webpackJsonp([153662236231701],{

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 483:
/***/ (function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(typeof navigator !== "undefined") && (function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return factory(root);
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	    "use strict";
	    var svgNS = "http://www.w3.org/2000/svg";
	
	var locationHref = '';
	
	var initialDefaultFrame = -999999;
	
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {};}
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = createSizedArray(val.length);
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	};
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = t;
	    this.totalLoops = c;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	var createElementID = (function(){
	    var _count = 0;
	    return function createID() {
	        return '__lottie_element_' + ++_count
	    }
	}())
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v; g = t; b = p; break;
	        case 1: r = q; g = v; b = p; break;
	        case 2: r = p; g = v; b = t; break;
	        case 3: r = p; g = q; b = v; break;
	        case 4: r = t; g = p; b = v; break;
	        case 5: r = v; g = p; b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	function BaseEvent(){}
	BaseEvent.prototype = {
		triggerEvent: function (eventName, args) {
		    if (this._cbs[eventName]) {
		        var len = this._cbs[eventName].length;
		        for (var i = 0; i < len; i++){
		            this._cbs[eventName][i](args);
		        }
		    }
		},
		addEventListener: function (eventName, callback) {
		    if (!this._cbs[eventName]){
		        this._cbs[eventName] = [];
		    }
		    this._cbs[eventName].push(callback);
	
			return function() {
				this.removeEventListener(eventName, callback);
			}.bind(this);
		},
		removeEventListener: function (eventName,callback){
		    if (!callback){
		        this._cbs[eventName] = null;
		    }else if(this._cbs[eventName]){
		        var i = 0, len = this._cbs[eventName].length;
		        while(i<len){
		            if(this._cbs[eventName][i] === callback){
		                this._cbs[eventName].splice(i,1);
		                i -=1;
		                len -= 1;
		            }
		            i += 1;
		        }
		        if(!this._cbs[eventName].length){
		            this._cbs[eventName] = null;
		        }
		    }
		}
	};
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray;
		} else {
			return createRegularArray;
		}
	}());
	
	function createSizedArray(len) {
		return Array.apply(null,{length:len});
	}
	function createNS(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElementNS(svgNS, type);
	}
	function createTag(type) {
		//return {appendChild:function(){},setAttribute:function(){},style:{}}
		return document.createElement(type);
	}
	function DynamicPropertyContainer(){};
	DynamicPropertyContainer.prototype = {
		addDynamicProperty: function(prop) {
			if(this.dynamicProperties.indexOf(prop) === -1) {
		        this.dynamicProperties.push(prop);
		        this.container.addDynamicProperty(this);
		    	this._isAnimated = true;
		    }
		},
		iterateDynamicProperties: function(){
		    this._mdf = false;
		    var i, len = this.dynamicProperties.length;
		    for(i=0;i<len;i+=1){
		        this.dynamicProperties[i].getValue();
		        if(this.dynamicProperties[i]._mdf) {
		            this._mdf = true;
		        }
		    }
		},
		initDynamicPropertyContainer: function(container){
		    this.container = container;
		    this.dynamicProperties = [];
		    this._mdf = false;
		    this._isAnimated = false;
		}
	}
	var getBlendMode = (function() {
	
		var blendModeEnums = {
	        1:'multiply',
	        2:'screen',
	        3:'overlay',
	        4:'darken',
	        5:'lighten',
	        6:'color-dodge',
	        7:'color-burn',
	        8:'hard-light',
	        9:'soft-light',
	        10:'difference',
	        11:'exclusion',
	        12:'hue',
	        13:'saturation',
	        14:'color',
	        15:'luminosity'
	    }
	
		return function(mode) {
			return blendModeEnums[mode] || '';
		}
	}())
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0, 0, 1, 0, 0, -mSin,  0,  mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0, -mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(1, 0,  0, 0, _tan(ax),  1, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0, mSin,  mCos, 0, 0, 0,  0,  1, 0, 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        if(!sz && sz !== 0) {
	            sz = 1;
	        }
	        if(sx === 1 && sy === 1 && sz === 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        var _p = this.props;
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            //NOTE: commenting this condition because TurboFan deoptimizes code when present
	            //if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	                _p[12] = _p[12] * a2 + _p[15] * m2;
	                _p[13] = _p[13] * f2 + _p[15] * n2;
	                _p[14] = _p[14] * k2 + _p[15] * o2;
	                _p[15] = _p[15] * p2;
	            //}
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = _p[0];
	        var b1 = _p[1];
	        var c1 = _p[2];
	        var d1 = _p[3];
	        var e1 = _p[4];
	        var f1 = _p[5];
	        var g1 = _p[6];
	        var h1 = _p[7];
	        var i1 = _p[8];
	        var j1 = _p[9];
	        var k1 = _p[10];
	        var l1 = _p[11];
	        var m1 = _p[12];
	        var n1 = _p[13];
	        var o1 = _p[14];
	        var p1 = _p[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function equals(matr){
	        var i = 0;
	        while (i < 16) {
	            if(matr.props[i] !== this.props[i]) {
	                return false;
	            }
	            i+=1;
	        }
	        return true;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToTriplePoints(pt1, pt2, pt3) {
	        var arr = createTypedArray('float32', 6);
	        if(this.isIdentity()) {
	            arr[0] = pt1[0];
	            arr[1] = pt1[1];
	            arr[2] = pt2[0];
	            arr[3] = pt2[1];
	            arr[4] = pt3[0];
	            arr[5] = pt3[1];
	        } else {
	            var p0 = this.props[0], p1 = this.props[1], p4 = this.props[4], p5 = this.props[5], p12 = this.props[12], p13 = this.props[13];
	            arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	            arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	            arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	            arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	            arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	            arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	        }
	        return arr;
	    }
	
	    function applyToPointArray(x,y,z){
	        var arr;
	        if(this.isIdentity()) {
	            arr = [x,y,z];
	        } else {
	            arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	        }
	        return arr;
	    }
	
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        var _p = this.props;
	        return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100+','+ Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }
	
	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v;
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }
	
	    function roundMatrixProperty(val) {
	        var v = 10000;
	        if((val < 0.000001 && val > 0) || (val > -0.000001 && val < 0)) {
	            return _rnd(val * v) / v;
	        }
	        return val;
	    }
	
	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var props = this.props;
	        var _a = roundMatrixProperty(props[0]);
	        var _b = roundMatrixProperty(props[1]);
	        var _c = roundMatrixProperty(props[4]);
	        var _d = roundMatrixProperty(props[5]);
	        var _e = roundMatrixProperty(props[12]);
	        var _f = roundMatrixProperty(props[13]);
	        return "matrix(" + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ")";
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToTriplePoints = applyToTriplePoints;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.equals = equals;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    };
	}());
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options === true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed === null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; };
	        prng.quick = function() { return arc4.g(4) / 0x100000000; };
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); };
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        };
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    }
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date(), global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	
	function extendPrototype(sources,destination){
	    var i, len = sources.length, sourcePrototype;
	    for (i = 0;i < len;i += 1) {
	        sourcePrototype = sources[i].prototype;
	        for (var attr in sourcePrototype) {
	            if (sourcePrototype.hasOwnProperty(attr)) destination.prototype[attr] = sourcePrototype[attr];
	        }
	    }
	}
	
	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}
	
	function createProxyFunction(prototype) {
		function ProxyFunction(){}
		ProxyFunction.prototype = prototype;
		return ProxyFunction;
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.001 && det1 < 0.001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    var getBezierLength = (function(){
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = bezier_length_pool.newElement();
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.percents[k] = perc;
	                lengthData.lengths[k] = addedLength;
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function getSegmentsLength(shapeData) {
	        var segmentsLength = segments_length_pool.newElement();
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = segmentsLength.lengths;
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed && len){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        segmentsLength.totalLength = totalLength;
	        return segmentsLength;
	    }
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	            var curveSegments = defaultCurveSegments;
	            var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if (pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for (k = 0; k < curveSegments; k += 1) {
	                point = createSizedArray(len);
	                perc = k / (curveSegments - 1);
	                ptDistance = 0;
	                for (i = 0; i < len; i += 1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	                ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance, point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	        };
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var percents = bezierData.percents;
	        var lengths = bezierData.lengths;
	        var len = percents.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]){
	            return percents[initPos];
	        }else{
	            var dir = lengths[initPos] > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(lengths[initPos] <= lengthPos && lengths[initPos+1] > lengthPos){
	                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos+1] - lengths[initPos]);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    //FIX for TypedArrays that don't store floating point values with enough accuracy
	                    if(initPos === len - 1) {
	                        return percents[initPos];
	                    }
	                    flag = false;
	                }
	            }
	            return percents[initPos] + (percents[initPos+1] - percents[initPos])*lPerc;
	        }
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u0 = 1;
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }
	
	    function getSegmentArray() {
	
	    }
	
	    var bezier_segment_points = createTypedArray('float32', 8);
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        var u0u0u0 = u0*u0*u0;
	        var t0u0u0_3 = t0*u0*u0*3;
	        var t0t0u0_3 = t0*t0*u0*3;
	        var t0t0t0 = t0*t0*t0;
	        //
	        var u0u0u1 = u0*u0*u1;
	        var t0u0u1_3 = t0*u0*u1 + u0*t0*u1 + u0*u0*t1;
	        var t0t0u1_3 = t0*t0*u1 + u0*t0*t1 + t0*u0*t1;
	        var t0t0t1 = t0*t0*t1;
	        //
	        var u0u1u1 = u0*u1*u1;
	        var t0u1u1_3 = t0*u1*u1 + u0*t1*u1 + u0*u1*t1;
	        var t0t1u1_3 = t0*t1*u1 + u0*t1*t1 + t0*u1*t1;
	        var t0t1t1 = t0*t1*t1;
	        //
	        var u1u1u1 = u1*u1*u1;
	        var t1u1u1_3 = t1*u1*u1 + u1*t1*u1 + u1*u1*t1;
	        var t1t1u1_3 = t1*t1*u1 + u1*t1*t1 + t1*u1*t1;
	        var t1t1t1 = t1*t1*t1;
	        for(i=0;i<len;i+=1){
	            bezier_segment_points[i * 4] = Math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 1] = Math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 2] = Math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000;
	            bezier_segment_points[i * 4 + 3] = Math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000;
	        }
	
	        return bezier_segment_points;
	    }
	
	    return {
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = createTag('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            };
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        };
	    }());
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    };
	    var combinedCharacters = [];
	    //Hindi characters
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366
	    , 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379
	    , 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	
	    function setUpNode(font, family){
	        var parentNode = createTag('span');
	        parentNode.style.fontFamily    = family;
	        var node = createTag('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(this.checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.isLoaded = true;}.bind(this),0);
	
	        }
	    }
	
	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        //tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontData.fStyle);
	        tHelper.setAttribute('font-weight', fontData.fWeight);
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = createTag('canvas').getContext('2d');
	        tCanvasHelper.font = fontData.fWeight + ' ' + fontData.fStyle + ' 100px '+ fontData.fFamily;
	        //tCanvasHelper.font = ' 100px '+ fontData.fFamily;
	        return tHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.isLoaded = true;
	            return;
	        }
	        if(this.chars){
	            this.isLoaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        var _pendingFonts = len;
	        for(i=0; i<len; i+= 1){
	            var shouldLoadFont = true;
	            var loadedSelector;
	            var j;
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	                _pendingFonts -= 1;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="'+ fontArr[i].fFamily +'"], style[f-origin="3"][f-family="'+ fontArr[i].fFamily +'"]');
	
	                if (loadedSelector.length > 0) {
	                    shouldLoadFont = false;
	                }
	
	                if (shouldLoadFont) {
	                    var s = createTag('style');
	                    s.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    s.setAttribute('f-origin', fontArr[i].origin);
	                    s.setAttribute('f-family', fontArr[i].fFamily);
	                    s.type = "text/css";
	                    s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                    defs.appendChild(s);
	                }
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
	
	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }
	
	                if (shouldLoadFont) {
	                    var l = createTag('link');
	                    l.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    l.setAttribute('f-origin', fontArr[i].origin);
	                    l.type = "text/css";
	                    l.rel = "stylesheet";
	                    l.href = fontArr[i].fPath;
	                    document.body.appendChild(l);
	                }
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
	
	                for (j = 0; j < loadedSelector.length; j++) {
	                    if (fontArr[i].fPath === loadedSelector[j].src) {
	                        // Font is already loaded
	                        shouldLoadFont = false;
	                    }
	                }
	
	                if (shouldLoadFont) {
	                    var sc = createTag('link');
	                    sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	                    sc.setAttribute('f-origin', fontArr[i].origin);
	                    sc.setAttribute('rel','stylesheet');
	                    sc.setAttribute('href',fontArr[i].fPath);
	                    defs.appendChild(sc);
	                }
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            fontArr[i].cache = {};
	            this.fonts.push(fontArr[i]);
	        }
	        if (_pendingFonts === 0) {
	            this.isLoaded = true;
	        } else {
	            //On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	            //Adding this timeout seems to fix it
	           setTimeout(this.checkLoadedFonts.bind(this), 100);
	        }
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if(console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }
	
	    function measureText(char, fontName, size) {
	        var fontData = this.getFontByName(fontName);
	        var index = char.charCodeAt(0);
	        if(!fontData.cache[index + 1]) {
	            var tHelper = fontData.helper;
	            //Canvas version
	            //fontData.cache[index] = tHelper.measureText(char).width / 100;
	            //SVG version
	            //console.log(tHelper.getBBox().width)
	            if (char === ' ') {
	                tHelper.textContent = '|' + char + '|';
	                var doubleSize = tHelper.getComputedTextLength();
	                tHelper.textContent = '||';
	                var singleSize = tHelper.getComputedTextLength();
	                fontData.cache[index + 1] = (doubleSize - singleSize)/100;
	            } else {
	                tHelper.textContent = char;
	                fontData.cache[index + 1] = (tHelper.getComputedTextLength())/100;
	            }
	        }
	        return fontData.cache[index + 1] * size;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return this.fonts[0];
	    }
	
	    function getCombinedCharacterCodes() {
	        return combinedCharacters;
	    }
	
	    function loaded() {
	        return this.isLoaded;
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.isLoaded = false;
	        this.initTime = Date.now();
	    };
	    //TODO: for now I'm adding these methods to the Class and not the prototype. Think of a better way to implement it. 
	    Font.getCombinedCharacterCodes = getCombinedCharacterCodes;
	
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	    Font.prototype.checkLoadedFonts = checkLoadedFonts;
	    Font.prototype.loaded = loaded;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = initialDefaultFrame;
	    var math_abs = Math.abs;
	
	    function interpolateValue(frameNum, caching) {
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if (this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', this.pv.length);
	        }
	        var iterationIndex = caching.lastIndex;
	        var i = iterationIndex;
	        var len = this.keyframes.length - 1, flag = true;
	        var keyData, nextKeyData;
	
	        while (flag) {
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i + 1];
	            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if ((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if (i < len - 1){
	                i += 1;
	            } else {
	                iterationIndex = 0;
	                flag = false;
	            }
	        }
	
	        var k, kLen, perc, jLen, j, fnc;
	        var nextKeyTime = nextKeyData.t - offsetTime;
	        var keyTime = keyData.t - offsetTime;
	        if (keyData.to) {
	            if (!keyData.bezierData) {
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if (frameNum >= nextKeyTime || frameNum < keyTime) {
	                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for (k = 0; k < kLen; k += 1) {
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                // caching._lastBezierData = null;
	            } else {
	                if (keyData.__fnct) {
	                    fnc = keyData.__fnct;
	                } else {
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	                var distanceInLine = bezierData.segmentLength*perc;
	
	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while (flag) {
	                    addedLength += bezierData.points[j].partialLength;
	                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	                        kLen = bezierData.points[j].point.length;
	                        for (k = 0; k < kLen; k += 1) {
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	                        }
	                        break;
	                    }
	                    if (j < jLen - 1){
	                        j += 1;
	                    } else {
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastBezierData = bezierData;
	            }
	        } else {
	            var outX, outY, inX, inY, keyValue;
	            len = keyData.s.length;
	            if (this.sh && keyData.h !== 1) {
	                if (frameNum >= nextKeyTime) {
	                    newValue[0] = keyData.e[0];
	                    newValue[1] = keyData.e[1];
	                    newValue[2] = keyData.e[2];
	                } else if (frameNum <= keyTime) {
	                    newValue[0] = keyData.s[0];
	                    newValue[1] = keyData.s[1];
	                    newValue[2] = keyData.s[2];
	                } else {
	                    var quatStart = createQuaternion(keyData.s);
	                    var quatEnd = createQuaternion(keyData.e);
	                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	                }
	                
	            } else {
	                for(i = 0; i < len; i += 1) {
	                    if (keyData.h !== 1) {
	                        if (frameNum >= nextKeyTime) {
	                            perc = 1;
	                        } else if(frameNum < keyTime) {
	                            perc = 0;
	                        } else {
	                            if(keyData.o.x.constructor === Array) {
	                                if (!keyData.__fnct) {
	                                    keyData.__fnct = [];
	                                }
	                                if (!keyData.__fnct[i]) {
	                                    outX = (typeof keyData.o.x[i] === undefined) ? keyData.o.x[0] : keyData.o.x[i];
	                                    outY = (typeof keyData.o.y[i] === undefined) ? keyData.o.y[0] : keyData.o.y[i];
	                                    inX = (typeof keyData.i.x[i] === undefined) ? keyData.i.x[0] : keyData.i.x[i];
	                                    inY = (typeof keyData.i.y[i] === undefined) ? keyData.i.y[0] : keyData.i.y[i];
	 
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct[i] = fnc;
	                                } else {
	                                    fnc = keyData.__fnct[i];
	                                }
	                            } else {
	                                if (!keyData.__fnct) {
	                                    outX = keyData.o.x;
	                                    outY = keyData.o.y;
	                                    inX = keyData.i.x;
	                                    inY = keyData.i.y;
	                                    fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                                    keyData.__fnct = fnc;
	                                } else {
	                                    fnc = keyData.__fnct;
	                                }
	                            }
	                            perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime ));
	                        }
	                    }
	
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (keyData.e[i] - keyData.s[i]) * perc;
	
	                    if (len === 1) {
	                        newValue = keyValue;
	                    } else {
	                        newValue[i] = keyValue;
	                    }
	                }
	            }
	        }
	        caching.lastIndex = iterationIndex;
	        return newValue;
	    }
	
	    //based on @Toji's https://github.com/toji/gl-matrix/
	    function slerp(a, b, t) {
	        var out = [];
	        var ax = a[0], ay = a[1], az = a[2], aw = a[3],
	        bx = b[0], by = b[1], bz = b[2], bw = b[3]
	
	        var omega, cosom, sinom, scale0, scale1;
	
	        cosom = ax * bx + ay * by + az * bz + aw * bw;
	        if (cosom < 0.0) {
	            cosom = -cosom;
	            bx = -bx;
	            by = -by;
	            bz = -bz;
	            bw = -bw;
	        }
	        if ((1.0 - cosom) > 0.000001) {
	            omega = Math.acos(cosom);
	            sinom = Math.sin(omega);
	            scale0 = Math.sin((1.0 - t) * omega) / sinom;
	            scale1 = Math.sin(t * omega) / sinom;
	        } else {
	            scale0 = 1.0 - t;
	            scale1 = t;
	        }
	        out[0] = scale0 * ax + scale1 * bx;
	        out[1] = scale0 * ay + scale1 * by;
	        out[2] = scale0 * az + scale1 * bz;
	        out[3] = scale0 * aw + scale1 * bw;
	
	        return out;
	    }
	
	    function quaternionToEuler(out, quat) {
	        var qx = quat[0];
	        var qy = quat[1];
	        var qz = quat[2];
	        var qw = quat[3];
	        var heading = Math.atan2(2*qy*qw-2*qx*qz , 1 - 2*qy*qy - 2*qz*qz)
	        var attitude = Math.asin(2*qx*qy + 2*qz*qw) 
	        var bank = Math.atan2(2*qx*qw-2*qy*qz , 1 - 2*qx*qx - 2*qz*qz);
	        out[0] = heading/degToRads;
	        out[1] = attitude/degToRads;
	        out[2] = bank/degToRads;
	    }
	
	    function createQuaternion(values) {
	        var heading = values[0] * degToRads;
	        var attitude = values[1] * degToRads;
	        var bank = values[2] * degToRads;
	        var c1 = Math.cos(heading / 2);
	        var c2 = Math.cos(attitude / 2);
	        var c3 = Math.cos(bank / 2);
	        var s1 = Math.sin(heading / 2);
	        var s2 = Math.sin(attitude / 2);
	        var s3 = Math.sin(bank / 2);
	        var w = c1 * c2 * c3 - s1 * s2 * s3;
	        var x = s1 * s2 * c3 + c1 * c2 * s3;
	        var y = s1 * c2 * c3 + c1 * s2 * s3;
	        var z = c1 * s2 * c3 - s1 * c2 * s3;
	
	        return [x,y,z,w];
	    }
	
	    function getValueAtCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            if(this._caching.lastFrame >= frameNum) {
	                this._caching._lastBezierData = null;
	                this._caching.lastIndex = 0;
	            }
	
	            var renderResult = this.interpolateValue(frameNum, this._caching);
	            this.pv = renderResult;
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function setVValue(val) {
	        var multipliedValue;
	        if(this.propType === 'unidimensional') {
	            multipliedValue = val * this.mult;
	            if(math_abs(this.v - multipliedValue) > 0.00001) {
	                this.v = multipliedValue;
	                this._mdf = true;
	            }
	        } else {
	            var i = 0, len = this.v.length;
	            while (i < len) {
	                multipliedValue = val[i] * this.mult;
	                if (math_abs(this.v[i] - multipliedValue) > 0.00001) {
	                    this.v[i] = multipliedValue;
	                    this._mdf = true;
	                }
	                i += 1;
	            }
	        }
	    }
	
	    function processEffectsSequence() {
	        if(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }        
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = this._isFirstFrame;
	        var multipliedValue;
	        var i, len = this.effectsSequence.length;
	        var finalValue = this.kf ? this.pv : this.data.k;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this._isFirstFrame = false;
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    function ValueProperty(elem, data, mult, container){
	        this.propType = 'unidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.effectsSequence = [];
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function MultiDimensionalProperty(elem, data, mult, container) {
	        this.propType = 'multidimensional';
	        this.mult = mult || 1;
	        this.data = data;
	        this._mdf = false;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        var i, len = data.k.length;
	        this.v = createTypedArray('float32', len);
	        this.pv = createTypedArray('float32', len);
	        var arr = createTypedArray('float32', len);
	        this.vel = createTypedArray('float32', len);
	        for (i = 0; i < len; i += 1) {
	            this.v[i] = data.k[i] * this.mult;
	            this.pv[i] = data.k[i];
	        }
	        this._isFirstFrame = true;
	        this.effectsSequence = [];
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedValueProperty(elem, data, mult, container) {
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.frameId = -1;
	        this._caching = {lastFrame: initFrame, lastIndex: 0, value: 0, _lastBezierData: null};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.v = initFrame;
	        this.pv = initFrame;
	        this._isFirstFrame = true;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.addEffect = addEffect;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult, container){
	        this.propType = 'multidimensional';
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for (i = 0; i < len - 1; i += 1) {
	            if (data.k[i].to && data.k[i].s && data.k[i].e) {
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	                if(s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	                    if(s.length === 2 || (s[2] === e[2] && to[2] === 0 && ti[2] === 0)) {
	                        data.k[i].to = null;
	                        data.k[i].ti = null;
	                    }
	                }
	            }
	        }
	        this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this._isFirstFrame = true;
	        this.mult = mult || 1;
	        this.elem = elem;
	        this.container = container;
	        this.comp = elem.comp;
	        this.getValue = processEffectsSequence;
	        this.setVValue = setVValue;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        for (i = 0; i < arrLen; i += 1) {
	            this.v[i] = initFrame;
	            this.pv[i] = initFrame;
	        }
	        this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32', arrLen)};
	        this.addEffect = addEffect;
	    }
	
	    function getProp(elem,data,type, mult, container) {
	        var p;
	        if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult, container);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult, container);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult, container);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult, container);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult, container);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult, container);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult, container);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult, container);
	                    break;
	            }
	        }
	        if(p.effectsSequence.length){
	            container.addDynamicProperty(p);
	        }
	        return p;
	    }
	
	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {
	
	    function applyToMatrix(mat) {
	        var _mdf = this._mdf;
	        this.iterateDynamicProperties();
	        this._mdf = this._mdf || _mdf;
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.sk) {
	            mat.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(forceRender){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	        if(this._isDirty) {
	            this.precalculateMatrix();
	            this._isDirty = false;
	        }
	
	        this.iterateDynamicProperties();
	
	        if (this._mdf || forceRender) {
	            this.v.cloneFromProps(this.pre.props);
	            if (this.appliedTransformations < 1) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.appliedTransformations < 2) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk && this.appliedTransformations < 3) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r && this.appliedTransformations < 4) {
	                this.v.rotate(-this.r.v);
	            } else if (!this.r && this.appliedTransformations < 4){
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented) {
	                var v1,v2, frameRate = this.elem.globalData.frameRate;
	                if(this.p && this.p.keyframes && this.p.getValueAtTime) {
	                    if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate,0);
	                        v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	                    } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                        v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / frameRate), 0);
	                        v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / frameRate, 0);
	                    } else {
	                        v1 = this.p.pv;
	                        v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	                    }
	                } else if(this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	                    v1 = [];
	                    v2 = [];
	                    var px = this.px, py = this.py, frameRate;
	                    if (px._caching.lastFrame+px.offsetTime <= px.keyframes[0].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate,0);
	                        v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate,0);
	                        v2[0] = px.getValueAtTime((px.keyframes[0].t) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[0].t) / frameRate,0);
	                    } else if(px._caching.lastFrame+px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	                        v1[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t / frameRate),0);
	                        v1[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t / frameRate),0);
	                        v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate,0);
	                        v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate,0);
	                    } else {
	                        v1 = [px.pv, py.pv];
	                        v2[0] = px.getValueAtTime((px._caching.lastFrame+px.offsetTime - 0.01) / frameRate,px.offsetTime);
	                        v2[1] = py.getValueAtTime((py._caching.lastFrame+py.offsetTime - 0.01) / frameRate,py.offsetTime);
	                    }
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function precalculateMatrix() {
	        if(!this.a.k) {
	            this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            this.appliedTransformations = 1;
	        } else {
	            return;
	        }
	        if(!this.s.effectsSequence.length) {
	            this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            this.appliedTransformations = 2;
	        } else {
	            return;
	        }
	        if(this.sk) {
	            if(!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	                this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	            this.appliedTransformations = 3;
	            } else {
	                return;
	            }
	        }
	        if (this.r) {
	            if(!this.r.effectsSequence.length) {
	                this.pre.rotate(-this.r.v);
	                this.appliedTransformations = 4;
	            } else {
	                return;
	            }
	        } else if(!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	            this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            this.appliedTransformations = 4;
	        }
	    }
	
	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }
	
	    function addDynamicProperty(prop) {
	        this._addDynamicProperty(prop);
	        this.elem.addDynamicProperty(prop);
	        this._isDirty = true;
	    }
	
	    function TransformProperty(elem,data,container){
	        this.elem = elem;
	        this.frameId = -1;
	        this.propType = 'transform';
	        this.data = data;
	        this.v = new Matrix();
	        //Precalculated matrix with non animated properties
	        this.pre = new Matrix();
	        this.appliedTransformations = 0;
	        this.initDynamicPropertyContainer(container || elem);
	        if(data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this);
	            }
	        }else{
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	        }
	        if(data.r) {
	            this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        } else if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	        }
	        if(data.a) {
	            this.a = PropertyFactory.getProp(elem,data.a,1,0,this);
	        }
	        if(data.s) {
	            this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this);
	        }
	        // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,elem);
	        } else {
	            this.o = {_mdf:false,v:1};
	        }
	        this._isDirty = true;
	        if(!this.dynamicProperties.length){
	            this.getValue(true);
	        }
	    }
	
	    TransformProperty.prototype = {
	        applyToMatrix: applyToMatrix,
	        getValue: processKeys,
	        precalculateMatrix: precalculateMatrix,
	        autoOrient: autoOrient
	    }
	
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
	
	    function getTransformProperty(elem,data,container){
	        return new TransformProperty(elem,data,container);
	    }
	
	    return {
	        getTransformProperty: getTransformProperty
	    };
	
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = createSizedArray(this._maxLength);
		this.o = createSizedArray(this._maxLength);
		this.i = createSizedArray(this._maxLength);
	}
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newElement();
			this.o[i] = point_pool.newElement();
			this.i[i] = point_pool.newElement();
			i += 1;
		}
	};
	
	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	};
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(createSizedArray(this._maxLength));
		this.i = this.i.concat(createSizedArray(this._maxLength));
		this.o = this.o.concat(createSizedArray(this._maxLength));
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newElement();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	
	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;
	
	    var i;
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, previousValue, caching) {
	        var iterationIndex = caching.lastIndex;
	        var keyPropS,keyPropE,isHold, j, k, jLen, kLen, perc, vertexValue;
	        var kf = this.keyframes;
	        if(frameNum < kf[0].t-this.offsetTime){
	            keyPropS = kf[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= kf[kf.length - 1].t-this.offsetTime){
	            if(kf[kf.length - 2].h === 1){
	                keyPropS = kf[kf.length - 1].s[0];
	            }else{
	                keyPropS = kf[kf.length - 2].e[0];
	            }
	            isHold = true;
	        }else{
	            var i = iterationIndex;
	            var len = kf.length- 1,flag = true,keyData,nextKeyData;
	            while(flag){
	                keyData = kf[i];
	                nextKeyData = kf[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else{
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        caching.lastIndex = iterationIndex;
	
	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                vertexValue = isHold ? keyPropS.i[j][k] :  keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                previousValue.i[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.o[j][k] :  keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                previousValue.o[j][k] = vertexValue;
	                vertexValue = isHold ? keyPropS.v[j][k] :  keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                previousValue.v[j][k] = vertexValue;
	            }
	        }
	    }
	
	    function interpolateShapeCurrentTime(){
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        var lastFrame = this._caching.lastFrame;
	        if(!(lastFrame !== initFrame && ((lastFrame < initTime && frameNum < initTime) || (lastFrame > endTime && frameNum > endTime)))){
	            ////
	            this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	            this.interpolateShape(frameNum, this.pv, this._caching);
	            ////
	        }
	        this._caching.lastFrame = frameNum;
	        return this.pv;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] 
	            || shape1.v[i][1] !== shape2.v[i][1] 
	            || shape1.o[i][0] !== shape2.o[i][0] 
	            || shape1.o[i][1] !== shape2.o[i][1] 
	            || shape1.i[i][0] !== shape2.i[i][0] 
	            || shape1.i[i][1] !== shape2.i[i][1]) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function setVValue(newPath) {
	        if(!shapesEqual(this.v, newPath)) {
	            this.v = shape_pool.clone(newPath);
	            this.localShapeCollection.releaseShapes();
	            this.localShapeCollection.addShape(this.v);
	            this._mdf = true;
	            this.paths = this.localShapeCollection;
	        }
	    }
	
	    function processEffectsSequence() {
	        if(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	            return;
	        }
	        if(this.lock) {
	            this.setVValue(this.pv);
	            return;
	        }
	        this.lock = true;
	        this._mdf = false;
	        var finalValue = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
	        var i, len = this.effectsSequence.length;
	        for(i = 0; i < len; i += 1) {
	            finalValue = this.effectsSequence[i](finalValue);
	        }
	        this.setVValue(finalValue);
	        this.lock = false;
	        this.frameId = this.elem.globalData.frameId;
	    };
	
	    function ShapeProperty(elem, data, type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.container = elem;
	        this.elem = elem;
	        this.data = data;
	        this.k = false;
	        this.kf = false;
	        this._mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	        this.effectsSequence = [];
	    }
	
	    function addEffect(effectFunction) {
	        this.effectsSequence.push(effectFunction);
	        this.container.addDynamicProperty(this);
	    }
	
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.propType = 'shape';
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.container = elem;
	        this.offsetTime = elem.data.st;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newElement();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	        this._caching = {lastFrame: initFrame, lastIndex: 0};
	        this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: createSizedArray(4),
	                i: createSizedArray(4),
	                o: createSizedArray(4),
	                c: true
	            };*/
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertEllToPath();
	            }
	        };
	
	        EllShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function (){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	
	                if(this._mdf){
	                    this.convertEllToPath();
	                }
	            },
	            convertEllToPath: function() {
	                var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	                var _cw = this.d !== 3;
	                var _v = this.v;
	                _v.v[0][0] = p0;
	                _v.v[0][1] = p1 - s1;
	                _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.v[1][1] = p1;
	                _v.v[2][0] = p0;
	                _v.v[2][1] = p1 + s1;
	                _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.v[3][1] = p1;
	                _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.i[0][1] = p1 - s1;
	                _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.i[1][1] = p1 - s1 * cPoint;
	                _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.i[2][1] = p1 + s1;
	                _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.i[3][1] = p1 + s1 * cPoint;
	                _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	                _v.o[0][1] = p1 - s1;
	                _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	                _v.o[1][1] = p1 + s1 * cPoint;
	                _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	                _v.o[2][1] = p1 + s1;
	                _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	                _v.o[3][1] = p1 - s1 * cPoint;
	            }
	        }
	
	        extendPrototype([DynamicPropertyContainer], EllShapeProperty);
	
	        return EllShapeProperty;
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function StarShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this);
	                this.convertToPath = this.convertStarToPath;
	            } else {
	                this.convertToPath = this.convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertToPath();
	            }
	        };
	
	        StarShapeProperty.prototype = {
	            reset: resetShape,
	            getValue: function() {
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertToPath();
	                }
	            },
	            convertStarToPath: function() {
	                var numPts = Math.floor(this.pt.v)*2;
	                var angle = Math.PI*2/numPts;
	                /*this.v.v.length = numPts;
	                this.v.i.length = numPts;
	                this.v.o.length = numPts;*/
	                var longFlag = true;
	                var longRad = this.or.v;
	                var shortRad = this.ir.v;
	                var longRound = this.os.v;
	                var shortRound = this.is.v;
	                var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	                var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	                var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	                currentAng += this.r.v;
	                var dir = this.data.d === 3 ? -1 : 1;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    rad = longFlag ? longRad : shortRad;
	                    roundness = longFlag ? longRound : shortRound;
	                    perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                    /*this.v.v[i] = [x,y];
	                    this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                    this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                    this.v._length = numPts;*/
	                    longFlag = !longFlag;
	                    currentAng += angle*dir;
	                }
	            },
	            convertPolygonToPath: function() {
	                var numPts = Math.floor(this.pt.v);
	                var angle = Math.PI*2/numPts;
	                var rad = this.or.v;
	                var roundness = this.os.v;
	                var perimSegment = 2*Math.PI*rad/(numPts*4);
	                var i, currentAng = -Math.PI/ 2;
	                var dir = this.data.d === 3 ? -1 : 1;
	                currentAng += this.r.v;
	                this.v._length = 0;
	                for(i=0;i<numPts;i+=1){
	                    var x = rad * Math.cos(currentAng);
	                    var y = rad * Math.sin(currentAng);
	                    var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                    var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                    x +=  + this.p.v[0];
	                    y +=  + this.p.v[1];
	                    this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                    currentAng += angle*dir;
	                }
	                this.paths.length = 0;
	                this.paths[0] = this.v;
	            }
	
	        }
	        extendPrototype([DynamicPropertyContainer], StarShapeProperty);
	
	        return StarShapeProperty;
	    }());
	
	    var RectShapeProperty = (function() {
	
	         function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newElement();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.initDynamicPropertyContainer(elem);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.k = false;
	                this.convertRectToPath();
	            }
	        };
	
	        RectShapeProperty.prototype = {
	            convertRectToPath: function (){
	                var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	                var round = bm_min(v0,v1,this.r.v);
	                var cPoint = round*(1-roundCorner);
	                this.v._length = 0;
	
	                if(this.d === 2 || this.d === 1) {
	                    this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                    this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                    }
	                }else{
	                    this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                    if(round!== 0){
	                        this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                        this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                        this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                        this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                        this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                        this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                    } else {
	                        this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                        this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                        this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                    }
	                }
	            },
	            getValue: function(frameNum){
	                if(this.elem.globalData.frameId === this.frameId){
	                    return;
	                }
	                this.frameId = this.elem.globalData.frameId;
	                this.iterateDynamicProperties();
	                if(this._mdf){
	                    this.convertRectToPath();
	                }
	
	            },
	            reset: resetShape
	        }
	        extendPrototype([DynamicPropertyContainer], RectShapeProperty);
	
	        return RectShapeProperty;
	    }());
	
	    function getShapeProp(elem,data,type){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    }
	
	    function getConstructorFunction() {
	        return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data){
	        return new modifiers[nm](elem, data);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        var shapeData = {shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()};
	        this.shapes.push(shapeData);
	        this.addShapeToModifier(shapeData);
	        if(this._isAnimated) {
	            data.setAsAnimated();
	        }
	    }
	};
	ShapeModifier.prototype.init = function(elem,data){
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	ShapeModifier.prototype.processKeys = function(){
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	extendPrototype([DynamicPropertyContainer], ShapeModifier);
	function TrimModifier(){
	}
	extendPrototype([ShapeModifier], TrimModifier);
	TrimModifier.prototype.initModifierProperties = function(elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	};
	
	TrimModifier.prototype.addShapeToModifier = function(shapeData){
	    shapeData.pathsData = [];
	};
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	    if (e <= 1) {
	        segments.push({
	            s: s,
	            e: e
	        });
	    } else if (s >= 1) {
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        });
	    } else {
	        segments.push({
	            s: s,
	            e: 1
	        });
	        segments.push({
	            s: 0,
	            e: e - 1
	        });
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for (i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if (segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if (!shapeSegments.length) {
	        shapeSegments.push([0, 0]);
	    }
	    return shapeSegments;
	};
	
	TrimModifier.prototype.releasePathsData = function(pathsData) {
	    var i, len = pathsData.length;
	    for (i = 0; i < len; i += 1) {
	        segments_length_pool.release(pathsData[i]);
	    }
	    pathsData.length = 0;
	    return pathsData;
	};
	
	TrimModifier.prototype.processShapes = function(_isFirstFrame) {
	    var s, e;
	    if (this._mdf || _isFirstFrame) {
	        var o = (this.o.v % 360) / 360;
	        if (o < 0) {
	            o += 1;
	        }
	        s = (this.s.v > 1 ? 1 : this.s.v < 0 ? 0 : this.s.v) + o;
	        e = (this.e.v > 1 ? 1 : this.e.v < 0 ? 0 : this.e.v) + o;
	        if (s === e) {
	
	        }
	        if (s > e) {
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        s = Math.round(s * 10000) * 0.0001;
	        e = Math.round(e * 10000) * 0.0001;
	        this.sValue = s;
	        this.eValue = e;
	    } else {
	        s = this.sValue;
	        e = this.eValue;
	    }
	    var shapePaths;
	    var i, len = this.shapes.length, j, jLen;
	    var pathsData, pathData, totalShapeLength, totalModifierLength = 0;
	
	    if (e === s) {
	        for (i = 0; i < len; i += 1) {
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape._mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if (!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for (i = 0; i < len; i += 1) {
	            shapeData = this.shapes[i];
	            // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	            if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = this.releasePathsData(shapeData.pathsData);
	                    for (j = 0; j < jLen; j += 1) {
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape._mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0, edges;
	        for (i = len - 1; i >= 0; i -= 1) {
	            shapeData = this.shapes[i];
	            if (shapeData.shape._mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                //if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	                if (this.m === 2 && len > 1) {
	                    edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]];
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if (shapeE <= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        });
	                    } else if (shapeS >= 1) {
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    } else {
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        });
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        });
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        if (segments.length > 1) {
	                            var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
	                            if (lastShapeInCollection.c) {
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData, segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if (this._mdf) {
	        for (i = 0; i < len; i += 1) {
	            //Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	            //Don't remove this even if it's losing cached info.
	            this.shapes[i].pathsData.length = 0;
	            this.shapes[i].shape._mdf = true;
	        }
	    }
	};
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for (i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i]);
	    }
	};
	
	TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	    if(newShape){
	        shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	};
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if (!shapePath) {
	        shapePath = shape_pool.newElement();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for (i = 0; i < len; i += 1) {
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for (j = 1; j < jLen; j +=1) {
	            currentLengthData = lengths[j-1];
	            if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e) {
	                shapePath.c = false;
	                break;
	            } else {
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if (shapePaths[i].c && lengths.length) {
	            currentLengthData = lengths[j - 1];
	            if (addedLength <= shapeSegment.e) {
	                var segmentLength = lengths[j - 1].addedLength;
	                if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	                    this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	                    this.addSegmentFromArray(segment, shapePath, segmentCount, newShape);
	                    // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if (shapePath._length) {
	            shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1],'o', shapePath._length - 1);
	        }
	        if (addedLength > shapeSegment.e) {
	            break;
	        }
	        if (i < len - 1) {
	            shapePath = shape_pool.newElement();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	};
	
	
	ShapeModifiers.registerModifier('tm', TrimModifier);
	function RoundCornersModifier(){}
	extendPrototype([ShapeModifier],RoundCornersModifier);
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newElement();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	};
	
	RoundCornersModifier.prototype.processShapes = function(_isFirstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape._mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this._mdf = false;
	    }
	};
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){}
	extendPrototype([ShapeModifier], RepeaterModifier);
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this);
	    this.so = PropertyFactory.getProp(elem,data.tr.so,0,0.01,this);
	    this.eo = PropertyFactory.getProp(elem,data.tr.eo,0,0.01,this);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	};
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	    }else{
	        this.getValue(true);
	    }
	};
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	};
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	};
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	};
	
	RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
	    var items, itemsTransform, i, dir, cont;
	    if(this._mdf || _isFirstFrame){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                };
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":1,"ix":6,"k":[{s:0,e:0,t:0},{s:0,e:0,t:1}]},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        cont = 0;
	        var renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        var j, jLen;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            jLen = itemsTransform.length;
	            items[items.length - 1].transform.mProps._mdf = true;
	            items[items.length - 1].transform.op._mdf = true;
	            items[items.length - 1].transform.op.v = this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    } else {
	        cont = this._currentCopies;
	        i = 0;
	        dir = 1;
	        while(cont){
	            items = this.elemsData[i].it;
	            itemsTransform = items[items.length - 1].transform.mProps.v.props;
	            items[items.length - 1].transform.mProps._mdf = false;
	            items[items.length - 1].transform.op._mdf = false;
	            cont -= 1;
	            i += dir;
	        }
	    }
	};
	
	RepeaterModifier.prototype.addShape = function(){};
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = createSizedArray(this._maxLength);
	}
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32',  1);
	    this.initDynamicPropertyContainer(container);
	    var i, len = data.length || 0, prop;
	    for(i = 0; i < len; i += 1) {
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, this);
	        this.k = prop.k || this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(!this.k){
	        this.getValue(true);
	    }
	    this._isAnimated = this.k;
	}
	
	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	    if (this._mdf) {
	        var i = 0, len = this.dataProps.length;
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else{
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else{
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	};
	extendPrototype([DynamicPropertyContainer], DashProperty);
	function GradientProperty(elem,data,container){
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p*4);
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,this);
	    this.k = this.prop.k;
	    this.getValue(true);
	}
	
	GradientProperty.prototype.comparePoints = function(values, points) {
	    var i = 0, len = this.o.length/2, diff;
	    while(i < len) {
	        diff = Math.abs(values[i*4] - values[points*4 + i*2]);
	        if(diff > 0.01){
	            return false;
	        }
	        i += 1;
	    }
	    return true;
	};
	
	GradientProperty.prototype.checkCollapsable = function() {
	    if (this.o.length/2 !== this.c.length/4) {
	        return false;
	    }
	    if (this.data.k.k[0].s) {
	        var i = 0, len = this.data.k.k.length;
	        while (i < len) {
	            if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	                return false;
	            }
	            i += 1;
	        }
	    } else if(!this.comparePoints(this.data.k.k, this.data.p)) {
	        return false;
	    }
	    return true;
	};
	
	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	    if(this.prop._mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this._cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this._omdf = !forceRender;
	                }
	            }
	        }
	        this._mdf = !forceRender;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], GradientProperty);
	var buildShapeString = function(pathNodes, length, closed, mat) {
		if(length === 0) {
	            return '';
	        }
	        var _o = pathNodes.o;
	        var _i = pathNodes.i;
	        var _v = pathNodes.v;
	        var i, shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	        for(i = 1; i < length; i += 1) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	        }
	        if (closed && length) {
	            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	            shapeString += 'z';
	        }
	        return shapeString;
	}
	var ImagePreloader = (function(){
	
	    var proxyImage = (function(){
	        var canvas = createTag('canvas');
	        canvas.width = 1;
	        canvas.height = 1;
	        var ctx = canvas.getContext('2d');
	        ctx.fillStyle = '#FF0000';
	        ctx.fillRect(0, 0, 1, 1);
	        return canvas;
	    }())
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }
	
	    function getAssetsPath(assetData, assetsPath, original_path) {
	        var path = '';
	        if (assetData.e) {
	            path = assetData.p;
	        } else if(assetsPath) {
	            var imagePath = assetData.p;
	            if (imagePath.indexOf('images/') !== -1) {
	                imagePath = imagePath.split('/')[1];
	            }
	            path = assetsPath + imagePath;
	        } else {
	            path = original_path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function createImageData(assetData) {
	        var path = getAssetsPath(assetData, this.assetsPath, this.path);
	        var img = createTag('img');
	        img.crossOrigin = 'anonymous';
	        img.addEventListener('load', this._imageLoaded.bind(this), false);
	        img.addEventListener('error', function() {
	            ob.img = proxyImage;
	            this._imageLoaded();
	        }.bind(this), false);
	        img.src = path;
	        var ob = {
	            img: img,
	            assetData: assetData
	        }
	        return ob;
	    }
	
	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        var i, len = assets.length;
	        for (i = 0; i < len; i += 1) {
	            if(!assets[i].layers){
	                this.totalImages += 1;
	                this.images.push(this._createImageData(assets[i]));
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    function getImage(assetData) {
	        var i = 0, len = this.images.length;
	        while (i < len) {
	            if (this.images[i].assetData === assetData) {
	                return this.images[i].img;
	            }
	            i += 1;
	        }
	    }
	
	    function destroy() {
	        this.imagesLoadedCb = null;
	        this.images.length = 0;
	    }
	
	    function loaded() {
	        return this.totalImages === this.loadedAssets;
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.loaded = loaded;
	        this.destroy = destroy;
	        this.getImage = getImage;
	        this._createImageData = createImageData;
	        this._imageLoaded = imageLoaded;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	        this.images = [];
	    };
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		};
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}());
	var assetLoader = (function(){
	
		function formatResponse(xhr) {
			if(xhr.response && typeof xhr.response === 'object') {
				return xhr.response;
			} else if(xhr.response && typeof xhr.response === 'string') {
				return JSON.parse(xhr.response);
			} else if(xhr.responseText) {
				return JSON.parse(xhr.responseText);
			}
		}
	
		function loadAsset(path, callback, errorCallback) {
			var response;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', path, true);
			// set responseType after calling open or IE will break.
			xhr.responseType = "json";
		    xhr.send();
		    xhr.onreadystatechange = function () {
		        if (xhr.readyState == 4) {
		            if(xhr.status == 200){
		            	response = formatResponse(xhr);
		            	callback(response);
		            }else{
		                try{
		            		response = formatResponse(xhr);
		            		callback(response);
		                }catch(err){
		                	if(errorCallback) {
		                		errorCallback(err);
		                	}
		                }
		            }
		        }
		    };
		}
		return {
			load: loadAsset
		}
	}())
	
	function TextAnimatorProperty(textData, renderType, elem){
	    this._isFirstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._textData = textData;
		this._renderType = renderType;
	    this._elem = elem;
		this._animatorsData = createSizedArray(this._textData.a.length);
		this._pathData = {};
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	
	}
	
	TextAnimatorProperty.prototype.searchProperties = function(){
	    var i, len = this._textData.a.length, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this),
	            l: getProp(this._elem,this._textData.p.l,0,0,this),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this);
	};
	
	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	        return;
	    }
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l, pathInfo, currentLength, currentPoint, segmentLength, flag, pointInd, segmentInd, prevPoint, points, segments, partialLength, totalLength, perc, tanAngle, mask;
	    if(this._hasMaskedPath) {
	        mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData._mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	            pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var pathData;
	            totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        pathInfo = this._pathData.pi;
	
	        currentLength = this._pathData.f.v;
	        segmentInd = 0;
	        pointInd = 1;
	        segmentLength = 0;
	        flag = true;
	        segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        partialLength = currentPoint.partialLength;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;
	
	    jLen = animators.length;
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw, letterSc, letterFc, letterM = '', letterP = this.defaultPropsArray, letterO;
	
	    //
	    if(documentData.j === 2 || documentData.j === 1) {
	        var animatorJustifyOffset = 0;
	        var animatorFirstCharOffset = 0;
	        var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	        var lastIndex = 0;
	        var isNewLine = true;
	
	        for (i = 0; i < len; i += 1) {
	            if (letters[i].n) {
	                if(animatorJustifyOffset) {
	                    animatorJustifyOffset += animatorFirstCharOffset;
	                }
	                while (lastIndex < i) {
	                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	                    lastIndex += 1;
	                }
	                animatorJustifyOffset = 0;
	                isNewLine = true;
	            } else {
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.t.propType) {
	                        if (isNewLine && documentData.j === 2) {
	                            animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	                        }
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	                        if (mult.length) {
	                            animatorJustifyOffset += animatorProps.t.v*mult[0] * justifyOffsetMult;
	                        } else {
	                            animatorJustifyOffset += animatorProps.t.v*mult * justifyOffsetMult;
	                        }
	                    }
	                }
	                isNewLine = false;
	            }
	        }
	        if(animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	        }
	        while(lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	        }
	    }
	    //
	
	    for( i = 0; i < len; i += 1) {
	
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else{
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if (animatorProps.p.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if (animatorProps.a.propType) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.t.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    //This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	                    if(xPos !== 0 || documentData.j !== 0) {
	                        if(this._hasMaskedPath) {
	                            if(mult.length) {
	                                currentLength += animatorProps.t.v*mult[0];
	                            } else {
	                                currentLength += animatorProps.t.v*mult;
	                            }
	                        }else{
	                            if(mult.length) {
	                                xPos += animatorProps.t.v*mult[0];
	                            } else {
	                                xPos += animatorProps.t.v*mult;
	                            }
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.a.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if (animatorProps.s.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if (animatorProps.sk.propType) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if (animatorProps.r.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if (animatorProps.ry.propType) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if (animatorProps.rx.propType) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if (animatorProps.o.propType) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0];
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if(animatorProps.fc.propType){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if(animatorProps.fh.propType){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if(animatorProps.fs.propType){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if(animatorProps.fb.propType){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	
	                if (animatorProps.p.propType) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.finalSize;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.finalSize;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }
	
	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	};
	
	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	};
	
	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	function TextAnimatorDataProperty(elem, animatorProps, container) {
		var defaultData = {propType:false};
		var getProp = PropertyFactory.getProp;
		var textAnimator_animatables = animatorProps.a;
		this.a = {
			r: textAnimator_animatables.r ? getProp(elem, textAnimator_animatables.r, 0, degToRads, container) : defaultData,
			rx: textAnimator_animatables.rx ? getProp(elem, textAnimator_animatables.rx, 0, degToRads, container) : defaultData,
			ry: textAnimator_animatables.ry ? getProp(elem, textAnimator_animatables.ry, 0, degToRads, container) : defaultData,
			sk: textAnimator_animatables.sk ? getProp(elem, textAnimator_animatables.sk, 0, degToRads, container) : defaultData,
			sa: textAnimator_animatables.sa ? getProp(elem, textAnimator_animatables.sa, 0, degToRads, container) : defaultData,
			s: textAnimator_animatables.s ? getProp(elem, textAnimator_animatables.s, 1, 0.01, container) : defaultData,
			a: textAnimator_animatables.a ? getProp(elem, textAnimator_animatables.a, 1, 0, container) : defaultData,
			o: textAnimator_animatables.o ? getProp(elem, textAnimator_animatables.o, 0, 0.01, container) : defaultData,
			p: textAnimator_animatables.p ? getProp(elem,textAnimator_animatables.p, 1, 0, container) : defaultData,
			sw: textAnimator_animatables.sw ? getProp(elem, textAnimator_animatables.sw, 0, 0, container) : defaultData,
			sc: textAnimator_animatables.sc ? getProp(elem, textAnimator_animatables.sc, 1, 0, container) : defaultData,
			fc: textAnimator_animatables.fc ? getProp(elem, textAnimator_animatables.fc, 1, 0, container) : defaultData,
			fh: textAnimator_animatables.fh ? getProp(elem, textAnimator_animatables.fh, 0, 0, container) : defaultData,
			fs: textAnimator_animatables.fs ? getProp(elem, textAnimator_animatables.fs, 0, 0.01, container) : defaultData,
			fb: textAnimator_animatables.fb ? getProp(elem, textAnimator_animatables.fb, 0, 0.01, container) : defaultData,
			t: textAnimator_animatables.t ? getProp(elem, textAnimator_animatables.t, 0, 0, container) : defaultData
		};
	
		this.s = TextSelectorProp.getTextSelectorProp(elem,animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	}
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}
	
	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this._mdf.o = false;
		this._mdf.sw = false;
		this._mdf.sc = false;
		this._mdf.fc = false;
		this._mdf.m = false;
		this._mdf.p = false;
		var updated = false;
	
		if(this.o !== o) {
			this.o = o;
			this._mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this._mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this._mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this._mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this._mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this._mdf.p = true;
			updated = true;
		}
		return updated;
	};
	function TextProperty(elem, data){
		this._frameId = initialDefaultFrame;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this._isFirstFrame = true;
		this._mdf = false;
	    this.data = data;
		this.elem = elem;
	    this.comp = this.elem.comp;
		this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
		this.currentData = {
			ascent: 0,
	        boxWidth: this.defaultBoxWidth,
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:null,
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        finalSize:0,
	        finalText:[],
	        finalLineHeight: 0,
	        __complete: false
	
		};
	    this.copyData(this.currentData, this.data.d.k[0].s);
	
	    if(!this.searchProperty()) {
	        this.completeTextData(this.currentData);
	    }
	}
	
	TextProperty.prototype.defaultBoxWidth = [0,0];
	
	TextProperty.prototype.copyData = function(obj, data) {
	    for(var s in data) {
	        if(data.hasOwnProperty(s)) {
	            obj[s] = data[s];
	        }
	    }
	    return obj;
	}
	
	TextProperty.prototype.setCurrentData = function(data){
	    if(!data.__complete) {
	        this.completeTextData(data);
	    }
	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	};
	
	TextProperty.prototype.searchProperty = function() {
	    return this.searchKeyframes();
	};
	
	TextProperty.prototype.searchKeyframes = function() {
	    this.kf = this.data.d.k.length > 1;
	    if(this.kf) {
	        this.addEffect(this.getKeyframeValue.bind(this));
	    }
	    return this.kf;
	}
	
	TextProperty.prototype.addEffect = function(effectFunction) {
		this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.getValue = function(_finalValue) {
	    if((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	        return;
	    }
	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;
	    if(this.lock) {
	        this.setCurrentData(this.currentData);
	        return;
	    }
	    this.lock = true;
	    this._mdf = false;
	    var multipliedValue;
	    var i, len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
	    for(i = 0; i < len; i += 1) {
	        //Checking if index changed to prevent creating a new object every time the expression updates.
	        if(currentIndex !== this.keysIndex) {
	            finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	        } else {
	            finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	        }
	    }
	    if(currentValue !== finalValue) {
	        this.setCurrentData(finalValue);
	    }
	    this.pv = this.v = this.currentData;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	}
	
	TextProperty.prototype.getKeyframeValue = function() {
	    var textKeys = this.data.d.k, textDocumentData;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textDocumentData = textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameNum){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	        this.keysIndex = i;
	    }
	    return this.data.d.k[this.keysIndex].s;
	};
	
	TextProperty.prototype.buildFinalText = function(text) {
	    var combinedCharacters = FontManager.getCombinedCharacterCodes();
	    var charactersArray = [];
	    var i = 0, len = text.length;
	    while (i < len) {
	        if (combinedCharacters.indexOf(text.charCodeAt(i)) !== -1) {
	            charactersArray[charactersArray.length - 1] += text.charAt(i);
	        } else {
	            charactersArray.push(text.charAt(i));
	        }
	        i += 1;
	    }
	    return charactersArray;
	}
	
	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	
	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            break;
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fontData.fWeight || fWeight;
	    documentData.fStyle = fStyle;
	    len = documentData.t.length;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var charCode;
	    if(documentData.sz){
	        var flag = true;
	        var boxWidth = documentData.sz[0];
	        var boxHeight = documentData.sz[1];
	        var currentHeight, finalText;
	        while(flag) {
	            finalText = this.buildFinalText(documentData.t);
	            currentHeight = 0;
	            lineWidth = 0;
	            len = finalText.length;
	            trackingOffset = documentData.tr/1000*documentData.finalSize;
	            var lastSpaceIndex = -1;
	            for(i=0;i<len;i+=1){
	                charCode = finalText[i].charCodeAt(0);
	                newLineFlag = false;
	                if(finalText[i] === ' '){
	                    lastSpaceIndex = i;
	                }else if(charCode === 13 || charCode === 3){
	                    lineWidth = 0;
	                    newLineFlag = true;
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                }
	                if(fontManager.chars){
	                    charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	                    cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	                }else{
	                    //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	                }
	                if(lineWidth + cLength > boxWidth && finalText[i] !== ' '){
	                    if(lastSpaceIndex === -1){
	                        len += 1;
	                    } else {
	                        i = lastSpaceIndex;
	                    }
	                    currentHeight += documentData.finalLineHeight || documentData.finalSize*1.2;
	                    finalText.splice(i, lastSpaceIndex === i ? 1 : 0,"\r");
	                    //finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	                    lastSpaceIndex = -1;
	                    lineWidth = 0;
	                }else {
	                    lineWidth += cLength;
	                    lineWidth += trackingOffset;
	                }
	            }
	            currentHeight += fontData.ascent*documentData.finalSize/100;
	            if(this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	                documentData.finalSize -= 1;
	                documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	            } else {
	                documentData.finalText = finalText;
	                len = documentData.finalText.length;
	                flag = false;
	            }
	        }
	
	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.finalText[i];
	        charCode = currentChar.charCodeAt(0);
	        if (currentChar === ' '){
	            val = '\u00A0';
	        } else if (charCode === 13 || charCode === 3) {
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else{
	            val = documentData.finalText[i];
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.finalSize/100;
	        }else{
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	            //tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        }
	
	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine, animatorJustifyOffset: 0});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val === '' || val === '\u00A0' || i === len - 1){
	                if(val === '' || val === '\u00A0'){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val === '' || i === len - 1){
	                if(val === ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else{
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else{
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;
	
	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val !== '') || (based == 2 && letterData.val !== '' && letterData.val !== '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.finalSize/100;
	};
	
	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.recalculate = function(index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	}
	
	TextProperty.prototype.canResizeFont = function(_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};
	
	TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	};
	
	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	
	    function TextSelectorProp(elem,data){
	        this._currentTextLength = -1;
	        this.k = false;
	        this.data = data;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.initDynamicPropertyContainer(elem);
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this);
	        }else{
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this);
	        if(!this.dynamicProperties.length){
	            this.getValue();
	        }
	    }
	
	    TextSelectorProp.prototype = {
	        getMult: function(ind) {
	            if(this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	                this.getValue();
	            }
	            //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	            var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	            var mult = 0;
	            var s = this.finalS;
	            var e = this.finalE;
	            var type = this.data.sh;
	            if(type == 2){
	                if(e === s){
	                    mult = ind >= e ? 1 : 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	                mult = easer(mult);
	            }else if(type == 3){
	                if(e === s){
	                    mult = ind >= e ? 0 : 1;
	                }else{
	                    mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                }
	
	                mult = easer(mult);
	            }else if(type == 4){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                    if(mult<0.5){
	                        mult *= 2;
	                    }else{
	                        mult = 1 - 2*(mult-0.5);
	                    }
	                }
	                mult = easer(mult);
	            }else if(type == 5){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    var tot = e - s;
	                    /*ind += 0.5;
	                    mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    var x = -tot/2+ind;
	                    var a = tot/2;
	                    mult = Math.sqrt(1 - (x*x)/(a*a));
	                }
	                mult = easer(mult);
	            }else if(type == 6){
	                if(e === s){
	                    mult = 0;
	                }else{
	                    ind = min(max(0,ind+0.5-s),e-s);
	                    mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                    /*
	                     ind = Math.min(Math.max(s,ind),e-1);
	                     mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                     mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	                }
	                mult = easer(mult);
	            }else {
	                if(ind >= floor(s)){
	                    if(ind-s < 0){
	                        mult = 1 - (s - ind);
	                    }else{
	                        mult = max(0,min(e-ind,1));
	                    }
	                }
	                mult = easer(mult);
	            }
	            return mult*this.a.v;
	        },
	        getValue: function(newCharsFlag) {
	            this.iterateDynamicProperties();
	            this._mdf = newCharsFlag || this._mdf;
	            this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	            if(newCharsFlag && this.data.r === 2) {
	                this.e.v = this._currentTextLength;
	            }
	            var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	            var o = this.o.v/divisor;
	            var s = this.s.v/divisor + o;
	            var e = (this.e.v/divisor) + o;
	            if(s>e){
	                var _s = s;
	                s = e;
	                e = _s;
	            }
	            this.finalS = s;
	            this.finalE = e;
	        }
	    }
	    extendPrototype([DynamicPropertyContainer], TextSelectorProp);
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    }
	
	    return {
	        getTextSelectorProp: getTextSelectorProp
	    };
	}());
	
	    
	var pool_factory = (function() {
		return function(initialLength, _create, _release, _clone) {
	
			var _length = 0;
			var _maxLength = initialLength;
			var pool = createSizedArray(_maxLength);
	
			var ob = {
				newElement: newElement,
				release: release
			};
	
			function newElement(){
				var element;
				if(_length){
					_length -= 1;
					element = pool[_length];
				} else {
					element = _create();
				}
				return element;
			}
	
			function release(element) {
				if(_length === _maxLength) {
					pool = pooling.double(pool);
					_maxLength = _maxLength*2;
				}
				if (_release) {
					_release(element);
				}
				pool[_length] = element;
				_length += 1;
			}
	
			function clone() {
				var clonedElement = newElement();
				return _clone(clonedElement);
			}
	
			return ob;
		};
	}());
	
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(createSizedArray(arr.length));
		}
	
		return {
			double: double
		};
	}());
	var point_pool = (function(){
	
		function create() {
			return createTypedArray('float32', 2);
		}
		return pool_factory(8, create);
	}());
	var shape_pool = (function(){
	
		function create() {
			return new ShapePath();
		}
	
		function release(shapePath) {
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
		}
	
		function clone(shape) {
			var cloned = factory.newElement();
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			cloned.setLength(len);
			cloned.c = shape.c;
			var pt;
			
			for(i = 0; i < len; i += 1) {
				cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
			}
			return cloned;
		}
	
		var factory = pool_factory(4, create, release);
		factory.clone = clone;
	
		return factory;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release
		};
	
		var _length = 0;
		var _maxLength = 4;
		var pool = createSizedArray(_maxLength);
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		return ob;
	}());
	var segments_length_pool = (function(){
	
		function create() {
			return {
				lengths: [],
				totalLength: 0
			};
		}
	
		function release(element) {
			var i, len = element.lengths.length;
			for(i=0;i<len;i+=1) {
				bezier_length_pool.release(element.lengths[i]);
			}
			element.lengths.length = 0;
		}
	
		return pool_factory(8, create, release);
	}());
	var bezier_length_pool = (function(){
	
		function create() {
			return {
	            addedLength: 0,
	            percents: createTypedArray('float32', defaultCurveSegments),
	            lengths: createTypedArray('float32', defaultCurveSegments),
	        };
		}
		return pool_factory(8, create);
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 3:
	            return this.createNull(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	    }
	    return this.createNull(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	};
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while (i < len) {
	        if (layers[i].ind == parentName) {
	            if (!elements[i] || elements[i] === true) {
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i].setAsParent();
	                if(layers[i].parent !== undefined) {
	                    this.buildElementParenting(element, layers[i].parent, hierarchy);
	                } else {
	                    element.setHierarchy(hierarchy);
	                }
	            }
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	
	BaseRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i]);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    }
	}
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var defs = createNS( 'defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        viewBoxSize: (config && config.viewBoxSize) || false,
	        className: (config && config.className) || ''
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        defs: defs,
	        renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	
	}
	
	extendPrototype([BaseRenderer],SVGRenderer);
	
	SVGRenderer.prototype.createNull = function (data) {
	    return new NullElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new SVGShapeElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    if(this.renderConfig.viewBoxSize) {
	        this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);
	    } else {
	        this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    }
	
	    if(!this.renderConfig.viewBoxOnly) {
	        this.svgElement.setAttribute('width',animData.w);
	        this.svgElement.setAttribute('height',animData.h);
	        this.svgElement.style.width = '100%';
	        this.svgElement.style.height = '100%';
	        this.svgElement.style.transform = 'translate3d(0,0,0)';
	    }
	    if(this.renderConfig.className) {
	        this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	    this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.svgElement);
	    //Mask animation
	    var defs = this.globalData.defs;
	
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	
	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
	
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame === num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    // console.log('-------');
	    // console.log('FRAME ',num);
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        for (i = 0; i < len; i += 1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        className: (config && config.className) || ''
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1,
	        _mdf: false,
	        renderConfig: this.renderConfig,
	        currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';
	}
	extendPrototype([BaseRenderer],CanvasRenderer);
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	};
	
	CanvasRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    var cProps = this.contextData.cTr.props;
	    this.transformMat.transform(cProps[0],cProps[1],cProps[2],cProps[3],cProps[4],cProps[5],cProps[6],cProps[7],cProps[8],cProps[9],cProps[10],cProps[11],cProps[12],cProps[13],cProps[14],cProps[15]);
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    /*if(op === 1){
	        return;
	    }*/
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    if(this.globalData.currentGlobalAlpha !== this.contextData.cO) {
	        this.canvasContext.globalAlpha = this.contextData.cO;
	        this.globalData.currentGlobalAlpha = this.contextData.cO;
	    }
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.reset();
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData._length <= this.contextData.cArrPos) {
	        this.contextData.duplicate();
	    }
	    var i, arr = this.contextData.saved[this.contextData.cArrPos];
	    for (i = 0; i < 16; i += 1) {
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	        this.globalData.blendMode = 'source-over';
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    if(this.globalData.currentGlobalAlpha !== popped) {
	        this.canvasContext.globalAlpha = popped;
	        this.globalData.currentGlobalAlpha = popped;
	    }
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = createTag('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	        w: animData.w,
	        h:animData.h,
	        sx:0,
	        sy:0,
	        tx:0,
	        ty:0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    this.reset();
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    /*var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }*/
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === -1){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas;
	    this.globalData.projectInterface.currentFrame = num;
	
	     // console.log('--------');
	     // console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    if(this.globalData._mdf) {
	        if(this.renderConfig.clearCanvas === true){
	            this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	        }else{
	            this.save();
	        }
	        for (i = len - 1; i >= 0; i-=1) {
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	        if(this.renderConfig.clearCanvas !== true){
	            this.restore();
	        }
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /*if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }*/
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	        className: (config && config.className) || '',
	        imagePreserveAspectRatio: (config && config.imagePreserveAspectRatio) || 'xMidYMid slice',
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true
	    };
	    this.globalData = {
	        _mdf: false,
	        frameNum: -1,
	        renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	
	}
	
	extendPrototype([BaseRenderer],HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        if(this.threeDElements) {
	            this.addTo3dContainer(newDOMElement,pos);
	        } else {
	            var i = 0;
	            var nextDOMElement, nextLayer, tmpDOMElement;
	            while(i<pos){
	                if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                    nextLayer = this.elements[i];
	                    tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	                    nextDOMElement = tmpDOMElement || nextDOMElement;
	                }
	                i += 1;
	            }
	            if(nextDOMElement){
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	                }
	            } else {
	                if(!layer.ddd || !this.supports3d){
	                    this.layerElement.appendChild(newDOMElement);
	                }
	            }
	        }
	        
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new SVGShapeElement(data, this.globalData, this);
	    }
	    return new HShapeElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.globalData, this);
	    }
	    return new HTextElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.globalData, this);
	    }
	    return new HImageElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new SVGCompElement(data, this.globalData, this);
	    }
	    return new HCompElement(data, this.globalData, this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.globalData, this);
	    }
	    return new HSolidElement(data, this.globalData, this);
	};
	
	HybridRenderer.prototype.createNull = SVGRenderer.prototype.createNull;
	
	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.createThreeDContainer = function(pos, type){
	    var perspectiveElem = createTag('div');
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	    if(type === '3d') {
	        perspectiveElem.style.width = this.globalData.compSize.w+'px';
	        perspectiveElem.style.height = this.globalData.compSize.h+'px';
	        perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	        container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	    
	    perspectiveElem.appendChild(container);
	    //this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos,
	        type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd && this.layers[i].ty !== 3){
	            if(currentContainer !== '3d'){
	                currentContainer = '3d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'3d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            if(currentContainer !== '2d'){
	                currentContainer = '2d';
	                lastThreeDContainerData = this.createThreeDContainer(i,'2d');
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        }
	    }
	    len = this.threeDElements.length;
	    for(i = len - 1; i >= 0; i --) {
	        this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData;
	    //Mask animation
	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createTag('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function MaskElement(data,element,globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = createElementID();
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count === 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w || 0);
	            rect.setAttribute('height', this.element.comp.data.h || 0);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            // TODO move this to a factory or to a constructor
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	                elem: path,
	                lastPath: ''
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000':'#ffffff');
	        path.setAttribute('clip-rule','nonzero');
	        var filterID;
	
	        if (properties[i].x.k !== 0) {
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);
	            filterID = createElementID();
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            path.setAttribute('stroke', properties[i].mode === 's' ? '#000000':'#ffffff');
	        } else {
	            feMorph = null;
	            x = null;
	        }
	
	        // TODO move this to a factory or to a constructor
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),
	            invRect: rect
	        };
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = createNS( maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    if(count > 0){
	        this.maskElement.setAttribute('id', layerId);
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	        defs.appendChild(this.maskElement);
	    }
	    if (this.viewData.length) {
	        this.element.addRenderableComponent(this);
	    }
	
	}
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop._mdf || isFirstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op._mdf || isFirstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    }
	    //pathNodes.__renderedString = pathString;
	
	    if(viewData.lastPath !== pathString){
	        var pathShapeValue = '';
	        if(viewData.elem){
	            if(pathNodes.c){
	                pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	            }
	            viewData.elem.setAttribute('d',pathShapeValue);
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};
	
	/**
	 * @file 
	 * Handles AE's layer parenting property.
	 *
	 */
	
	function HierarchyElement(){}
	
	HierarchyElement.prototype = {
		/**
	     * @function 
	     * Initializes hierarchy properties
	     *
	     */
		initHierarchy: function() {
			//element's parent list
		    this.hierarchy = [];
		    //if element is parent of another layer _isParent will be true
		    this._isParent = false;
		    this.checkParenting();
		},
		/**
	     * @function 
	     * Sets layer's hierarchy.
	     * @param {array} hierarch
	     * layer's parent list
	     *
	     */ 
		setHierarchy: function(hierarchy){
		    this.hierarchy = hierarchy;
		},
		/**
	     * @function 
	     * Sets layer as parent.
	     *
	     */ 
		setAsParent: function() {
		    this._isParent = true;
		},
		/**
	     * @function 
	     * Searches layer's parenting chain
	     *
	     */ 
		checkParenting: function(){
		    if (this.data.parent !== undefined){
		        this.comp.buildElementParenting(this, this.data.parent, []);
		    }
		}
	};
	/**
	 * @file 
	 * Handles element's layer frame update.
	 * Checks layer in point and out point
	 *
	 */
	
	function FrameElement(){}
	
	FrameElement.prototype = {
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     */
	    initFrame: function(){
	        //set to true when inpoint is rendered
	        this._isFirstFrame = false;
	        //list of animated properties
	        this.dynamicProperties = [];
	        // If layer has been modified in current tick this will be true
	        this._mdf = false;
	    },
	    /**
	     * @function 
	     * Calculates all dynamic values
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * @param {boolean} isVisible
	     * if layers is currently in range
	     * 
	     */
	    prepareProperties: function(num, isVisible) {
	        var i, len = this.dynamicProperties.length;
	        for (i = 0;i < len; i += 1) {
	            if (isVisible || (this._isParent && this.dynamicProperties[i].propType === 'transform')) {
	                this.dynamicProperties[i].getValue();
	                if (this.dynamicProperties[i]._mdf) {
	                    this.globalData._mdf = true;
	                    this._mdf = true;
	                }
	            }
	        }
	    },
	    addDynamicProperty: function(prop) {
	        if(this.dynamicProperties.indexOf(prop) === -1) {
	            this.dynamicProperties.push(prop);
	        }
	    }
	};
	function TransformElement(){}
	
	TransformElement.prototype = {
	    initTransform: function() {
	        this.finalTransform = {
	            mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {o:0},
	            _matMdf: false,
	            _opMdf: false,
	            mat: new Matrix()
	        };
	        if (this.data.ao) {
	            this.finalTransform.mProp.autoOriented = true;
	        }
	
	        //TODO: check TYPE 11: Guided elements
	        if (this.data.ty !== 11) {
	            //this.createElements();
	        }
	    },
	    renderTransform: function() {
	
	        this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	        this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
	
	        if (this.hierarchy) {
	            var mat;
	            var finalMat = this.finalTransform.mat;
	            var i = 0, len = this.hierarchy.length;
	            //Checking if any of the transformation matrices in the hierarchy chain has changed.
	            if (!this.finalTransform._matMdf) {
	                while (i < len) {
	                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
	                        this.finalTransform._matMdf = true;
	                        break;
	                    }
	                    i += 1;
	                }
	            }
	            
	            if (this.finalTransform._matMdf) {
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	                for (i = 0; i < len; i += 1) {
	                    mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                    finalMat.transform(mat[0], mat[1], mat[2], mat[3], mat[4], mat[5], mat[6], mat[7], mat[8], mat[9], mat[10], mat[11], mat[12], mat[13], mat[14], mat[15]);
	                }
	            }
	        }
	    },
	    globalToLocal: function(pt) {
	        var transforms = [];
	        transforms.push(this.finalTransform);
	        var flag = true;
	        var comp = this.comp;
	        while (flag) {
	            if (comp.finalTransform) {
	                if (comp.data.hasMask) {
	                    transforms.splice(0, 0, comp.finalTransform);
	                }
	                comp = comp.comp;
	            } else {
	                flag = false;
	            }
	        }
	        var i, len = transforms.length,ptNew;
	        for (i = 0; i < len; i += 1) {
	            ptNew = transforms[i].mat.applyToPointArray(0, 0, 0);
	            //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	            pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	        }
	        return pt;
	    },
	    mHelper: new Matrix()
	};
	function RenderableElement(){
	
	}
	
	RenderableElement.prototype = {
	    initRenderable: function() {
	        //layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	        this.isInRange = false;
	        //layer's display state
	        this.hidden = false;
	        // If layer's transparency equals 0, it can be hidden
	        this.isTransparent = false;
	        //list of animated components
	        this.renderableComponents = [];
	    },
	    addRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) === -1) {
	            this.renderableComponents.push(component);
	        }
	    },
	    removeRenderableComponent: function(component) {
	        if(this.renderableComponents.indexOf(component) !== -1) {
	            this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	        }
	    },
	    prepareRenderableFrame: function(num) {
	        this.checkLayerLimits(num);
	    },
	    checkTransparency: function(){
	        if(this.finalTransform.mProp.o.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.isTransparent) {
	            this.isTransparent = false;
	            this.show();
	        }
	    },
	    /**
	     * @function 
	     * Initializes frame related properties.
	     *
	     * @param {number} num
	     * current frame number in Layer's time
	     * 
	     */
	    checkLayerLimits: function(num) {
	        if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	        {
	            if(this.isInRange !== true){
	                this.globalData._mdf = true;
	                this._mdf = true;
	                this.isInRange = true;
	                this.show();
	            }
	        } else {
	            if(this.isInRange !== false){
	                this.globalData._mdf = true;
	                this.isInRange = false;
	                this.hide();
	            }
	        }
	    },
	    renderRenderable: function() {
	        var i, len = this.renderableComponents.length;
	        for(i = 0; i < len; i += 1) {
	            this.renderableComponents[i].renderFrame(this._isFirstFrame);
	        }
	        /*this.maskManager.renderFrame(this.finalTransform.mat);
	        this.renderableEffectsManager.renderFrame(this._isFirstFrame);*/
	    },
	    sourceRectAtTime: function(){
	        return {
	            top:0,
	            left:0,
	            width:100,
	            height:100
	        };
	    },
	    getLayerSize: function(){
	        if(this.data.ty === 5){
	            return {w:this.data.textData.width,h:this.data.textData.height};
	        }else{
	            return {w:this.data.width,h:this.data.height};
	        }
	    }
	};
	function RenderableDOMElement() {}
	
	(function(){
	    var _prototype = {
	        initElement: function(data,globalData,comp) {
	            this.initFrame();
	            this.initBaseData(data, globalData, comp);
	            this.initTransform(data, globalData, comp);
	            this.initHierarchy();
	            this.initRenderable();
	            this.initRendererElement();
	            this.createContainerElements();
	            this.createRenderableComponents();
	            this.createContent();
	            this.hide();
	        },
	        hide: function(){
	            if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	                var elem = this.baseElement || this.layerElement;
	                elem.style.display = 'none';
	                this.hidden = true;
	            }
	        },
	        show: function(){
	            if (this.isInRange && !this.isTransparent){
	                if (!this.data.hd) {
	                    var elem = this.baseElement || this.layerElement;
	                    elem.style.display = 'block';
	                }
	                this.hidden = false;
	                this._isFirstFrame = true;
	            }
	        },
	        renderFrame: function() {
	            //If it is exported as hidden (data.hd === true) no need to render
	            //If it is not visible no need to render
	            if (this.data.hd || this.hidden) {
	                return;
	            }
	            this.renderTransform();
	            this.renderRenderable();
	            this.renderElement();
	            this.renderInnerContent();
	            if (this._isFirstFrame) {
	                this._isFirstFrame = false;
	            }
	        },
	        renderInnerContent: function() {},
	        prepareFrame: function(num) {
	            this._mdf = false;
	            this.prepareRenderableFrame(num);
	            this.prepareProperties(num, this.isInRange);
	            this.checkTransparency();
	        },
	        destroy: function(){
	            this.innerElem =  null;
	            this.destroyBaseElement();
	        }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	}());
	function ProcessedElement(element, position) {
		this.elem = element;
		this.pos = position;
	}
	function SVGStyleData(data, level) {
		this.data = data;
		this.type = data.ty;
		this.d = '';
		this.lvl = level;
		this._mdf = false;
		this.closed = data.hd === true;
		this.pElem = createNS('path');
		this.msElem = null;
	}
	
	SVGStyleData.prototype.reset = function() {
		this.d = '';
		this._mdf = false;
	};
	function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level;
	    //TODO find if there are some cases where _isAnimated can be false. 
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	    this._isAnimated = !!shape.k;
	    // TODO: commenting this for now since all shapes are animated
	    var i = 0, len = transformers.length;
	    while(i < len) {
	    	if(transformers[i].mProps.dynamicProperties.length) {
	    		this._isAnimated = true;
	    		break;
	    	}
	    	i += 1;
	    }
	}
	
	SVGShapeData.prototype.setAsAnimated = function() {
	    this._isAnimated = true;
	}
	function SVGTransformData(mProps, op, container) {
		this.transform = {
			mProps: mProps,
			op: op,
			container: container
		};
		this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	}
	function SVGStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	function SVGFillStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
		this.c = PropertyFactory.getProp(elem,data.c,1,255,this);
		this.style = styleOb;
	}
	
	extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	function SVGGradientFillStyleData(elem, data, styleOb){
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	}
	
	SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb){
	    this.o = PropertyFactory.getProp(elem,data.o,0,0.01,this);
	    this.s = PropertyFactory.getProp(elem,data.s,1,null,this);
	    this.e = PropertyFactory.getProp(elem,data.e,1,null,this);
	    this.h = PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);
	    this.a = PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);
	    this.g = new GradientProperty(elem,data.g,this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	
	};
	
	SVGGradientFillStyleData.prototype.setGradientData = function(pathElement,data){
	
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = data.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+gradientId+')');
	    
	    this.gf = gfill;
	    this.cst = stops;
	};
	
	SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb){
	    if(this.g._hasOpacity && !this.g._collapsable){
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = createElementID();
	        var maskId = createElementID();
	        mask.setAttribute('id',maskId);
	        var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	        var stops = this.stops;
	        for(j=data.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( data.ty === 'gf' ? 'fill':'stroke','url(' + locationHref + '#'+opacityId+')');
	        this.of = opFill;
	        this.ms = mask;
	        this.ost = stops;
	        this.maskId = maskId;
	        styleOb.msElem = maskElement;
	    }
	};
	
	extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	function SVGGradientStrokeStyleData(elem, data, styleOb){
		this.initDynamicPropertyContainer(elem);
		this.getValue = this.iterateDynamicProperties;
		this.w = PropertyFactory.getProp(elem,data.w,0,null,this);
		this.d = new DashProperty(elem,data.d||{},'svg',this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	}
	
	extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	function ShapeGroupData() {
		this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	}
	var SVGElementsRenderer = (function() {
		var _identityMatrix = new Matrix();
		var _matrixHelper = new Matrix();
	
		var ob = {
			createRenderFunction: createRenderFunction
		}
	
		function createRenderFunction(data) {
		    var ty = data.ty;
		    switch(data.ty) {
		        case 'fl':
		        return renderFill;
		        case 'gf':
		        return renderGradient;
		        case 'gs':
		        return renderGradientStroke;
		        case 'st':
		        return renderStroke;
		        case 'sh':
		        case 'el':
		        case 'rc':
		        case 'sr':
		        return renderPath;
		        case 'tr':
		        return renderContentTransform;
		    }
		}
	
		function renderContentTransform(styleData, itemData, isFirstFrame) {
		    if(isFirstFrame || itemData.transform.op._mdf){
		        itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);
		    }
		    if(isFirstFrame || itemData.transform.mProps._mdf){
		        itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());
		    }
		}
	
		function renderPath(styleData, itemData, isFirstFrame) {
		    var j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.styles.length;
		    var lvl = itemData.lvl;
		    var paths, mat, props, iterations, k;
		    for(l=0;l<lLen;l+=1){
		        redraw = itemData.sh._mdf || isFirstFrame;
		        if(itemData.styles[l].lvl < lvl){
		            mat = _matrixHelper.reset();
		            iterations = lvl - itemData.styles[l].lvl;
		            k = itemData.transformers.length-1;
		            while(!redraw && iterations > 0) {
		                redraw = itemData.transformers[k].mProps._mdf || redraw;
		                iterations --;
		                k --;
		            }
		            if(redraw) {
		                iterations = lvl - itemData.styles[l].lvl;
		                k = itemData.transformers.length-1;
		                while(iterations > 0) {
		                    props = itemData.transformers[k].mProps.v.props;
		                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
		                    iterations --;
		                    k --;
		                }
		            }
		        } else {
		            mat = _identityMatrix;
		        }
		        paths = itemData.sh.paths;
		        jLen = paths._length;
		        if(redraw){
		            pathStringTransformed = '';
		            for(j=0;j<jLen;j+=1){
		                pathNodes = paths.shapes[j];
		                if(pathNodes && pathNodes._length){
		                    pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
		                }
		            }
		            itemData.caches[l] = pathStringTransformed;
		        } else {
		            pathStringTransformed = itemData.caches[l];
		        }
		        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
		        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
		    }
		}
	
		function renderFill (styleData,itemData, isFirstFrame){
		    var styleElem = itemData.style;
	
		    if(itemData.c._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
		    }
		};
	
		function renderGradientStroke (styleData, itemData, isFirstFrame) {
		    renderGradient(styleData, itemData, isFirstFrame);
		    renderStroke(styleData, itemData, isFirstFrame);
		}
	
		function renderGradient(styleData, itemData, isFirstFrame) {
		    var gfill = itemData.gf;
		    var hasOpacity = itemData.g._hasOpacity;
		    var pt1 = itemData.s.v, pt2 = itemData.e.v;
	
		    if (itemData.o._mdf || isFirstFrame) {
		        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
		        itemData.style.pElem.setAttribute(attr, itemData.o.v);
		    }
		    if (itemData.s._mdf || isFirstFrame) {
		        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
		        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
		        gfill.setAttribute(attr1, pt1[0]);
		        gfill.setAttribute(attr2, pt1[1]);
		        if (hasOpacity && !itemData.g._collapsable) {
		            itemData.of.setAttribute(attr1, pt1[0]);
		            itemData.of.setAttribute(attr2, pt1[1]);
		        }
		    }
		    var stops, i, len, stop;
		    if (itemData.g._cmdf || isFirstFrame) {
		        stops = itemData.cst;
		        var cValues = itemData.g.c;
		        len = stops.length;
		        for (i = 0; i < len; i += 1){
		            stop = stops[i];
		            stop.setAttribute('offset', cValues[i * 4] + '%');
		            stop.setAttribute('stop-color','rgb('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ')');
		        }
		    }
		    if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
		        var oValues = itemData.g.o;
		        if(itemData.g._collapsable) {
		            stops = itemData.cst;
		        } else {
		            stops = itemData.ost;
		        }
		        len = stops.length;
		        for (i = 0; i < len; i += 1) {
		            stop = stops[i];
		            if(!itemData.g._collapsable) {
		                stop.setAttribute('offset', oValues[i * 2] + '%');
		            }
		            stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
		        }
		    }
		    if (styleData.t === 1) {
		        if (itemData.e._mdf  || isFirstFrame) {
		            gfill.setAttribute('x2', pt2[0]);
		            gfill.setAttribute('y2', pt2[1]);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('x2', pt2[0]);
		                itemData.of.setAttribute('y2', pt2[1]);
		            }
		        }
		    } else {
		        var rad;
		        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
		            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            gfill.setAttribute('r', rad);
		            if(hasOpacity && !itemData.g._collapsable){
		                itemData.of.setAttribute('r', rad);
		            }
		        }
		        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
		            if (!rad) {
		                rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
		            }
		            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	
		            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
		            var dist = rad * percent;
		            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
		            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
		            gfill.setAttribute('fx', x);
		            gfill.setAttribute('fy', y);
		            if (hasOpacity && !itemData.g._collapsable) {
		                itemData.of.setAttribute('fx', x);
		                itemData.of.setAttribute('fy', y);
		            }
		        }
		        //gfill.setAttribute('fy','200');
		    }
		};
	
		function renderStroke(styleData, itemData, isFirstFrame) {
		    var styleElem = itemData.style;
		    var d = itemData.d;
		    if (d && (d._mdf || isFirstFrame) && d.dashStr) {
		        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
		        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
		    }
		    if(itemData.c && (itemData.c._mdf || isFirstFrame)){
		        styleElem.pElem.setAttribute('stroke','rgb(' + bm_floor(itemData.c.v[0]) + ',' + bm_floor(itemData.c.v[1]) + ',' + bm_floor(itemData.c.v[2]) + ')');
		    }
		    if(itemData.o._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
		    }
		    if(itemData.w._mdf || isFirstFrame){
		        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
		        if(styleElem.msElem){
		            styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
		        }
		    }
		};
	
		return ob;
	}())
	function ShapeTransformManager() {
		this.sequences = {};
		this.sequenceList = [];
	    this.transform_key_count = 0;
	}
	
	ShapeTransformManager.prototype = {
		addTransformSequence: function(transforms) {
			var i, len = transforms.length;
			var key = '_';
			for(i = 0; i < len; i += 1) {
				key += transforms[i].transform.key + '_';
			}
			var sequence = this.sequences[key];
			if(!sequence) {
				sequence = {
					transforms: [].concat(transforms),
					finalTransform: new Matrix(),
					_mdf: false
				};
				this.sequences[key] = sequence;
				this.sequenceList.push(sequence);
			}
			return sequence;
		},
		processSequence: function(sequence, isFirstFrame) {
			var i = 0, len = sequence.transforms.length, _mdf = isFirstFrame;
			while (i < len && !isFirstFrame) {
				if (sequence.transforms[i].transform.mProps._mdf) {
					_mdf = true;
					break;
				}
				i += 1
			}
			if (_mdf) {
				var props;
				sequence.finalTransform.reset();
				for (i = len - 1; i >= 0; i -= 1) {
			        props = sequence.transforms[i].transform.mProps.v.props;
			        sequence.finalTransform.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
				}
			}
			sequence._mdf = _mdf;
			
		},
		processSequences: function(isFirstFrame) {
			var i, len = this.sequenceList.length;
			for (i = 0; i < len; i += 1) {
				this.processSequence(this.sequenceList[i], isFirstFrame);
			}
	
		},
		getNewKey: function() {
			return '_' + this.transform_key_count++;
		}
	}
	function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0,0,0,0,0,0];
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    this.sh = ShapePropertyFactory.getShapeProp(element,data,ty,element);
	    var i , len = styles.length,styledShape;
	    for (i = 0; i < len; i += 1) {
	        if (!styles[i].closed) {
	            styledShape = {
	                transforms: transformsManager.addTransformSequence(styles[i].transforms),
	                trNodes: []
	            }
	            this.styledShapes.push(styledShape);
	            styles[i].elements.push(styledShape);
	        }
	    }
	}
	
	CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	function BaseElement(){
	}
	
	BaseElement.prototype = {
	    checkMasks: function(){
	        if(!this.data.hasMask){
	            return false;
	        }
	        var i = 0, len = this.data.masksProperties.length;
	        while(i<len) {
	            if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	                return true;
	            }
	            i += 1;
	        }
	        return false;
	    },
	    initExpressions: function(){
	        this.layerInterface = LayerExpressionInterface(this);
	        if(this.data.hasMask && this.maskManager) {
	            this.layerInterface.registerMaskInterface(this.maskManager);
	        }
	        var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	        this.layerInterface.registerEffectsInterface(effectsInterface);
	
	        if(this.data.ty === 0 || this.data.xt){
	            this.compInterface = CompExpressionInterface(this);
	        } else if(this.data.ty === 4){
	            this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);
	            this.layerInterface.content = this.layerInterface.shapeInterface;
	        } else if(this.data.ty === 5){
	            this.layerInterface.textInterface = TextExpressionInterface(this);
	            this.layerInterface.text = this.layerInterface.textInterface;
	        }
	    },
	    setBlendMode: function(){
	        var blendModeValue = getBlendMode(this.data.bm);
	        var elem = this.baseElement || this.layerElement;
	
	        elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function(data, globalData, comp){
	        this.globalData = globalData;
	        this.comp = comp;
	        this.data = data;
	        this.layerId = createElementID();
	        
	        //Stretch factor for old animations missing this property.
	        if(!this.data.sr){
	            this.data.sr = 1;
	        }
	        // effects manager
	        this.effectsManager = new EffectsManager(this.data,this,this.dynamicProperties);
	        
	    },
	    getType: function(){
	        return this.type;
	    }
	}
	function NullElement(data,globalData,comp){
	    this.initFrame();
		this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	}
	
	NullElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	NullElement.prototype.renderFrame = function() {
	};
	
	NullElement.prototype.getBaseElement = function() {
		return null;
	};
	
	NullElement.prototype.destroy = function() {
	};
	
	NullElement.prototype.sourceRectAtTime = function() {
	};
	
	NullElement.prototype.hide = function() {
	};
	
	extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement], NullElement);
	
	function SVGBaseElement(){
	}
	
	SVGBaseElement.prototype = {
	    initRendererElement: function() {
	        this.layerElement = createNS('g');
	    },
	    createContainerElements: function(){
	        this.matteElement = createNS('g');
	        this.transformedElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	        this._sizeChanged = false;
	        var layerElementParent = null;
	        //If this layer acts as a mask for the following layer
	        var filId, fil, gg;
	        if (this.data.td) {
	            if (this.data.td == 3 || this.data.td == 1) {
	                var masker = createNS('mask');
	                masker.setAttribute('id', this.layerId);
	                masker.setAttribute('mask-type', this.data.td == 3 ? 'luminance' : 'alpha');
	                masker.appendChild(this.layerElement);
	                layerElementParent = masker;
	                this.globalData.defs.appendChild(masker);
	                // This is only for IE and Edge when mask if of type alpha
	                if (!featureSupport.maskType && this.data.td == 1) {
	                    masker.setAttribute('mask-type', 'luminance');
	                    filId = createElementID();
	                    fil = filtersFactory.createFilter(filId);
	                    this.globalData.defs.appendChild(fil);
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    masker.appendChild(gg);
	                    gg.setAttribute('filter','url(' + locationHref + '#' + filId + ')');
	                }
	            } else if(this.data.td == 2) {
	                var maskGroup = createNS('mask');
	                maskGroup.setAttribute('id', this.layerId);
	                maskGroup.setAttribute('mask-type','alpha');
	                var maskGrouper = createNS('g');
	                maskGroup.appendChild(maskGrouper);
	                filId = createElementID();
	                fil = filtersFactory.createFilter(filId);
	                ////
	
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type', 'matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	                feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	                fil.appendChild(feColorMatrix);
	
	                ////
	                /*var feCTr = createNS('feComponentTransfer');
	                feCTr.setAttribute('in','SourceGraphic');
	                fil.appendChild(feCTr);
	                var feFunc = createNS('feFuncA');
	                feFunc.setAttribute('type','table');
	                feFunc.setAttribute('tableValues','1.0 0.0');
	                feCTr.appendChild(feFunc);*/
	                this.globalData.defs.appendChild(fil);
	                var alphaRect = createNS('rect');
	                alphaRect.setAttribute('width',  this.comp.data.w);
	                alphaRect.setAttribute('height', this.comp.data.h);
	                alphaRect.setAttribute('x','0');
	                alphaRect.setAttribute('y','0');
	                alphaRect.setAttribute('fill','#ffffff');
	                alphaRect.setAttribute('opacity','0');
	                maskGrouper.setAttribute('filter', 'url(' + locationHref + '#'+filId+')');
	                maskGrouper.appendChild(alphaRect);
	                maskGrouper.appendChild(this.layerElement);
	                layerElementParent = maskGrouper;
	                if (!featureSupport.maskType) {
	                    maskGroup.setAttribute('mask-type', 'luminance');
	                    fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                    gg = createNS('g');
	                    maskGrouper.appendChild(alphaRect);
	                    gg.appendChild(this.layerElement);
	                    layerElementParent = gg;
	                    maskGrouper.appendChild(gg);
	                }
	                this.globalData.defs.appendChild(maskGroup);
	            }
	        } else if (this.data.tt) {
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        } else {
	            this.baseElement = this.layerElement;
	        }
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id', this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        //Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	        if (this.data.ty === 0 && !this.data.hd) {
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L' + this.data.w + ',0' + ' L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	            var clipId = createElementID();
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	
	            if (this.checkMasks()) {
	                var cpGroup = createNS('g');
	                cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId + ')');
	                cpGroup.appendChild(this.layerElement);
	                this.transformedElement = cpGroup;
	                if (layerElementParent) {
	                    layerElementParent.appendChild(this.transformedElement);
	                } else {
	                    this.baseElement = this.transformedElement;
	                }
	            } else {
	                this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            }
	            
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	
	    },
	    renderElement: function() {
	        if (this.finalTransform._matMdf) {
	            this.transformedElement.setAttribute('transform', this.finalTransform.mat.to2dCSS());
	        }
	        if (this.finalTransform._opMdf) {
	            this.transformedElement.setAttribute('opacity', this.finalTransform.mProp.o.v);
	        }
	    },
	    destroyBaseElement: function() {
	        this.layerElement = null;
	        this.matteElement = null;
	        this.maskManager.destroy();
	    },
	    getBaseElement: function() {
	        if (this.data.hd) {
	            return null;
	        }
	        return this.baseElement;
	    },
	    createRenderableComponents: function() {
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	        this.renderableEffectsManager = new SVGEffects(this);
	    },
	    setMatte: function(id) {
	        if (!this.matteElement) {
	            return;
	        }
	        this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	    }
	};
	function IShapeElement(){
	}
	
	IShapeElement.prototype = {
	    addShapeToModifiers: function(data) {
	        var i, len = this.shapeModifiers.length;
	        for(i=0;i<len;i+=1){
	            this.shapeModifiers[i].addShape(data);
	        }
	    },
	    isShapeInAnimatedModifiers: function(data) {
	        var i = 0, len = this.shapeModifiers.length;
	        while(i < len) {
	            if(this.shapeModifiers[i].isAnimatedWithShape(data)) {
	                return true;
	            }
	        }
	        return false;
	    },
	    renderModifiers: function() {
	        if(!this.shapeModifiers.length){
	            return;
	        }
	        var i, len = this.shapes.length;
	        for(i=0;i<len;i+=1){
	            this.shapes[i].sh.reset();
	        }
	
	        len = this.shapeModifiers.length;
	        for(i=len-1;i>=0;i-=1){
	            this.shapeModifiers[i].processShapes(this._isFirstFrame);
	        }
	    },
	    lcEnum: {
	        '1': 'butt',
	        '2': 'round',
	        '3': 'square'
	    },
	    ljEnum: {
	        '1': 'miter',
	        '2': 'round',
	        '3': 'bevel'
	    },
	    searchProcessedElement: function(elem){
	        var elements = this.processedElements;
	        var i = 0, len = elements.length;
	        while (i < len) {
	            if (elements[i].elem === elem) {
	                return elements[i].pos;
	            }
	            i += 1;
	        }
	        return 0;
	    },
	    addProcessedElement: function(elem, pos){
	        var elements = this.processedElements;
	        var i = elements.length;
	        while(i) {
	            i -= 1;
	            if (elements[i].elem === elem) {
	                elements[i].pos = pos;
	                return;
	            }
	        }
	        elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function(num) {
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	    }
	};
	function ITextElement(){
	}
	
	ITextElement.prototype.initElement = function(data,globalData,comp){
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};
	
	ITextElement.prototype.prepareFrame = function(num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(this.textProperty._mdf || this.textProperty._isFirstFrame) {
	        this.buildNewText();
	        this.textProperty._isFirstFrame = false;
	        this.textProperty._mdf = false;
	    }
	};
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	};
	
	ITextElement.prototype.canResizeFont = function(_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	};
	
	ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	};
	
	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	};
	
	
	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	};
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	ITextElement.prototype.destroy = function(){
	    
	};
	function ICompElement(){}
	
	extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
	
	ICompElement.prototype.initElement = function(data,globalData,comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	    this.hide();
	};
	
	/*ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.hideElement();
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};*/
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	    if(!this.isInRange && !this.data.xt){
	        return;
	    }
	
	    if (!this.tm._placeholder) {
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    //This iteration needs to be backwards because of how expressions connect between each other
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	            if(this.elements[i]._mdf) {
	                this._mdf = true;
	            }
	        }
	    }
	};
	
	ICompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i += 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroyElements = function(){
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.destroy = function(){
	    this.destroyElements();
	    this.destroyBaseElement();
	};
	
	function IImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], IImageElement);
	
	IImageElement.prototype.createContent = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio',this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    
	    this.layerElement.appendChild(this.innerElem);
	};
	
	function ISolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([IImageElement], ISolidElement);
	
	ISolidElement.prototype.createContent = function(){
	
	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	};
	function SVGCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    //this.layerElement = createNS('g');
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([SVGRenderer, ICompElement, SVGBaseElement], SVGCompElement);
	function SVGTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], SVGTextElement);
	
	SVGTextElement.prototype.createContent = function(){
	
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};
	
	SVGTextElement.prototype.buildTextContents = function(textArray) {
	    var i = 0, len = textArray.length;
	    var textContents = [], currentTextContent = '';
	    while (i < len) {
	        if(textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	            textContents.push(currentTextContent);
	            currentTextContent = '';
	        } else {
	            currentTextContent += textArray[i];
	        }
	        i += 1;
	    }
	    textContents.push(currentTextContent);
	    return textContents;
	}
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    if(singleShape && !usesGlyphs && !documentData.sz) {
	        var tElement = this.textContainer;
	        var justify = 'start';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = this.buildTextContents(documentData.finalText);
	        len = textContent.length;
	        yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.finalLineHeight;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	            if (singleShape) {
	                if(letters[i].n) {
	                    xPos = -trackingOffset;
	                    yPos += documentData.yOffset;
	                    yPos += firstLine ? 1 : 0;
	                    firstLine = false;
	                }
	                this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                xPos += letters[i].l || 0;
	                //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                xPos += trackingOffset;
	            }
	            if(usesGlyphs) {
	                charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                if(singleShape) {
	                    tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
	                }
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape && tSpan) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	};
	
	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        };
	    }
	    return this.bbox;
	};
	
	SVGTextElement.prototype.renderInnerContent = function(){
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;
	
	            var letters = this.textProperty.currentData.l;
	
	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter._mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter._mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter._mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter._mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter._mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	};
	function SVGShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	}
	
	extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement], SVGShapeElement);
	
	SVGShapeElement.prototype.initSecondaryElement = function() {
	};
	
	SVGShapeElement.prototype.identityMatrix = new Matrix();
	
	SVGShapeElement.prototype.buildExpressionInterface = function(){};
	
	SVGShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	};
	
	/*
	This method searches for multiple shapes that affect a single element and one of them is animated
	*/
	SVGShapeElement.prototype.filterUniqueShapes = function(){
	    var i, len = this.shapes.length, shape;
	    var j, jLen = this.stylesList.length;
	    var style, count = 0;
	    var tempShapes = [];
	    var areAnimated = false;
	    for(j = 0; j < jLen; j += 1) {
	        style = this.stylesList[j];
	        areAnimated = false;
	        tempShapes.length = 0;
	        for(i = 0; i < len; i += 1) {
	            shape = this.shapes[i];
	            if(shape.styles.indexOf(style) !== -1) {
	                tempShapes.push(shape);
	                areAnimated = shape._isAnimated || areAnimated;
	            }
	        }
	        if(tempShapes.length > 1 && areAnimated) {
	            this.setShapesAsAnimated(tempShapes);
	        }
	    }
	}
	
	SVGShapeElement.prototype.setShapesAsAnimated = function(shapes){
	    var i, len = shapes.length;
	    for(i = 0; i < len; i += 1) {
	        shapes[i].setAsAnimated();
	    }
	}
	
	SVGShapeElement.prototype.createStyleElement = function(data, level){
	    //TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	
	    var pathElement = styleOb.pElem;
	    if(data.ty === 'st') {
	        elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if(data.ty === 'fl') {
	        elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if(data.ty === 'gf' || data.ty === 'gs') {
	        var gradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	        elementData = new gradientConstructor(this, data, styleOb);
	        this.globalData.defs.appendChild(elementData.gf);
	        if (elementData.maskId) {
	            this.globalData.defs.appendChild(elementData.ms);
	            this.globalData.defs.appendChild(elementData.of);
	            pathElement.setAttribute('mask','url(' + locationHref + '#' + elementData.maskId + ')');
	        }
	    }
	    
	    if(data.ty === 'st' || data.ty === 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        pathElement.setAttribute('fill-opacity','0');
	        if(data.lj === 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	        }
	    }
	
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = new ShapeGroupData();
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        elementData.gr.setAttribute('class',data.cl);
	    }
	    if(data.bm){
	        elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	    return elementData;
	};
	
	SVGShapeElement.prototype.createTransformElement = function(data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this,data,this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
	    var ty = 4;
	    if(data.ty === 'rc'){
	        ty = 5;
	    }else if(data.ty === 'el'){
	        ty = 6;
	    }else if(data.ty === 'sr'){
	        ty = 7;
	    }
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this,data,ty,this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	};
	
	SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
	    var i = 0, len = this.animatedContents.length;
	    while(i < len) {
	        if(this.animatedContents[i].element === element) {
	            return;
	        }
	        i += 1;
	    }
	    this.animatedContents.push({
	        fn: SVGElementsRenderer.createRenderFunction(data),
	        element: element,
	        data: data
	    });
	};
	
	SVGShapeElement.prototype.setElementStyles = function(elementData){
	    var arr = elementData.styles;
	    var j, jLen = this.stylesList.length;
	    for (j = 0; j < jLen; j += 1) {
	        if (!this.stylesList[j].closed) {
	            arr.push(this.stylesList[j]);
	        }
	    }
	};
	
	SVGShapeElement.prototype.reloadShapes = function(){
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for( i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	    for(i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	};
	
	SVGShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].style.pElem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], container);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	            }
	            this.setElementStyles(itemsData[i]);
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	SVGShapeElement.prototype.renderInnerContent = function() {
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].reset();
	    }
	    this.renderShape();
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i]._mdf || this._isFirstFrame) {
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	                //Adding M0 0 fixes same mask bug on all browsers
	                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	            }
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	        }
	    }
	};
	
	SVGShapeElement.prototype.renderShape = function() {
	    var i, len = this.animatedContents.length;
	    var animatedContent;
	    for(i = 0; i < len; i += 1) {
	        animatedContent = this.animatedContents[i];
	        if((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	            animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	        }
	    }
	}
	
	SVGShapeElement.prototype.destroy = function(){
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	};
	
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = createElementID();
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        while (elemChildren[0]) {
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	};
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        if(this.paths[i].m === -1) {
	            continue;
	        }
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager._mdf || mask.prop._mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p._mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p._mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p._mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }
	
	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	
	        if(this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager._mdf){
	        if(forceRender || this.filterManager.effectElements[4].p._mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p._mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p._mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf){
	            var distance = this.filterManager.effectElements[3].p.v;
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	            var x = distance * Math.cos(angle);
	            var y = distance * Math.sin(angle);
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p._mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	var _svgMatteSymbols = [];
	
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.findSymbol = function(mask) {
	    var i = 0, len = _svgMatteSymbols.length;
	    while(i < len) {
	        if(_svgMatteSymbols[i] === mask) {
	            return _svgMatteSymbols[i];
	        }
	        i += 1;
	    }
	    return null;
	};
	
	SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	    if(!parentNode) {
	        return;
	    }
	    var children = parentNode.children;
	    var i = 0, len = children.length;
	    while (i < len) {
	        if (children[i] === mask.layerElement) {
	            break;
	        }
	        i += 1;
	    }
	    var nextChild;
	    if (i <= len - 2) {
	        nextChild = children[i + 1];
	    }
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	    if(nextChild) {
	        parentNode.insertBefore(useElem, nextChild);
	    } else {
	        parentNode.appendChild(useElem);
	    }
	};
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    if(!this.findSymbol(mask)) {
	        var symbolId = createElementID();
	        var masker = createNS('mask');
	        masker.setAttribute('id', mask.layerId);
	        masker.setAttribute('mask-type', 'alpha');
	        _svgMatteSymbols.push(mask);
	        var defs = elem.globalData.defs;
	        defs.appendChild(masker);
	        var symbol = createNS('symbol');
	        symbol.setAttribute('id', symbolId);
	        this.replaceInParent(mask, symbolId);
	        symbol.appendChild(mask.layerElement);
	        defs.appendChild(symbol);
	        var useElem = createNS('use');
	        useElem.setAttribute('href', '#' + symbolId);
	        masker.appendChild(useElem);
	        mask.data.hd = false;
	        mask.show();
	    }
	    elem.setMatte(mask.layerId);
	};
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0, len = elements.length;
	    while (i < len) {
	    	if (elements[i] && elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	};
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	};
	function SVGEffects(elem){
	    var i, len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        filterManager = null;
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effectsManager.effectElements[i]);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effectsManager.effectElements[i], elem);
	        }
	        if(filterManager) {
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	    if (this.filters.length) {
	        elem.addRenderableComponent(this);
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(_isFirstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(_isFirstFrame);
	    }
	};
	function CVContextData() {
		this.saved = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    this.cO = 1;
	    var i, len = 15;
	    this.savedOp = createTypedArray('float32', len);
	    for(i=0;i<len;i+=1){
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = len;
	}
	
	CVContextData.prototype.duplicate = function() {
		var newLength = this._length * 2;
		var currentSavedOp = this.savedOp;
	    this.savedOp = createTypedArray('float32', newLength);
	    this.savedOp.set(currentSavedOp);
	    var i = 0;
	    for(i = this._length; i < newLength; i += 1) {
	        this.saved[i] = createTypedArray('float32', 16);
	    }
	    this._length = newLength;
	};
	
	CVContextData.prototype.reset = function() {
		this.cArrPos = 0;
		this.cTr.reset();
	    this.cO = 1;
	};
	function CVBaseElement(){
	}
	
	CVBaseElement.prototype = {
	    createElements: function(){},
	    initRendererElement: function(){},
	    createContainerElements: function(){
	        this.canvasContext = this.globalData.canvasContext;
	        this.renderableEffectsManager = new CVEffects(this);
	    },
	    createContent: function(){},
	    setBlendMode: function(){
	        var globalData = this.globalData;
	        if(globalData.blendMode !== this.data.bm) {
	            globalData.blendMode = this.data.bm;
	            var blendModeValue = getBlendMode(this.data.bm);
	            globalData.canvasContext.globalCompositeOperation = blendModeValue;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new CVMaskElement(this.data, this);
	    },
	    hideElement: function(){
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	            this.hidden = true;
	        }
	    },
	    showElement: function(){
	        if (this.isInRange && !this.isTransparent){
	            this.hidden = false;
	            this._isFirstFrame = true;
	            this.maskManager._isFirstFrame = true;
	        }
	    },
	    renderFrame: function() {
	        if (this.hidden || this.data.hd) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.setBlendMode();
	        this.globalData.renderer.save();
	        this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	        this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v);
	        this.renderInnerContent();
	        this.globalData.renderer.restore();
	        if(this.maskManager.hasMasks) {
	            this.globalData.renderer.restore(true);
	        }
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.canvasContext = null;
	        this.data = null;
	        this.globalData = null;
	        this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	};
	CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
	
	function CVImageElement(data, globalData, comp){
	    this.failed = false;
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getImage(this.assetData);
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	
	CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVImageElement.prototype.createContent = function(){
	
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	        var canvas = createTag('canvas');
	        canvas.width = this.assetData.w;
	        canvas.height = this.assetData.h;
	        var ctx = canvas.getContext('2d');
	
	        var imgW = this.img.width;
	        var imgH = this.img.height;
	        var imgRel = imgW / imgH;
	        var canvasRel = this.assetData.w/this.assetData.h;
	        var widthCrop, heightCrop;
	        var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
	        if((imgRel > canvasRel && par === 'xMidYMid slice') || (imgRel < canvasRel && par !== 'xMidYMid slice')) {
	            heightCrop = imgH;
	            widthCrop = heightCrop*canvasRel;
	        } else {
	            widthCrop = imgW;
	            heightCrop = widthCrop/canvasRel;
	        }
	        ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	        this.img = canvas;
	    }
	
	};
	
	CVImageElement.prototype.renderInnerContent = function(parentMatrix){
	    if (this.failed) {
	        return;
	    }
	    this.canvasContext.drawImage(this.img, 0, 0);
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	};
	function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate, this) : {_placeholder:true};
	}
	
	extendPrototype([CanvasRenderer, ICompElement, CVBaseElement], CVCompElement);
	
	CVCompElement.prototype.renderInnerContent = function() {
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.layers = null;
	    this.elements = null;
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i, len = this.masksProperties.length, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            hasMasks = true;
	        }
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);
	    }
	    this.hasMasks = hasMasks;
	    if(hasMasks) {
	        this.element.addRenderableComponent(this);
	    }
	}
	
	CVMaskElement.prototype.renderFrame = function () {
	    if(!this.hasMasks){
	        return;
	    }
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i, len = this.masksProperties.length;
	    var pt,pts,data;
	    ctx.beginPath();
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode !== 'n'){
	            if (this.masksProperties[i].inv) {
	                ctx.moveTo(0, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, 0);
	                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	                ctx.lineTo(0, this.element.globalData.compSize.h);
	                ctx.lineTo(0, 0);
	            }
	            data = this.viewData[i].v;
	            pt = transform.applyToPointArray(data.v[0][0],data.v[0][1],0);
	            ctx.moveTo(pt[0], pt[1]);
	            var j, jLen = data._length;
	            for (j = 1; j < jLen; j++) {
	                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	            }
	            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	    }
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	};
	
	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	}
	
	extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement], CVShapeElement);
	
	CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	
	CVShapeElement.prototype.transformHelper = {opacity:1,_opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createContent = function(){
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data, transforms) {
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        preTransforms: this.transformsManager.addTransformSequence(transforms),
	        transforms: [],
	        elements: [],
	        closed: data.hd === true
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,this);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,this);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,this);
	        elementData.h = PropertyFactory.getProp(this,data.h||{k:0},0,0.01,this);
	        elementData.a = PropertyFactory.getProp(this,data.a||{k:0},0,degToRads,this);
	        elementData.g = new GradientProperty(this,data.g,this);
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,this);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,this);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas');
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	    } else {
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	};
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createTransformElement = function(data) {
	    var elementData = {
	        transform : {
	            opacity: 1,
	            _opMdf:false,
	            key: this.transformsManager.getNewKey(),
	            op: PropertyFactory.getProp(this,data.o,0,0.01,this),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,this)
	        }
	    };
	    return elementData;
	};
	
	CVShapeElement.prototype.createShapeElement = function(data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	};
	
	CVShapeElement.prototype.reloadShapes = function() {
	    this._isFirstFrame = true;
	    var i, len = this.itemsData.length;
	    for (i = 0; i < len; i += 1) {
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData, true, []);
	    len = this.dynamicProperties.length;
	    for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	};
	
	CVShapeElement.prototype.addTransformToStyleList = function(transform) {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.push(transform);
	        }
	    }
	}
	
	CVShapeElement.prototype.removeTransformFromStyleList = function() {
	    var i, len = this.stylesList.length;
	    for (i = 0; i < len; i += 1) {
	        if(!this.stylesList[i].closed) {
	            this.stylesList[i].transforms.pop();
	        }
	    }
	}
	
	CVShapeElement.prototype.closeStyles = function(styles) {
	    var i, len = styles.length, j, jLen;
	    for (i = 0; i < len; i += 1) {
	        styles[i].closed = true;
	    }
	}
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData, shouldRender, transforms){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], processedPos, modifier, currentTransform;
	    var ownTransforms = [].concat(transforms);
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._shouldRender = shouldRender;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'|| arr[i].ty == 'gf'|| arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData, shouldRender, ownTransforms);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                currentTransform = this.createTransformElement(arr[i]);
	                itemsData[i] = currentTransform;
	            }
	            ownTransforms.push(itemsData[i]);
	            this.addTransformToStyleList(itemsData[i]);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i]);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i]);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData);
	                this.shapeModifiers.push(modifier);
	                shouldRender = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.renderInnerContent = function() {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);
	};
	
	CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
	    var props, groupMatrix;
	    if(parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	        groupTransform.opacity = parentTransform.opacity;
	        groupTransform.opacity *= groupTransform.op.v;
	        groupTransform._opMdf = true;
	    }
	};
	
	CVShapeElement.prototype.drawLayer = function() {
	    var i, len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type, currentStyle;
	    for(i=0;i<len;i+=1){
	        currentStyle = this.stylesList[i];
	        type = currentStyle.type;
	
	        //Skipping style when
	        //Stroke width equals 0
	        //style should not be rendered (extra unused repeaters)
	        //current opacity equals 0
	        //global opacity equals 0
	        if(((type === 'st' || type === 'gs') && currentStyle.wi === 0) || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0){
	            continue;
	        }
	        renderer.save();
	        elems = currentStyle.elements;
	        if(type === 'st' || type === 'gs'){
	            ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	            ctx.lineWidth = currentStyle.wi;
	            ctx.lineCap = currentStyle.lc;
	            ctx.lineJoin = currentStyle.lj;
	            ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	            ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }
	        renderer.ctxOpacity(currentStyle.coOp);
	        if(type !== 'st' && type !== 'gs'){
	            ctx.beginPath();
	        }
	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st' || type === 'gs'){
	                ctx.beginPath();
	                if(currentStyle.da){
	                    ctx.setLineDash(currentStyle.da);
	                    ctx.lineDashOffset = currentStyle.do;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;
	
	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);
	                }else{
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st' || type === 'gs'){
	                ctx.stroke();
	                if(currentStyle.da){
	                    ctx.setLineDash(this.dashResetter);
	                }
	            }
	        }
	        if(type !== 'st' && type !== 'gs'){
	            ctx.fill(currentStyle.r);
	        }
	        renderer.restore();
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            this.renderShapeTransform(parentTransform, groupTransform);
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gf' || items[i].ty == 'gs'){
	            this.renderGradientFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(isMain){
	        this.drawLayer();
	    }
	    
	};
	
	CVShapeElement.prototype.renderStyledShape = function(styledShape, shape){
	    if(this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	        var shapeNodes = styledShape.trNodes;
	        var paths = shape.paths;
	        var i, len, j, jLen = paths._length;
	        shapeNodes.length = 0;
	        var groupTransformMat = styledShape.transforms.finalTransform;
	        for (j = 0; j < jLen; j += 1) {
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i === 1) {
	                        shapeNodes.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	                    });
	                }
	                if (len === 1) {
	                    shapeNodes.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    shapeNodes.push({
	                        t: 'c',
	                        pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	                    });
	                    shapeNodes.push({
	                        t: 'z'
	                    });
	                }
	            }
	        }
	        styledShape.trNodes = shapeNodes;
	    }
	}
	
	CVShapeElement.prototype.renderPath = function(pathData,itemData){
	    if(pathData.hd !== true && pathData._shouldRender) {
	        var i, len = itemData.styledShapes.length;
	        for (i = 0; i < len; i += 1) {
	            this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	        }
	    }
	};
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	        styleElem.co = 'rgb(' 
	        + bm_floor(itemData.c.v[0]) + ',' 
	        + bm_floor(itemData.c.v[1]) + ',' 
	        + bm_floor(itemData.c.v[2]) + ')';
	    }
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	        styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderGradientFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    if(!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || (styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf))) {
	        var ctx = this.globalData.canvasContext;
	        var grd;
	        var pt1 = itemData.s.v, pt2 = itemData.e.v;
	        if (styleData.t === 1) {
	            grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	        } else {
	            var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	            var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	
	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99: itemData.h.v;
	            var dist = rad * percent;
	            var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	            var grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	        }
	
	        var i, len = styleData.g.p;
	        var cValues = itemData.g.c;
	        var opacity = 1;
	
	        for (i = 0; i < len; i += 1){
	            if(itemData.g._hasOpacity && itemData.g._collapsable) {
	                opacity = itemData.g.o[i*2 + 1];
	            }
	            grd.addColorStop(cValues[i * 4] / 100,'rgba('+ cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ','+cValues[i * 4 + 3] + ',' + opacity + ')');
	        }
	        styleElem.grd = grd;
	    }
	    styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d._mdf  || this._isFirstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c._mdf || this._isFirstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w._mdf || this._isFirstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	};
	
	
	function CVSolidElement(data, globalData, comp) {
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	
	CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	CVSolidElement.prototype.renderInnerContent = function() {
	    var ctx = this.canvasContext;
	    ctx.fillStyle = this.data.sc;
	    ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	};
	function CVTextElement(data, globalData, comp){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    };
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement], CVTextElement);
	
	CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.finalSize;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = createSizedArray(jLen);
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	};
	
	CVTextElement.prototype.renderInnerContent = function(){
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	};
	function CVEffects() {
	
	}
	CVEffects.prototype.renderFrame = function(){};
	function HBaseElement(data,globalData,comp){}
	HBaseElement.prototype = {
	    checkBlendMode: function(){},
	    initRendererElement: function(){
	        this.baseElement = createTag(this.data.tg || 'div');
	        if(this.data.hasMask) {
	            this.svgElement = createNS('svg');
	            this.layerElement = createNS('g');
	            this.maskedElement = this.layerElement;
	            this.svgElement.appendChild(this.layerElement);
	            this.baseElement.appendChild(this.svgElement);
	        } else {
	            this.layerElement = this.baseElement;
	        }
	        styleDiv(this.baseElement);
	    },
	    createContainerElements: function(){
	        this.renderableEffectsManager = new CVEffects(this);
	        this.transformedElement = this.baseElement;
	        this.maskedElement = this.layerElement;
	        if (this.data.ln) {
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if (this.data.cl) {
	            this.layerElement.setAttribute('class', this.data.cl);
	        }
	        if (this.data.bm !== 0) {
	            this.setBlendMode();
	        }
	    },
	    renderElement: function() {
	        if(this.finalTransform._matMdf){
	            this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = this.finalTransform.mat.toCSS();
	        }
	        if(this.finalTransform._opMdf){
	            this.transformedElement.style.opacity = this.finalTransform.mProp.o.v;
	        }
	    },
	    renderFrame: function() {
	        //If it is exported as hidden (data.hd === true) no need to render
	        //If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	            return;
	        }
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderElement();
	        this.renderInnerContent();
	        if (this._isFirstFrame) {
	            this._isFirstFrame = false;
	        }
	    },
	    destroy: function(){
	        this.layerElement = null;
	        this.transformedElement = null;
	        if(this.matteElement) {
	            this.matteElement = null;
	        }
	        if(this.maskManager) {
	            this.maskManager.destroy();
	            this.maskManager = null;
	        }
	    },
	    createRenderableComponents: function(){
	        this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function(){
	    },
	    setMatte: function(){}
	};
	HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,globalData,comp){
	    this.initElement(data,globalData,comp);
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement], HSolidElement);
	
	HSolidElement.prototype.createContent = function(){
	    var rect;
	    if(this.data.hasMask){
	        rect = createNS('rect');
	        rect.setAttribute('width',this.data.sw);
	        rect.setAttribute('height',this.data.sh);
	        rect.setAttribute('fill',this.data.sc);
	        this.svgElement.setAttribute('width',this.data.sw);
	        this.svgElement.setAttribute('height',this.data.sh);
	    } else {
	        rect = createTag('div');
	        rect.style.width = this.data.sw + 'px';
	        rect.style.height = this.data.sh + 'px';
	        rect.style.backgroundColor = this.data.sc;
	    }
	    this.layerElement.appendChild(rect);
	};
	
	function HCompElement(data,globalData,comp){
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data,globalData,comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this) : {_placeholder:true};
	}
	
	extendPrototype([HybridRenderer, ICompElement, HBaseElement], HCompElement);
	HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
	
	HCompElement.prototype.createContainerElements = function(){
	    this._createBaseContainerElements();
	    //divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        this.svgElement.setAttribute('width',this.data.w);
	        this.svgElement.setAttribute('height',this.data.h);
	        this.transformedElement = this.baseElement;
	    } else {
	        this.transformedElement = this.layerElement;
	    }
	};
	
	HCompElement.prototype.addTo3dContainer = function(elem,pos) {
	    var j = 0;
	    var nextElement;
	    while(j<pos){
	        if(this.elements[j] && this.elements[j].getBaseElement){
	            nextElement = this.elements[j].getBaseElement();
	        }
	        j += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(elem, nextElement);
	    } else {
	        this.layerElement.appendChild(elem);
	    }
	}
	
	function HShapeElement(data,globalData,comp){
	    //List of drawable elements
	    this.shapes = [];
	    // Full shape data
	    this.shapesData = data.shapes;
	    //List of styles that will be applied to shapes
	    this.stylesList = [];
	    //List of modifiers that will be applied to shapes
	    this.shapeModifiers = [];
	    //List of items in shape tree
	    this.itemsData = [];
	    //List of items in previous shape tree
	    this.processedElements = [];
	    // List of animated components
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data,globalData,comp);
	    //Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	    this.prevViewData = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement], HShapeElement);
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
	
	HShapeElement.prototype.createContent = function(){
	    var cont;
	    this.baseElement.style.fontSize = 0;
	    if (this.data.hasMask) {
	        this.layerElement.appendChild(this.shapesContainer);
	        cont = this.svgElement;
	    } else {
	        cont = createNS('svg');
	        var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	        cont.setAttribute('width',size.w);
	        cont.setAttribute('height',size.h);
	        cont.appendChild(this.shapesContainer);
	        this.layerElement.appendChild(cont);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	};
	
	HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
	    var i, len = transformers.length;
	    for(i = 0; i < len; i += 1) {
	        point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	    return point;
	}
	
	HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i, len = shape._length, vPoint, oPoint, nextIPoint, nextVPoint, bounds;
	    if (len <= 1) {
	        return;
	    }
	    for (i = 0; i < len - 1; i += 1) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	    if(shape.c) {
	        vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	        oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	        nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	        nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	        this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	}
	
	HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bm_min(bounds.left, boundingBox.x);
	    boundingBox.xMax = bm_max(bounds.right, boundingBox.xMax);
	    boundingBox.y = bm_min(bounds.top, boundingBox.y);
	    boundingBox.yMax = bm_max(bounds.bottom, boundingBox.yMax);
	}
	
	HShapeElement.prototype.shapeBoundingBox = {
	    left:0,
	    right:0,
	    top:0,
	    bottom:0,
	}
	
	HShapeElement.prototype.tempBoundingBox = {
	    x:0,
	    xMax:0,
	    y:0,
	    yMax:0,
	    width:0,
	    height:0
	}
	
	HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
	
	    var bounds = [[p0[0],p3[0]], [p0[1],p3[1]]];
	
	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	
	      b = b | 0;
	      a = a | 0;
	      c = c | 0;
	
	      if (a === 0) {
	
	        if (b === 0) {
	          continue;
	        }
	
	        t = -c / b;
	
	        if (0 < t && t < 1) {
	          bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));
	        }
	        continue;
	      }
	
	      b2ac = b * b - 4 * c * a;
	
	      if (b2ac < 0) {
	        continue;
	      }
	
	      t1 = (-b + bm_sqrt(b2ac))/(2 * a);
	      if (0 < t1 && t1 < 1) bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));
	
	      t2 = (-b - bm_sqrt(b2ac))/(2 * a);
	      if (0 < t2 && t2 < 1) bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));
	
	    }
	
	    this.shapeBoundingBox.left = bm_min.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bm_min.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bm_max.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bm_max.apply(null, bounds[1]);
	  };
	
	  HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
	    return bm_pow(1-t, 3) * p0[i]
	        + 3 * bm_pow(1-t, 2) * t * p1[i]
	        + 3 * (1-t) * bm_pow(t, 2) * p2[i]
	        + bm_pow(t, 3) * p3[i];
	  }
	
	HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
	    var i, len = itemsData.length, path;
	    for(i = 0; i < len; i += 1) {
	        if(itemsData[i] && itemsData[i].sh) {
	            this.calculateShapeBoundingBox(itemsData[i], boundingBox)
	        } else if(itemsData[i] && itemsData[i].it) {
	            this.calculateBoundingBox(itemsData[i].it, boundingBox)
	        }
	    }
	}
	
	HShapeElement.prototype.currentBoxContains = function(box) {
	    return this.currentBBox.x <= box.x 
	    && this.currentBBox.y <= box.y 
	    && this.currentBBox.width + this.currentBBox.x >= box.x + box.width
	    && this.currentBBox.height + this.currentBBox.y >= box.y + box.height
	}
	
	HShapeElement.prototype.renderInnerContent = function() {
	    this._renderShapeFrame();
	
	    if(!this.hidden && (this._isFirstFrame || this._mdf)) {
	        var tempBoundingBox = this.tempBoundingBox;
	        var max = 999999;
	        tempBoundingBox.x = max;
	        tempBoundingBox.xMax = -max;
	        tempBoundingBox.y = max;
	        tempBoundingBox.yMax = -max;
	        this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	        tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	        tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y;
	        //var tempBoundingBox = this.shapeCont.getBBox();
	        if(this.currentBoxContains(tempBoundingBox)) {
	            return;
	        }
	        var changed = false;
	        if(this.currentBBox.w !== tempBoundingBox.width){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.shapeCont.setAttribute('width',tempBoundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== tempBoundingBox.height){
	            this.currentBBox.h = tempBoundingBox.height;
	            this.shapeCont.setAttribute('height',tempBoundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== tempBoundingBox.x  || this.currentBBox.y !== tempBoundingBox.y){
	            this.currentBBox.w = tempBoundingBox.width;
	            this.currentBBox.h = tempBoundingBox.height;
	            this.currentBBox.x = tempBoundingBox.x;
	            this.currentBBox.y = tempBoundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,globalData,comp){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data,globalData,comp);
	
	}
	extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement], HTextElement);
	
	HTextElement.prototype.createContent = function(){
	    this.isMasked = this.checkMasks();
	    if(this.isMasked){
	        this.renderType = 'svg';
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        this.svgElement.setAttribute('width',this.compW);
	        this.svgElement.setAttribute('height',this.compH);
	        var g = createNS('g');
	        this.maskedElement.appendChild(g);
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = this.layerElement;
	    }
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.finalSize+'px';
	        innerElemStyle.lineHeight = documentData.finalSize+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = createTag('div');
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = createTag('span');
	                    styleDiv(tParent);
	                    tSpan = createTag('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	
	                    //document.body.appendChild is needed to get exact measure of shape
	                    document.body.appendChild(tCont);
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';
	
	                    letters[i].yOffset = boundingBox.y-1;
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	                    tParent.appendChild(tCont);
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.finalSize/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	};
	
	HTextElement.prototype.renderInnerContent = function() {
	
	    if(this.data.singleShape){
	        if(!this._isFirstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform._matMdf){
	                 this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(renderedLetter._mdf.m) {
	            if(!this.isMasked){
	                textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	            }else{
	                textSpan.setAttribute('transform',renderedLetter.m);
	            }
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw && renderedLetter._mdf.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc && renderedLetter._mdf.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc && renderedLetter._mdf.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }
	
	    if(this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)){
	        var boundingBox = this.innerElem.getBBox();
	
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.svgElement.setAttribute('width',boundingBox.width);
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.svgElement.setAttribute('height',boundingBox.height);
	        }
	
	        var margin = 1;
	        if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	            this.currentBBox.w = boundingBox.width + margin*2;
	            this.currentBBox.h = boundingBox.height + margin*2;
	            this.currentBBox.x = boundingBox.x - margin;
	            this.currentBBox.y = boundingBox.y - margin;
	
	            this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.svgElement.style.transform = this.svgElement.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	};
	function HImageElement(data,globalData,comp){
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data,globalData,comp);
	}
	
	extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement], HImageElement);
	
	
	HImageElement.prototype.createContent = function(){
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        this.layerElement.appendChild(this.imageElem);
	        this.baseElement.setAttribute('width',this.assetData.w);
	        this.baseElement.setAttribute('height',this.assetData.h);
	    } else {
	        this.layerElement.appendChild(img);
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.baseElement.setAttribute('id',this.data.ln);
	    }
	};
	function HCameraElement(data,globalData,comp){
	    this.initFrame();
	    this.initBaseData(data,globalData,comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this);
	        this.py = getProp(this,data.ks.p.y,1,0,this);
	        this.pz = getProp(this,data.ks.p.z,1,0,this);
	    }else{
	        this.p = getProp(this,data.ks.p,1,0,this);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true;
	}
	extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        if(comp.type === '3d') {
	            comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	            comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	            comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        }
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var _mdf = this._isFirstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	        }
	    }
	    if(_mdf || this.pe._mdf || (this.p && this.p._mdf) || (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || (this.a && this.a._mdf)) {
	        this.mat.reset();
	
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length - 1;
	            for (i = len; i >= 0; i -= 1) {
	                /*mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                console.log(mat)
	                this.mat.transform(-mat[0],-mat[1],-mat[2],-mat[3],-mat[4],-mat[5],-mat[6],-mat[7],-mat[8],-mat[9],-mat[10],-mat[11],-mat[12],-mat[13],-mat[14],mat[15]);
	                console.log(this.mat.props)*/
	                var mTransf = this.hierarchy[i].finalTransform.mProp;
	                this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);
	                this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	                this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	                this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);
	                this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);
	            }
	        }
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	
	
	        
	
	        var hasMatrixChanged = !this._prevMat.equals(this.mat);
	        if((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	            len = this.comp.threeDElements.length;
	            var comp;
	            for(i=0;i<len;i+=1){
	                comp = this.comp.threeDElements[i];
	                if(comp.type === '3d') {
	                    if(hasMatrixChanged) {
	                        comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	                    }
	                    if(this.pe._mdf) {
	                        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	                    }
	                }
	            }
	            this.mat.clone(this._prevMat);
	        }
	    }
	    this._isFirstFrame = false;
	};
	
	HCameraElement.prototype.prepareFrame = function(num) {
	    this.prepareProperties(num, true);
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	HCameraElement.prototype.initExpressions = function(){};
	HCameraElement.prototype.getBaseElement = function(){return null;};
	function HEffects() {
	}
	HEffects.prototype.renderFrame = function(){};
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function getRegisteredAnimations() {
	        var i, len = registeredAnimations.length;
	        var animations = [];
	        for(i = 0; i < len; i += 1) {
	            animations.push(registeredAnimations[i].animation);
	        }
	        return animations;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	    function resume(nowTime) {
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(playingAnimationsNum && !_isFrozen) {
	            window.requestAnimationFrame(resume);
	        } else {
	            _stopped = true;
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = createTag('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    function activate(){
	        if(!_isFrozen && playingAnimationsNum){
	            if(_stopped) {
	                window.requestAnimationFrame(first);
	                _stopped = false;
	            }
	        }
	    }
	
	    function freeze() {
	        _isFrozen = true;
	    }
	
	    function unfreeze() {
	        _isFrozen = false;
	        activate();
	    }
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    //moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	}());
	
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	};
	
	extendPrototype([BaseEvent], AnimationItem);
	
	AnimationItem.prototype.setParams = function(params) {
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    this.assetsPath = params.assetsPath;
	    if(params.animationData){
	        this.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	
	        assetLoader.load(params.path, this.configAnimation.bind(this), function() {
	            this.trigger('data_failed');
	        }.bind(this));
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.totalFrames;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    assetLoader.load(segmentPath, this.includeLayers.bind(this), function() {
	        this.trigger('data_failed');
	    }.bind(this));
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.totalFrames;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.imagesLoaded = function() {
	    this.trigger('loaded_images');
	    this.checkLoaded()
	}
	
	AnimationItem.prototype.preloadImages = function() {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	}
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    if(!this.renderer){
	        return;
	    }
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.preloadImages();
	    this.loadSegments();
	    this.updaFrameModifier();
	    this.waitForFontsLoaded();
	};
	
	AnimationItem.prototype.waitForFontsLoaded = function(){
	    if(!this.renderer) {
	        return;
	    }
	    if(this.renderer.globalData.fontManager.loaded()){
	        this.checkLoaded();
	    }else{
	        setTimeout(this.waitForFontsLoaded.bind(this),20);
	    }
	}
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.loaded() && (this.imagePreloader.loaded() || this.renderer.rendererType !== 'canvas')) {
	        this.isLoaded = true;
	        dataManager.completeData(this.animationData, this.renderer.globalData.fontManager);
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function() {
	            this.trigger('DOMLoaded');
	        }.bind(this), 0);
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	};
	
	AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.subframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame;
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        this._idle = true;
	        this.trigger('_idle');
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false;
	    // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	        if (!this.loop || this.playCount === this.loop) {
	            if (!this.checkSegments(nextValue >  this.totalFrames ? nextValue % this.totalFrames : 0)) {
	                _isComplete = true;
	                nextValue = this.totalFrames - 1;
	            }
	        } else if (nextValue >= this.totalFrames) {
	            this.playCount += 1;
	            if (!this.checkSegments(nextValue % this.totalFrames)) {
	                this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	                this._completedLoop = true;
	                this.trigger('loopComplete');
	            }
	        } else {
	            this.setCurrentRawFrameValue(nextValue);
	        }
	    } else if(nextValue < 0) {
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	            if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	                this.setCurrentRawFrameValue(this.totalFrames + (nextValue % this.totalFrames));
	                if(!this._completedLoop) {
	                    this._completedLoop = true;
	                } else {
	                    this.trigger('loopComplete');
	                }
	            } else {
	                _isComplete = true;
	                nextValue = 0;
	            }
	        }
	    } else {
	        this.setCurrentRawFrameValue(nextValue);
	    }
	    if (_isComplete) {
	        this.setCurrentRawFrameValue(nextValue);
	        this.pause();
	        this.trigger('complete');
	    }
	};
	
	AnimationItem.prototype.adjustSegment = function(arr, offset){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.timeCompleted = this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0.001 + offset);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init;
	        }
	    }
	
	    this.firstFrame = init;
	    this.timeCompleted = this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	};
	
	AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	        this.segments.length = 0;
	    }
	    if (typeof arr[0] === 'object') {
	        var i, len = arr.length;
	        for (i = 0; i < len; i += 1) {
	            this.segments.push(arr[i]);
	        }
	    } else {
	        this.segments.push(arr);
	    }
	    if (this.segments.length) {
	        this.adjustSegment(this.segments.shift(), 0);
	    }
	    if (this.isPaused) {
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip,this.animationData.op]);
	    //this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if (forceFlag) {
	        this.checkSegments(0);
	    }
	};
	AnimationItem.prototype.checkSegments = function(offset) {
	    if (this.segments.length) {
	        this.adjustSegment(this.segments.shift(), offset);
	        return true;
	    }
	    return false;
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if ((name && this.name != name) || !this.renderer) {
	        return;
	    }
	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(assetData.e) {
	        path = assetData.p;
	    } else if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	
	    	var stackCount = 0;
	    	var registers = [];
	
	    	function pushExpression() {
				stackCount += 1;
	    	}
	
	    	function popExpression() {
				stackCount -= 1;
				if (stackCount === 0) {
					releaseInstances();
				}
	    	}
	
	    	function registerExpressionProperty(expression) {
	    		if (registers.indexOf(expression) === -1) {
					registers.push(expression)
	    		}
	    	}
	
	    	function releaseInstances() {
	    		var i, len = registers.length;
	    		for (i = 0; i < len; i += 1) {
					registers[i].release();
	    		}
	    		registers.length = 0;
	    	}
	
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	        animation.renderer.globalData.pushExpression = pushExpression;
	        animation.renderer.globalData.popExpression = popExpression;
	        animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	var ExpressionManager = (function(){
	    'use strict';
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function $bm_isInstanceOfArray(arr) {
	        return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function isNumerable(tOfV, v) {
	        return tOfV === 'number' || tOfV === 'boolean' || tOfV === 'string' || v instanceof Number;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if($bm_isInstanceOfArray(a)){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    var easeInBez = BezierFactory.getBezierEasing(0.333,0,.833,.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167,0.167,.667,1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(.33,0,.667,1, 'easeInOut').get;
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a + b;
	        }
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] + b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            b = b.slice(0);
	            b[0] = a + b[0];
	            return b;
	        }
	        if($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( $bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            a = a.slice(0);
	            a[0] = a[0] - b;
	            return a;
	        }
	        if(isNumerable(tOfA, a) &&  $bm_isInstanceOfArray(b)){
	            b = b.slice(0);
	            b[0] = a - b[0];
	            return b;
	        }
	        if($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a * b;
	        }
	
	        var i, len;
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if(isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	            return a / b;
	        }
	        var i, len;
	        if($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if(isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1, arr2) {
	        if (typeof arr1 === 'number' || arr1 instanceof Number) {
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2) {
	            arr2 = helperLengthArray;
	        }
	        var i, len = Math.min(arr1.length, arr2.length);
	        var addedLength = 0;
	        for (i = 0; i < len; i += 1) {
	            addedLength += Math.pow(arr2[i] - arr1[i], 2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec) {
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val) {
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	
	    function hue2rgb(p, q, t){
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s === 0){
	            r = g = b = l; // achromatic
	        }else{
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            value1 = tMin;
	            value2 = tMax;
	            tMin = 0;
	            tMax = 1;
	        }
	        if(tMax < tMin) {
	            var _tMin = tMax;
	            tMax = tMin;
	            tMin = _tMin;
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = createTypedArray('float32', len);
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = createTypedArray('float32', len);
	            }
	            var arr = createTypedArray('float32', len);
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i]);
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	        var i, len = points.length;
	        var path = shape_pool.newElement();
	        path.setPathData(!!closed, len);
	        var arrPlaceholder = [0,0], inVertexPoint, outVertexPoint;
	        for(i = 0; i < len; i += 1) {
	            inVertexPoint = (inTangents && inTangents[i]) ? inTangents[i] : arrPlaceholder;
	            outVertexPoint = (outTangents && outTangents[i]) ? outTangents[i] : arrPlaceholder;
	            path.setTripleAt(points[i][0],points[i][1],outVertexPoint[0] + points[i][0],outVertexPoint[1] + points[i][1],inVertexPoint[0] + points[i][0],inVertexPoint[1] + points[i][1],i,true);
	        }
	        return path;
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,$bm_transform,content,effect;
	        var thisProperty = property;
	        thisProperty.valueAtTime = thisProperty.getValueAtTime;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        elem.comp.displayStartTime = 0;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var name = elem.data.nm;
	        var loopIn, loop_in, loopOut, loop_out;
	        var toWorld,fromWorld,fromComp,toComp,fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
	        var __expression_functions = [];
	        if(data.xf) {
	            var i, len = data.xf.length;
	            for(i = 0; i < len; i += 1) {
	                __expression_functions[i] = eval('(function(){ return ' + data.xf[i] + '}())');
	            }
	        }
	
	        var scoped_bm_rt;
	        var expression_function = eval('[function _expression_function(){' + val+';scoped_bm_rt=$bm_rt}' + ']')[0];
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var active = !this.data || this.data.hd !== true;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        if(thisProperty.loopIn) {
	            loopIn = thisProperty.loopIn.bind(thisProperty);
	            loop_in = loopIn;
	        }
	
	        if(thisProperty.loopOut) {
	            loopOut = thisProperty.loopOut.bind(thisProperty);
	            loop_out = loopOut;
	        }
	
	        function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }
	
	        function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }
	
	        if(this.getValueAtTime) {
	            valueAtTime = this.getValueAtTime.bind(this);
	        }
	
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        }
	
	        function easeOut(t, tMin, tMax, val1, val2){
	            return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	        }
	
	        function easeIn(t, tMin, tMax, val1, val2){
	            return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	        }
	
	        function ease(t, tMin, tMax, val1, val2){
	            return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	        }
	
	        function applyEase(fn, t, tMin, tMax, val1, val2) {
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            t = t > 1 ? 1 : t < 0 ? 0 : t;
	            var mult = fn(t);
	            if($bm_isInstanceOfArray(val1)) {
	                var i, len = val1.length;
	                var arr = createTypedArray('float32', len);
	                for (i = 0; i < len; i += 1) {
	                    arr[i] = (val2[i] - val1[i]) * mult + val1[i];
	                }
	                return arr;
	            } else {
	                return (val2 - val1) * mult + val1;
	            }
	        }
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        }
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        }
	
	        function framesToTime(frames, fps) { 
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames / fps;
	        }
	
	        function timeToFrames(t, fps) {
	            if (!t && t !== 0) {
	                t = time;
	            }
	            if (!fps) {
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t * fps;
	        }
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        }
	
	        function sourceRectAtTime() {
	            return elem.sourceRectAtTime();
	        }
	
	        function substring(init, end) {
	            if(typeof value === 'string') {
	                if(end === undefined) {
	                return value.substring(init)
	                }
	                return value.substring(init, end)
	            }
	            return '';
	        }
	
	        function substr(init, end) {
	            if(typeof value === 'string') {
	                if(end === undefined) {
	                return value.substr(init)
	                }
	                return value.substr(init, end)
	            }
	            return '';
	        }
	
	        var time, velocity, value, text, textIndex, textTotal, selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        var globalData = elem.globalData;
	        function executeExpression(_value) {
	            // globalData.pushExpression();
	            value = _value;
	            if (_needsRandom) {
	                seedRandom(randSeed);
	            }
	            if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	                return value;
	            }
	            if(this.propType === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if (!thisLayer) {
	                text = elem.layerInterface.text;
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	                fromComp = thisLayer.fromComp.bind(thisLayer);
	                toComp = thisLayer.toComp.bind(thisLayer);
	                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	                fromCompToSurface = fromComp;
	            }
	            if (!transform) {
	                transform = elem.layerInterface("ADBE Transform Group");
	                $bm_transform = transform;
	                if(transform) {
	                    anchorPoint = transform.anchorPoint;
	                    /*position = transform.position;
	                    rotation = transform.rotation;
	                    scale = transform.scale;*/
	                }
	            }
	            
	            if (elemType === 4 && !content) {
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if (!effect) {
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if (hasParent && !parent) {
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if (needsVelocity) {
	                velocity = velocityAtTime(time);
	            }
	            expression_function();
	            this.frameExpressionId = elem.globalData.frameId;
	
	
	            //TODO: Check if it's possible to return on ShapeInterface the .v value
	            if (scoped_bm_rt.propType === "shape") {
	                scoped_bm_rt = scoped_bm_rt.v;
	            }
	            // globalData.popExpression();
	            return scoped_bm_rt;
	        }
	        return executeExpression;
	    }
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type ? type.toLowerCase() : '';
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function getValueAtTime(frameNum) {
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	            this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;
	
	    }
	
	    function getSpeedAtTime(frameNum) {
	        var delta = -0.01;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var speed = 0;
	        if(v1.length){
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                speed += Math.pow(v2[i] - v1[i], 2);
	            }
	            speed = Math.sqrt(speed) * 100;
	        } else {
	            speed = 0;
	        }
	        return speed;
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.001;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    }
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            prop.initiateExpression = ExpressionManager.initiateExpression;
	            prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        console.warn('Transform at time not supported');
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = 0.01;
	            this.propType = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        };
	    }());
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
	        var prop = getTransformProperty(elem, data, container);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        return prop;
	    };
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, container){
	        var prop = propertyGetProp(elem,data,type, mult, container);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.getVelocityAtTime = getVelocityAtTime.bind(prop);
	        prop.getSpeedAtTime = getSpeedAtTime.bind(prop);
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        prop.propertyIndex = data.ix;
	        var value = 0;
	        if(type !== 0) {
	            value = createTypedArray('float32', data.a === 1 ?  data.k[0].s.length : data.k.length);
	        }
	        prop._cachingAtTime = {
	            lastFrame: initialDefaultFrame,
	            lastIndex: 0,
	            value: value
	        };
	        searchExpressions(elem,data,prop);
	        if(prop.k){
	            container.addDynamicProperty(prop);
	        }
	
	        return prop;
	    };
	
	    function getShapeValueAtTime(frameNum) {
	        //For now this caching object is created only when needed instead of creating it when the shape is initialized.
	        if (!this._cachingAtTime) {
	            this._cachingAtTime = {
	                shapeValue: shape_pool.clone(this.pv),
	                lastIndex: 0,
	                lastTime: initialDefaultFrame
	            };
	        }
	        
	        frameNum *= this.elem.globalData.frameRate;
	        frameNum -= this.offsetTime;
	        if(frameNum !== this._cachingAtTime.lastTime) {
	            this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	            this._cachingAtTime.lastTime = frameNum;
	            this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	        }
	        return this._cachingAtTime.shapeValue;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    function ShapeExpressions(){}
	    ShapeExpressions.prototype = {
	        vertices: function(prop, time){
	            if (this.k) {
	                this.getValue();
	            }
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            var i, len = shapePath._length;
	            var vertices = shapePath[prop];
	            var points = shapePath.v;
	            var arr = createSizedArray(len);
	            for(i = 0; i < len; i += 1) {
	                if(prop === 'i' || prop === 'o') {
	                    arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	                } else {
	                    arr[i] = [vertices[i][0], vertices[i][1]];
	                }
	                
	            }
	            return arr;
	        },
	        points: function(time){
	            return this.vertices('v', time);
	        },
	        inTangents: function(time){
	            return this.vertices('i', time);
	        },
	        outTangents: function(time){
	            return this.vertices('o', time);
	        },
	        isClosed: function(){
	            return this.v.c;
	        },
	        pointOnPath: function(perc, time){
	            var shapePath = this.v;
	            if(time !== undefined) {
	                shapePath = this.getValueAtTime(time, 0);
	            }
	            if(!this._segmentsLength) {
	                this._segmentsLength = bez.getSegmentsLength(shapePath);
	            }
	
	            var segmentsLength = this._segmentsLength;
	            var lengths = segmentsLength.lengths;
	            var lengthPos = segmentsLength.totalLength * perc;
	            var i = 0, len = lengths.length;
	            var j = 0, jLen;
	            var accumulatedLength = 0, pt;
	            while(i < len) {
	                if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                    var initIndex = i;
	                    var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                    var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                    pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	                    break;
	                } else {
	                    accumulatedLength += lengths[i].addedLength;
	                }
	                i += 1;
	            }
	            if(!pt){
	                pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];
	            }
	            return pt;
	        },
	        vectorOnPath: function(perc, time, vectorType){
	            //perc doesn't use triple equality because it can be a Number object as well as a primitive.
	            perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	            var pt1 = this.pointOnPath(perc, time);
	            var pt2 = this.pointOnPath(perc + 0.001, time);
	            var xLength = pt2[0] - pt1[0];
	            var yLength = pt2[1] - pt1[1];
	            var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	            var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	            return unitVector;
	        },
	        tangentOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'tangent');
	        },
	        normalOnPath: function(perc, time){
	            return this.vectorOnPath(perc, time, 'normal');
	        },
	        setGroupProperty: setGroupProperty,
	        getValueAtTime: getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        prop.propertyIndex = data.ix;
	        prop.lock = false;
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(prop.k){
	            elem.addDynamicProperty(prop);
	        }
	        return prop;
	    };
	
	    var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
	    TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    };
	}());
	(function addDecorator() {
	
	    function searchExpressions(){
	        if(this.data.d.x){
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.addEffect(this.getExpressionValue.bind(this));
	            return true;
	        }
	    }
	
	    TextProperty.prototype.getExpressionValue = function(currentValue, text) {
	        var newValue = this.calculateExpression(text);
	        if(currentValue.t !== newValue) {
	            var newData = {};
	            this.copyData(newData, currentValue);
	            newData.t = newValue.toString();
	            newData.__complete = false;
	            return newData;
	        }
	        return currentValue;
	    }
	
	    TextProperty.prototype.searchProperty = function(){
	
	        var isKeyframed = this.searchKeyframes();
	        var hasExpressions = this.searchExpressions();
	        this.kf = isKeyframed || hasExpressions;
	        return this.kf;
	    };
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ShapeExpressionInterface = (function(){
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(pathInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));
	            }
	        }
	        return arr;
	    }
	
	    function contentsInterfaceFactory(shape,view, propertyGroup){
	       var interfaces;
	       var interfaceFunction = function _interfaceFunction(value){
	           var i = 0, len = interfaces.length;
	            while(i<len){
	                if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                   return interfaces[i];
	                }
	                i+=1;
	            }
	            if(typeof value === 'number'){
	               return interfaces[value-1];
	            }
	       };
	       interfaceFunction.propertyGroup = function(val){
	           if(val === 1){
	               return interfaceFunction;
	           } else{
	               return propertyGroup(val-1);
	           }
	       };
	       interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	       interfaceFunction.numProperties = interfaces.length;
	       interfaceFunction.propertyIndex = shape.cix;
	       interfaceFunction._name = shape.nm;
	
	       return interfaceFunction;
	   }
	
	    function groupInterfaceFactory(shape,view, propertyGroup){
	        var interfaceFunction = function _interfaceFunction(value){
	            switch(value){
	                case 'ADBE Vectors Group':
	                case 'Contents':
	                case 2:
	                    return interfaceFunction.content;
	                //Not necessary for now. Keeping them here in case a new case appears
	                //case 'ADBE Vector Transform Group':
	                //case 3:
	                default:
	                    return interfaceFunction.transform;
	            }
	        };
	        interfaceFunction.propertyGroup = function(val){
	            if(val === 1){
	                return interfaceFunction;
	            } else{
	                return propertyGroup(val-1);
	            }
	        };
	        var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	        var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	        interfaceFunction.content = content;
	        interfaceFunction.transform = transformInterface;
	        Object.defineProperty(interfaceFunction, '_name', {
	            get: function(){
	                return shape.nm;
	            }
	        });
	        //interfaceFunction.content = interfaceFunction;
	        interfaceFunction.numProperties = shape.np;
	        interfaceFunction.propertyIndex = shape.ix;
	        interfaceFunction.nm = shape.nm;
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function fillInterfaceFactory(shape,view,propertyGroup){
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(propertyGroup);
	        view.o.setGroupProperty(propertyGroup);
	        return interfaceFunction;
	    }
	
	    function strokeInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val === 1){
	                return ob;
	            } else{
	                return propertyGroup(val-1);
	            }
	        }
	        function _dashPropertyGroup(val){
	            if(val === 1){
	                return dashOb;
	            } else{
	                return _propertyGroup(val-1);
	            }
	        }
	        function addPropertyToDashOb(i) {
	            Object.defineProperty(dashOb, shape.d[i].nm, {
	                get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	            });
	        }
	        var i, len = shape.d ? shape.d.length : 0;
	        var dashOb = {};
	        for (i = 0; i < len; i += 1) {
	            addPropertyToDashOb(i);
	            view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	        }
	
	        function interfaceFunction(val){
	            if(val === 'Color' || val === 'color'){
	                return interfaceFunction.color;
	            } else if(val === 'Opacity' || val === 'opacity'){
	                return interfaceFunction.opacity;
	            } else if(val === 'Stroke Width' || val === 'stroke width'){
	                return interfaceFunction.strokeWidth;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'color': {
	                get: ExpressionPropertyInterface(view.c)
	            },
	            'opacity': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            'strokeWidth': {
	                get: ExpressionPropertyInterface(view.w)
	            },
	            'dash': {
	                get: function() {
	                    return dashOb;
	                }
	            },
	            '_name': { value: shape.nm },
	            'mn': { value: shape.mn }
	        });
	
	        view.c.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	        view.w.setGroupProperty(_propertyGroup);
	        return interfaceFunction;
	    }
	
	    function trimInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        view.s.setGroupProperty(_propertyGroup);
	        view.e.setGroupProperty(_propertyGroup);
	        view.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === shape.e.ix || val === 'End' || val === 'end'){
	                return interfaceFunction.end;
	            }
	            if(val === shape.s.ix){
	                return interfaceFunction.start;
	            }
	            if(val === shape.o.ix){
	                return interfaceFunction.offset;
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	
	        Object.defineProperties(interfaceFunction, {
	            'start': {
	                get: ExpressionPropertyInterface(view.s)
	            },
	            'end': {
	                get: ExpressionPropertyInterface(view.e)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(view.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function transformInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        view.transform.mProps.o.setGroupProperty(_propertyGroup);
	        view.transform.mProps.p.setGroupProperty(_propertyGroup);
	        view.transform.mProps.a.setGroupProperty(_propertyGroup);
	        view.transform.mProps.s.setGroupProperty(_propertyGroup);
	        view.transform.mProps.r.setGroupProperty(_propertyGroup);
	        if(view.transform.mProps.sk){
	            view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	            view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	        }
	        view.transform.op.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.a.ix === value || value === 'Anchor Point'){
	                return interfaceFunction.anchorPoint;
	            }
	            if(shape.o.ix === value || value === 'Opacity'){
	                return interfaceFunction.opacity;
	            }
	            if(shape.p.ix === value || value === 'Position'){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation'){
	                return interfaceFunction.rotation;
	            }
	            if(shape.s.ix === value || value === 'Scale'){
	                return interfaceFunction.scale;
	            }
	            if(shape.sk && shape.sk.ix === value || value === 'Skew'){
	                return interfaceFunction.skew;
	            }
	            if(shape.sa && shape.sa.ix === value || value === 'Skew Axis'){
	                return interfaceFunction.skewAxis;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'opacity': {
	                get: ExpressionPropertyInterface(view.transform.mProps.o)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(view.transform.mProps.p)
	            },
	            'anchorPoint': {
	                get: ExpressionPropertyInterface(view.transform.mProps.a)
	            },
	            'scale': {
	                get: ExpressionPropertyInterface(view.transform.mProps.s)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(view.transform.mProps.r)
	            },
	            'skew': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sk)
	            },
	            'skewAxis': {
	                get: ExpressionPropertyInterface(view.transform.mProps.sa)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.ty = 'tr';
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function ellipseInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        interfaceFunction.propertyIndex = shape.ix;
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.s.ix === value){
	                return interfaceFunction.size;
	            }
	        }
	
	        Object.defineProperties(interfaceFunction, {
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function starInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.or.setGroupProperty(_propertyGroup);
	        prop.os.setGroupProperty(_propertyGroup);
	        prop.pt.setGroupProperty(_propertyGroup);
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	        if(shape.ir){
	            prop.ir.setGroupProperty(_propertyGroup);
	            prop.is.setGroupProperty(_propertyGroup);
	        }
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.rotation;
	            }
	            if(shape.pt.ix === value){
	                return interfaceFunction.points;
	            }
	            if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                return interfaceFunction.outerRadius;
	            }
	            if(shape.os.ix === value){
	                return interfaceFunction.outerRoundness;
	            }
	            if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                return interfaceFunction.innerRadius;
	            }
	            if(shape.is && shape.is.ix === value){
	                return interfaceFunction.innerRoundness;
	            }
	
	        }
	
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'rotation': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'points': {
	                get: ExpressionPropertyInterface(prop.pt)
	            },
	            'outerRadius': {
	                get: ExpressionPropertyInterface(prop.or)
	            },
	            'outerRoundness': {
	                get: ExpressionPropertyInterface(prop.os)
	            },
	            'innerRadius': {
	                get: ExpressionPropertyInterface(prop.ir)
	            },
	            'innerRoundness': {
	                get: ExpressionPropertyInterface(prop.is)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function rectInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.p.setGroupProperty(_propertyGroup);
	        prop.s.setGroupProperty(_propertyGroup);
	        prop.r.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.p.ix === value){
	                return interfaceFunction.position;
	            }
	            if(shape.r.ix === value){
	                return interfaceFunction.roundness;
	            }
	            if(shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size'){
	                return interfaceFunction.size;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'position': {
	                get: ExpressionPropertyInterface(prop.p)
	            },
	            'roundness': {
	                get: ExpressionPropertyInterface(prop.r)
	            },
	            'size': {
	                get: ExpressionPropertyInterface(prop.s)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function roundedInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.rd.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.r.ix === value || 'Round Corners 1' === value){
	                return interfaceFunction.radius;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'radius': {
	                get: ExpressionPropertyInterface(prop.rd)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function repeaterInterfaceFactory(shape,view,propertyGroup){
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        var prop = view;
	        interfaceFunction.propertyIndex = shape.ix;
	        prop.c.setGroupProperty(_propertyGroup);
	        prop.o.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(value){
	            if(shape.c.ix === value || 'Copies' === value){
	                return interfaceFunction.copies;
	            } else if(shape.o.ix === value || 'Offset' === value){
	                return interfaceFunction.offset;
	            }
	
	        }
	        Object.defineProperties(interfaceFunction, {
	            'copies': {
	                get: ExpressionPropertyInterface(prop.c)
	            },
	            'offset': {
	                get: ExpressionPropertyInterface(prop.o)
	            },
	            '_name': { value: shape.nm }
	        });
	        interfaceFunction.mn = shape.mn;
	        return interfaceFunction;
	    }
	
	    function pathInterfaceFactory(shape,view,propertyGroup){
	        var prop = view.sh;
	        function _propertyGroup(val){
	            if(val == 1){
	                return interfaceFunction;
	            } else {
	                return propertyGroup(--val);
	            }
	        }
	        prop.setGroupProperty(_propertyGroup);
	
	        function interfaceFunction(val){
	            if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                return interfaceFunction.path;
	            }
	        }
	        Object.defineProperties(interfaceFunction, {
	            'path': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            'shape': {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                }
	            },
	            '_name': { value: shape.nm },
	            'ix': { value: shape.ix },
	            'mn': { value: shape.mn }
	        });
	        return interfaceFunction;
	    }
	
	    return function(shapes,view,propertyGroup) {
	        var interfaces;
	        function _interfaceFunction(value){
	            if(typeof value === 'number'){
	                return interfaces[value-1];
	            } else {
	                var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value){
	                        return interfaces[i];
	                    }
	                    i+=1;
	                }
	            }
	        }
	        _interfaceFunction.propertyGroup = propertyGroup;
	        interfaces = iterateElements(shapes, view, _interfaceFunction);
	        return _interfaceFunction;
	    };
	}());
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                elem.textProperty.getValue()
	                var stringValue = elem.textProperty.currentData.t;
	                if(stringValue !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    };
	}());
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	    function sampleImage() {
	        return [1,1,1,1];
	    }
	
	
	    return function(elem){
	
	        var transformInterface;
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                case "effects":
	                case "Effects":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sampleImage = sampleImage;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperties(_thisLayerFunction,{
	            hasParent: {
	                get: function(){
	                    return elem.hierarchy.length;
	                }
	            },
	            parent: {
	                get: function(){
	                    return elem.hierarchy[0].layerInterface;
	                }
	            },
	            rotation: getDescriptor(transformInterface, 'rotation'),
	            scale: getDescriptor(transformInterface, 'scale'),
	            position: getDescriptor(transformInterface, 'position'),
	            opacity: getDescriptor(transformInterface, 'opacity'),
	            anchorPoint: anchorPointDescriptor,
	            anchor_point: anchorPointDescriptor,
	            transform: {
	                get: function () {
	                    return transformInterface;
	                }
	            },
	            active: {
	                get: function(){
	                    return elem.isInRange;
	                }
	            }
	        });
	
	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	        _thisLayerFunction.inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        _thisLayerFunction.outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        _thisLayerFunction._name = elem.data.nm;
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    };
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return null;
	            //return {active:false};
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        _thisLayerFunction.displayStartTime = 0;
	        _thisLayerFunction.numLayers = comp.layers.length;
	        return _thisLayerFunction;
	    };
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "ADBE Rotate X":
	                    return _thisFunction.xRotation;
	                case "ADBE Rotate Y":
	                    return _thisFunction.yRotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case 'ADBE Position_0':
	                    return _thisFunction.xPosition;
	                case 'ADBE Position_1':
	                    return _thisFunction.yPosition;
	                case 'ADBE Position_2':
	                    return _thisFunction.zPosition;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: ExpressionPropertyInterface(transform.r || transform.rz)
	        });
	
	        Object.defineProperty(_thisFunction, "zRotation", {
	            get: ExpressionPropertyInterface(transform.rz || transform.r)
	        });
	
	        Object.defineProperty(_thisFunction, "xRotation", {
	            get: ExpressionPropertyInterface(transform.rx)
	        });
	
	        Object.defineProperty(_thisFunction, "yRotation", {
	            get: ExpressionPropertyInterface(transform.ry)
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: ExpressionPropertyInterface(transform.s)
	        });
	
	        if(transform.p) {
	            var _transformFactory = ExpressionPropertyInterface(transform.p);
	        }
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return _transformFactory();
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                }
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: ExpressionPropertyInterface(transform.px)
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: ExpressionPropertyInterface(transform.py)
	        });
	
	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: ExpressionPropertyInterface(transform.pz)
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: ExpressionPropertyInterface(transform.a)
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: ExpressionPropertyInterface(transform.o)
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: ExpressionPropertyInterface(transform.sk)
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: ExpressionPropertyInterface(transform.sa)
	        });
	
	        Object.defineProperty(_thisFunction, "orientation", {
	            get: ExpressionPropertyInterface(transform.or)
	        });
	
	        return _thisFunction;
	    };
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	                        this.compositions[i].prepareFrame(this.currentFrame);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    };
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effectsManager){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effectsManager.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef || [], i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            };
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }
	
	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else{
	               return propertyGroup(val-1);
	            }
	        }
	
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        };
	
	        groupInterface.propertyGroup = _propertyGroup;
	
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = groupInterface.enabled = data.en !== 0;
	        return groupInterface;
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup){
	        var expressionProperty = ExpressionPropertyInterface(element.p);
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return expressionProperty();
	        }
	
	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }
	
	        return interfaceFunction;
	    }
	
	    return ob;
	
	}());
	var MaskManagerInterface = (function(){
	
		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	                if(this._mask.prop.k){
	                    this._mask.prop.getValue();
	                }
	                return this._mask.prop;
	            }
	        });
	
		var MaskManager = function(maskManager, elem){
			var _maskManager = maskManager;
			var _elem = elem;
			var _masksInterfaces = createSizedArray(maskManager.viewData.length);
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}
	
			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			};
			return maskFunction;
		};
		return MaskManager;
	}());
	
	var ExpressionPropertyInterface = (function() {
	
	    var defaultUnidimensionalValue = {pv:0, v:0, mult: 1}
	    var defaultMultidimensionalValue = {pv:[0,0,0], v:[0,0,0], mult: 1}
	
	    function completeProperty(expressionValue, property, type) {
	        Object.defineProperty(expressionValue, 'velocity', {
	            get: function(){
	                return property.getVelocityAtTime(property.comp.currentFrame);
	            }
	        });
	        expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                var value = '';
	                if ('s' in property.keyframes[pos-1]) {
	                    value = property.keyframes[pos-1].s;
	                } else if ('e' in property.keyframes[pos-2]) {
	                    value = property.keyframes[pos-2].e;
	                } else {
	                    value = property.keyframes[pos-2].s;
	                }
	                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value);
	                valueProp.time = property.keyframes[pos-1].t / property.elem.comp.globalData.frameRate;
	                return valueProp;
	            }
	        };
	        expressionValue.valueAtTime = property.getValueAtTime;
	        expressionValue.speedAtTime = property.getSpeedAtTime;
	        expressionValue.velocityAtTime = property.getVelocityAtTime;
	        expressionValue.propertyGroup = property.propertyGroup;
	    }
	
	    function UnidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultUnidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var val = property.pv * mult;
	        var expressionValue = new Number(val);
	        expressionValue.value = val;
	        completeProperty(expressionValue, property, 'unidimensional');
	
	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            val = property.v * mult;
	            if(expressionValue.value !== val) {
	                expressionValue = new Number(val);
	                expressionValue.value = val;
	                completeProperty(expressionValue, property, 'unidimensional');
	            }
	            return expressionValue;
	        }
	    }
	
	    function MultidimensionalPropertyInterface(property) {
	        if(!property || !('pv' in property)) {
	            property = defaultMultidimensionalValue;
	        }
	        var mult = 1 / property.mult;
	        var len = property.pv.length;
	        var expressionValue = createTypedArray('float32', len);
	        var arrValue = createTypedArray('float32', len);
	        expressionValue.value = arrValue;
	        completeProperty(expressionValue, property, 'multidimensional');
	
	        return function() {
	            if (property.k) {
	                property.getValue();
	            }
	            for (var i = 0; i < len; i += 1) {
	                expressionValue[i] = arrValue[i] = property.v[i] * mult;
	            }
	            return expressionValue;
	        }
	    }
	
	    //TODO: try to avoid using this getter
	    function defaultGetter() {
	        return defaultUnidimensionalValue;
	    }
	    
	    return function(property) {
	        if(!property) {
	            return defaultGetter;
	        } else if (property.propType === 'unidimensional') {
	            return UnidimensionalPropertyInterface(property);
	        } else {
	            return MultidimensionalPropertyInterface(property);
	        }
	    }
	}())
	
	function SliderEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function AngleEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function ColorEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function PointEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,container);
	}
	function LayerIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function MaskIndexEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function CheckboxEffect(data,elem, container){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,container);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(){}
	function EffectsManager(data,element){
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element){
	    this.init(data,element);
	}
	
	extendPrototype([DynamicPropertyContainer], GroupEffect);
	
	GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
	
	GroupEffect.prototype.init = function(data,element){
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        eff = null;
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,this);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,this);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,this);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,this);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,this);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,this);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,this);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,this);
	                break;
	            //case 6:
	            default:
	                eff = new NoValueEffect(effects[i],element,this);
	                break;
	        }
	        if(eff) {
	            this.effectElements.push(eff);
	        }
	    }
	};
	
	    var lottiejs = {};
	
	    var _isFrozen = false;
	
	    function setLocationHref (href) {
	        locationHref = href;
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	
	    lottiejs.play = animationManager.play;
	    lottiejs.pause = animationManager.pause;
	    lottiejs.setLocationHref = setLocationHref;
	    lottiejs.togglePause = animationManager.togglePause;
	    lottiejs.setSpeed = animationManager.setSpeed;
	    lottiejs.setDirection = animationManager.setDirection;
	    lottiejs.stop = animationManager.stop;
	    lottiejs.searchAnimations = searchAnimations;
	    lottiejs.registerAnimation = animationManager.registerAnimation;
	    lottiejs.loadAnimation = loadAnimation;
	    lottiejs.setSubframeRendering = setSubframeRendering;
	    lottiejs.resize = animationManager.resize;
	    //lottiejs.start = start;
	    lottiejs.goToAndStop = animationManager.goToAndStop;
	    lottiejs.destroy = animationManager.destroy;
	    lottiejs.setQuality = setQuality;
	    lottiejs.inBrowser = inBrowser;
	    lottiejs.installPlugin = installPlugin;
	    lottiejs.freeze = animationManager.freeze;
	    lottiejs.unfreeze = animationManager.unfreeze;
	    lottiejs.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	    lottiejs.__getFactory = getFactory;
	    lottiejs.version = '5.4.3';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return lottiejs;
	}));


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by joe on 16/9/6.
	 */
	
	module.exports = __webpack_require__(618);


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by joe on 16/9/2.
		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
		var DragScroll = function (_React$Component) {
		  _inherits(DragScroll, _React$Component);
	
		  function DragScroll(props) {
		    _classCallCheck(this, DragScroll);
	
		    var _this = _possibleConstructorReturn(this, (DragScroll.__proto__ || Object.getPrototypeOf(DragScroll)).call(this, props));
	
		    _this.state = {
		      data: props.dataSource,
		      dragging: false
		    };
		    return _this;
		  }
	
		  _createClass(DragScroll, [{
		    key: "render",
		    value: function render() {
		      var sytle = null;
		      if (this.props.height && this.props.width) {
		        sytle = { style: { height: this.props.height, width: this.props.width, overflow: 'auto' } };
		      }
		      return _react2.default.createElement(
		        "div",
		        _extends({ className: this.props.className }, sytle, {
		          onMouseUp: this.mouseUpHandle.bind(this),
		          onMouseMove: this.mouseMoveHandle.bind(this),
		          ref: "container" }),
		        this.props.children && this.renderChildren(this.props.children)
		      );
		    }
		  }, {
		    key: "componentDidMount",
		    value: function componentDidMount() {
		      window.addEventListener('mouseup', this.mouseUpHandle.bind(this));
		      window.addEventListener('mousemove', this.mouseMoveHandle.bind(this));
		    }
		  }, {
		    key: "componentWillUnmount",
		    value: function componentWillUnmount() {
		      window.removeEventListener('mouseup', this.mouseUpHandle.bind(this));
		      window.removeEventListener('mousemove', this.mouseMoveHandle.bind(this));
		    }
		  }, {
		    key: "mouseUpHandle",
		    value: function mouseUpHandle(e) {
		      if (this.state.dragging) {
		        this.state.dragging = false;
		        this.setState(this.state);
		      }
		    }
		  }, {
		    key: "mouseDownHandle",
		    value: function mouseDownHandle(e) {
		      if (!this.state.dragging) {
		        this.state.dragging = true;
		        this.setState(this.state);
		        this.lastClientX = e.clientX;
		        this.lastClientY = e.clientY;
		        e.preventDefault();
		      }
		    }
		  }, {
		    key: "mouseMoveHandle",
		    value: function mouseMoveHandle(e) {
		      if (this.state.dragging) {
		        this.refs.container.scrollLeft -= -this.lastClientX + (this.lastClientX = e.clientX);
		        this.refs.container.scrollTop -= -this.lastClientY + (this.lastClientY = e.clientY);
		      }
		    }
		  }, {
		    key: "renderChildren",
		    value: function renderChildren(dom, type) {
		      var _this2 = this;
	
		      if (this.isArray(dom)) {
		        return dom.map(function (item, index) {
		          return _react2.default.cloneElement(item, {
		            key: item.key || index,
		            onMouseUp: _this2.mouseUpHandle.bind(_this2),
		            onMouseDown: _this2.mouseDownHandle.bind(_this2)
		          });
		        });
		      } else if ('object' == (typeof dom === "undefined" ? "undefined" : _typeof(dom))) {
		        return _react2.default.cloneElement(dom, {
		          onMouseUp: this.mouseUpHandle.bind(this),
		          onMouseDown: this.mouseDownHandle.bind(this)
		        });
		      }
		    }
		  }, {
		    key: "isArray",
		    value: function isArray(object) {
		      return object && (typeof object === "undefined" ? "undefined" : _typeof(object)) === 'object' && typeof object.length === 'number' && typeof object.splice === 'function' &&
		      //判断length属性是否是可枚举的 对于数组 将得到false
		      !object.propertyIsEnumerable('length');
		    }
		  }]);
	
		  return DragScroll;
		}(_react2.default.Component);
	
		exports.default = DragScroll;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(27);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(8);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(9);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lottieWeb = __webpack_require__(139);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lottie = function (_React$Component) {
	  (0, _inherits3.default)(Lottie, _React$Component);
	
	  function Lottie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Lottie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickToPause = function () {
	      // The pause() method is for handling pausing by passing a prop isPaused
	      // This method is for handling the ability to pause by clicking on the animation
	      if (_this.anim.isPaused) {
	        _this.anim.play();
	      } else {
	        _this.anim.pause();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Lottie, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          options = _props.options,
	          eventListeners = _props.eventListeners;
	      var loop = options.loop,
	          autoplay = options.autoplay,
	          animationData = options.animationData,
	          rendererSettings = options.rendererSettings,
	          segments = options.segments;
	
	
	      this.options = {
	        container: this.el,
	        renderer: 'svg',
	        loop: loop !== false,
	        autoplay: autoplay !== false,
	        segments: segments !== false,
	        animationData: animationData,
	        rendererSettings: rendererSettings
	      };
	
	      this.options = (0, _extends3.default)({}, this.options, options);
	
	      this.anim = _lottieWeb2.default.loadAnimation(this.options);
	      this.registerEvents(eventListeners);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps /* , nextState */) {
	      /* Recreate the animation handle if the data is changed */
	      if (this.options.animationData !== nextProps.options.animationData) {
	        this.deRegisterEvents(this.props.eventListeners);
	        this.destroy();
	        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
	        this.anim = _lottieWeb2.default.loadAnimation(this.options);
	        this.registerEvents(nextProps.eventListeners);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.isStopped) {
	        this.stop();
	      } else if (this.props.segments) {
	        this.playSegments();
	      } else {
	        this.play();
	      }
	
	      this.pause();
	      this.setSpeed();
	      this.setDirection();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.deRegisterEvents(this.props.eventListeners);
	      this.destroy();
	      this.options.animationData = null;
	      this.anim = null;
	    }
	  }, {
	    key: 'setSpeed',
	    value: function setSpeed() {
	      this.anim.setSpeed(this.props.speed);
	    }
	  }, {
	    key: 'setDirection',
	    value: function setDirection() {
	      this.anim.setDirection(this.props.direction);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.anim.play();
	    }
	  }, {
	    key: 'playSegments',
	    value: function playSegments() {
	      this.anim.playSegments(this.props.segments);
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.anim.stop();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (this.props.isPaused && !this.anim.isPaused) {
	        this.anim.pause();
	      } else if (!this.props.isPaused && this.anim.isPaused) {
	        this.anim.pause();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.anim.destroy();
	    }
	  }, {
	    key: 'registerEvents',
	    value: function registerEvents(eventListeners) {
	      var _this2 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'deRegisterEvents',
	    value: function deRegisterEvents(eventListeners) {
	      var _this3 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          ariaRole = _props2.ariaRole,
	          ariaLabel = _props2.ariaLabel,
	          isClickToPauseDisabled = _props2.isClickToPauseDisabled,
	          title = _props2.title;
	
	
	      var getSize = function getSize(initial) {
	        var size = void 0;
	
	        if (typeof initial === 'number') {
	          size = initial + 'px';
	        } else {
	          size = initial || '100%';
	        }
	
	        return size;
	      };
	
	      var lottieStyles = (0, _extends3.default)({
	        width: getSize(width),
	        height: getSize(height),
	        overflow: 'hidden',
	        margin: '0 auto',
	        outline: 'none'
	      }, this.props.style);
	
	      var onClickHandler = isClickToPauseDisabled ? function () {
	        return null;
	      } : this.handleClickToPause;
	
	      return (
	        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
	        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
	        _react2.default.createElement('div', {
	          ref: function ref(c) {
	            _this4.el = c;
	          },
	          style: lottieStyles,
	          onClick: onClickHandler,
	          title: title,
	          role: ariaRole,
	          'aria-label': ariaLabel,
	          tabIndex: '0'
	        })
	      );
	    }
	  }]);
	  return Lottie;
	}(_react2.default.Component);
	
	exports.default = Lottie;
	
	
	Lottie.propTypes = {
	  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  options: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  isStopped: _propTypes2.default.bool,
	  isPaused: _propTypes2.default.bool,
	  speed: _propTypes2.default.number,
	  segments: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  direction: _propTypes2.default.number,
	  ariaRole: _propTypes2.default.string,
	  ariaLabel: _propTypes2.default.string,
	  isClickToPauseDisabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string
	};
	
	Lottie.defaultProps = {
	  eventListeners: [],
	  isStopped: false,
	  isPaused: false,
	  speed: 1,
	  ariaRole: 'button',
	  ariaLabel: 'animation',
	  isClickToPauseDisabled: false,
	  title: ''
	};

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(91);
	
	var _utils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Player);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Player.__proto__ || Object.getPrototypeOf(Player)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.isReady = false, _this.isPlaying = false, _this.isLoading = true, _this.loadOnReady = null, _this.startOnPlay = true, _this.seekOnPlay = null, _this.onDurationCalled = false, _this.getInternalPlayer = function (key) {
	      if (!_this.player) return null;
	      return _this.player[key];
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player && _this.isReady) {
	        var playedSeconds = _this.getCurrentTime() || 0;
	        var loadedSeconds = _this.getSecondsLoaded();
	        var duration = _this.getDuration();
	        if (duration) {
	          var progress = {
	            playedSeconds: playedSeconds,
	            played: playedSeconds / duration
	          };
	          if (loadedSeconds !== null) {
	            progress.loadedSeconds = loadedSeconds;
	            progress.loaded = loadedSeconds / duration;
	          }
	          // Only call onProgress if values have changed
	          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
	            _this.props.onProgress(progress);
	          }
	          _this.prevPlayed = progress.played;
	          _this.prevLoaded = progress.loaded;
	        }
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
	    }, _this.onReady = function () {
	      if (!_this.mounted) return;
	      _this.isReady = true;
	      _this.isLoading = false;
	      var _this$props = _this.props,
	          onReady = _this$props.onReady,
	          playing = _this$props.playing,
	          volume = _this$props.volume,
	          muted = _this$props.muted;
	
	      onReady();
	      if (!muted && volume !== null) {
	        _this.player.setVolume(volume);
	      }
	      if (_this.loadOnReady) {
	        _this.player.load(_this.loadOnReady, true);
	        _this.loadOnReady = null;
	      } else if (playing) {
	        _this.player.play();
	      }
	      _this.onDurationCheck();
	    }, _this.onPlay = function () {
	      _this.isPlaying = true;
	      _this.isLoading = false;
	      var _this$props2 = _this.props,
	          onStart = _this$props2.onStart,
	          onPlay = _this$props2.onPlay,
	          playbackRate = _this$props2.playbackRate;
	
	      if (_this.startOnPlay) {
	        if (_this.player.setPlaybackRate) {
	          _this.player.setPlaybackRate(playbackRate);
	        }
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      _this.onDurationCheck();
	    }, _this.onPause = function (e) {
	      _this.isPlaying = false;
	      if (!_this.isLoading) {
	        _this.props.onPause(e);
	      }
	    }, _this.onEnded = function () {
	      var _this$props3 = _this.props,
	          activePlayer = _this$props3.activePlayer,
	          loop = _this$props3.loop,
	          onEnded = _this$props3.onEnded;
	
	      if (activePlayer.loopOnEnded && loop) {
	        _this.seekTo(0);
	      }
	      if (!loop) {
	        _this.isPlaying = false;
	        onEnded();
	      }
	    }, _this.onDurationCheck = function () {
	      clearTimeout(_this.durationCheckTimeout);
	      var duration = _this.getDuration();
	      if (duration) {
	        if (!_this.onDurationCalled) {
	          _this.props.onDuration(duration);
	          _this.onDurationCalled = true;
	        }
	      } else {
	        _this.durationCheckTimeout = setTimeout(_this.onDurationCheck, 100);
	      }
	    }, _this.onLoaded = function () {
	      // Sometimes we know loading has stopped but onReady/onPlay are never called
	      // so this provides a way for players to avoid getting stuck
	      _this.isLoading = false;
	    }, _this.ref = function (player) {
	      if (player) {
	        _this.player = player;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  } // Track playing state internally to prevent bugs
	  // Use isLoading to prevent onPause when switching URL
	
	
	  _createClass(Player, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.player.load(this.props.url);
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	      clearTimeout(this.durationCheckTimeout);
	      if (this.isReady) {
	        this.player.stop();
	      }
	      if (this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // Invoke player methods based on incoming props
	      var _props = this.props,
	          url = _props.url,
	          playing = _props.playing,
	          volume = _props.volume,
	          muted = _props.muted,
	          playbackRate = _props.playbackRate,
	          pip = _props.pip;
	
	      if (!(0, _utils.isEqual)(url, nextProps.url)) {
	        if (this.isLoading) {
	          console.warn('ReactPlayer: the attempt to load ' + nextProps.url + ' is being deferred until the player has loaded');
	          this.loadOnReady = nextProps.url;
	          return;
	        }
	        this.isLoading = true;
	        this.startOnPlay = true;
	        this.onDurationCalled = false;
	        this.player.load(nextProps.url, this.isReady);
	      }
	      if (!playing && nextProps.playing && !this.isPlaying) {
	        this.player.play();
	      }
	      if (playing && !nextProps.playing && this.isPlaying) {
	        this.player.pause();
	      }
	      if (!pip && nextProps.pip && this.player.enablePIP) {
	        this.player.enablePIP();
	      } else if (pip && !nextProps.pip && this.player.disablePIP) {
	        this.player.disablePIP();
	      }
	      if (volume !== nextProps.volume && nextProps.volume !== null) {
	        this.player.setVolume(nextProps.volume);
	      }
	      if (muted !== nextProps.muted) {
	        if (nextProps.muted) {
	          this.player.mute();
	        } else {
	          this.player.unmute();
	          if (nextProps.volume !== null) {
	            // Set volume next tick to fix a bug with DailyMotion
	            setTimeout(function () {
	              return _this2.player.setVolume(nextProps.volume);
	            });
	          }
	        }
	      }
	      if (playbackRate !== nextProps.playbackRate && this.player.setPlaybackRate) {
	        this.player.setPlaybackRate(nextProps.playbackRate);
	      }
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      if (!this.isReady) return null;
	      return this.player.getCurrentTime();
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      if (!this.isReady) return null;
	      return this.player.getSecondsLoaded();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      var _this3 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && amount !== 0) {
	        this.seekOnPlay = amount;
	        setTimeout(function () {
	          _this3.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	        return;
	      }
	      if (amount > 0 && amount < 1) {
	        // Convert fraction to seconds based on duration
	        var duration = this.player.getDuration();
	        if (!duration) {
	          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
	          return;
	        }
	        this.player.seekTo(duration * amount);
	        return;
	      }
	      this.player.seekTo(amount);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Player = this.props.activePlayer;
	      if (!Player) {
	        return null;
	      }
	      return _react2['default'].createElement(Player, _extends({}, this.props, {
	        ref: this.ref,
	        onReady: this.onReady,
	        onPlay: this.onPlay,
	        onPause: this.onPause,
	        onEnded: this.onEnded,
	        onLoaded: this.onLoaded
	      }));
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	Player.displayName = 'Player';
	Player.propTypes = _props2.propTypes;
	Player.defaultProps = _props2.defaultProps;
	exports['default'] = Player;

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ICON_SIZE = '64px';
	
	var Preview = function (_Component) {
	  _inherits(Preview, _Component);
	
	  function Preview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Preview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Preview.__proto__ || Object.getPrototypeOf(Preview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Preview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchImage(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.url !== nextProps.url) {
	        this.fetchImage(nextProps);
	      }
	    }
	  }, {
	    key: 'fetchImage',
	    value: function fetchImage(_ref2) {
	      var _this2 = this;
	
	      var url = _ref2.url,
	          light = _ref2.light;
	
	      if (typeof light === 'string') {
	        this.setState({ image: light });
	        return;
	      }
	      this.setState({ image: null });
	      return window.fetch('http://noembed.com/embed?url=' + url).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        if (data.thumbnail_url) {
	          var image = data.thumbnail_url.replace('height=100', 'height=480');
	          _this2.setState({ image: image });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onClick = this.props.onClick;
	      var image = this.state.image;
	
	      var flexCenter = {
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      };
	      var styles = {
	        preview: _extends({
	          width: '100%',
	          height: '100%',
	          backgroundImage: image ? 'url(' + image + ')' : undefined,
	          backgroundSize: 'cover',
	          backgroundPosition: 'center',
	          cursor: 'pointer'
	        }, flexCenter),
	        shadow: _extends({
	          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
	          borderRadius: ICON_SIZE,
	          width: ICON_SIZE,
	          height: ICON_SIZE
	        }, flexCenter),
	        playIcon: {
	          borderStyle: 'solid',
	          borderWidth: '16px 0 16px 26px',
	          borderColor: 'transparent transparent transparent white',
	          marginLeft: '7px'
	        }
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.preview, className: 'react-player__preview', onClick: onClick },
	        _react2['default'].createElement(
	          'div',
	          { style: styles.shadow, className: 'react-player__shadow' },
	          _react2['default'].createElement('div', { style: styles.playIcon, className: 'react-player__play-icon' })
	        )
	      );
	    }
	  }]);
	
	  return Preview;
	}(_react.Component);
	
	exports['default'] = Preview;

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilePlayer = exports.Mixcloud = exports.DailyMotion = exports.Twitch = exports.Wistia = exports.Streamable = exports.Facebook = exports.Vimeo = exports.SoundCloud = exports.YouTube = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _YouTube = __webpack_require__(144);
	
	Object.defineProperty(exports, 'YouTube', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_YouTube)['default'];
	  }
	});
	
	var _SoundCloud = __webpack_require__(142);
	
	Object.defineProperty(exports, 'SoundCloud', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SoundCloud)['default'];
	  }
	});
	
	var _Vimeo = __webpack_require__(143);
	
	Object.defineProperty(exports, 'Vimeo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Vimeo)['default'];
	  }
	});
	
	var _Facebook = __webpack_require__(232);
	
	Object.defineProperty(exports, 'Facebook', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Facebook)['default'];
	  }
	});
	
	var _Streamable = __webpack_require__(235);
	
	Object.defineProperty(exports, 'Streamable', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Streamable)['default'];
	  }
	});
	
	var _Wistia = __webpack_require__(237);
	
	Object.defineProperty(exports, 'Wistia', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Wistia)['default'];
	  }
	});
	
	var _Twitch = __webpack_require__(236);
	
	Object.defineProperty(exports, 'Twitch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitch)['default'];
	  }
	});
	
	var _DailyMotion = __webpack_require__(141);
	
	Object.defineProperty(exports, 'DailyMotion', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DailyMotion)['default'];
	  }
	});
	
	var _Mixcloud = __webpack_require__(234);
	
	Object.defineProperty(exports, 'Mixcloud', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mixcloud)['default'];
	  }
	});
	
	var _FilePlayer = __webpack_require__(233);
	
	Object.defineProperty(exports, 'FilePlayer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FilePlayer)['default'];
	  }
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(91);
	
	var _utils = __webpack_require__(20);
	
	var _players = __webpack_require__(642);
	
	var _players2 = _interopRequireDefault(_players);
	
	var _Player4 = __webpack_require__(140);
	
	var _Player5 = _interopRequireDefault(_Player4);
	
	var _Preview = __webpack_require__(640);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _preload = __webpack_require__(643);
	
	var _preload2 = _interopRequireDefault(_preload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	var customPlayers = [];
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.state = {
	      showPreview: !!_this.props.light
	    }, _this.onClickPreview = function () {
	      _this.setState({ showPreview: false });
	    }, _this.getDuration = function () {
	      if (!_this.player) return null;
	      return _this.player.getDuration();
	    }, _this.getCurrentTime = function () {
	      if (!_this.player) return null;
	      return _this.player.getCurrentTime();
	    }, _this.getSecondsLoaded = function () {
	      if (!_this.player) return null;
	      return _this.player.getSecondsLoaded();
	    }, _this.getInternalPlayer = function () {
	      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	      if (!_this.player) return null;
	      return _this.player.getInternalPlayer(key);
	    }, _this.seekTo = function (fraction) {
	      if (!_this.player) return null;
	      _this.player.seekTo(fraction);
	    }, _this.onReady = function () {
	      _this.props.onReady(_this);
	    }, _this.wrapperRef = function (wrapper) {
	      _this.wrapper = wrapper;
	    }, _this.activePlayerRef = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.progressFrequency) {
	        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
	        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	    }
	  }, {
	    key: 'getActivePlayer',
	    value: function getActivePlayer(url) {
	      var _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var _Player = _arr[_i];
	        if (_Player.canPlay(url)) {
	          return _Player;
	        }
	      }
	      // Fall back to FilePlayer if nothing else can play the URL
	      return _FilePlayer.FilePlayer;
	    }
	  }, {
	    key: 'renderActivePlayer',
	    value: function renderActivePlayer(url, activePlayer) {
	      if (!url) return null;
	      return _react2['default'].createElement(_Player5['default'], _extends({}, this.props, {
	        key: activePlayer.displayName,
	        ref: this.activePlayerRef,
	        config: this.config,
	        activePlayer: activePlayer,
	        onReady: this.onReady
	      }));
	    }
	  }, {
	    key: 'sortPlayers',
	    value: function sortPlayers(a, b) {
	      // Retain player order to prevent weird iframe behaviour when switching players
	      if (a && b) {
	        return a.key < b.key ? -1 : 1;
	      }
	      return 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          style = _props.style,
	          width = _props.width,
	          height = _props.height,
	          light = _props.light,
	          Wrapper = _props.wrapper;
	      var showPreview = this.state.showPreview;
	
	      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	      var activePlayer = this.getActivePlayer(url);
	      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
	      var preloadPlayers = (0, _preload2['default'])(url, this.config);
	      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);
	      if (showPreview && url) {
	        return _react2['default'].createElement(_Preview2['default'], {
	          url: url,
	          light: light,
	          onClick: this.onClickPreview
	        });
	      }
	      return _react2['default'].createElement(
	        Wrapper,
	        _extends({ ref: this.wrapperRef, style: _extends({}, style, { width: width, height: height }) }, otherProps),
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.addCustomPlayer = function (player) {
	  customPlayers.push(player);
	};
	
	ReactPlayer.removeCustomPlayers = function () {
	  customPlayers = [];
	};
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props2.propTypes;
	ReactPlayer.defaultProps = _props2.defaultProps;
	
	ReactPlayer.canPlay = function (url) {
	  var _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	    var _Player2 = _arr2[_i2];
	    if (_Player2.canPlay(url)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	ReactPlayer.canEnablePIP = function (url) {
	  var _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players2['default']));
	
	  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
	    var _Player3 = _arr3[_i3];
	    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	exports['default'] = ReactPlayer;

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DailyMotion = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://api.dmcdn.net/all.js';
	var SDK_GLOBAL = 'DM';
	var SDK_GLOBAL_READY = 'dmAsyncInit';
	var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
	
	var DailyMotion = exports.DailyMotion = function (_Component) {
	  _inherits(DailyMotion, _Component);
	
	  function DailyMotion() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DailyMotion);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DailyMotion.__proto__ || Object.getPrototypeOf(DailyMotion)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onDurationChange = function () {
	      var duration = _this.getDuration();
	      _this.props.onDuration(duration);
	    }, _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DailyMotion, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          controls = _props.controls,
	          config = _props.config,
	          onError = _props.onError,
	          playing = _props.playing;
	
	      var _url$match = url.match(MATCH_URL),
	          _url$match2 = _slicedToArray(_url$match, 2),
	          id = _url$match2[1];
	
	      if (this.player) {
	        this.player.load(id, {
	          start: (0, _utils.parseStartTime)(url),
	          autoplay: playing
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
	        return DM.player;
	      }).then(function (DM) {
	        if (!_this2.container) return;
	        var Player = DM.player;
	        _this2.player = new Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          video: id,
	          params: _extends({
	            controls: controls,
	            autoplay: _this2.props.playing,
	            mute: _this2.props.muted,
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }, config.dailymotion.params),
	          events: {
	            apiready: _this2.props.onReady,
	            seeked: function seeked() {
	              return _this2.props.onSeek(_this2.player.currentTime);
	            },
	            video_end: _this2.props.onEnded,
	            durationchange: _this2.onDurationChange,
	            pause: _this2.props.onPause,
	            playing: _this2.props.onPlay,
	            waiting: _this2.props.onBuffer,
	            error: function error(event) {
	              return onError(event);
	            }
	          }
	        });
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.player.duration || null;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.player.bufferedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return DailyMotion;
	}(_react.Component);
	
	DailyMotion.displayName = 'DailyMotion';
	
	DailyMotion.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	DailyMotion.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(DailyMotion);

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Facebook = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//connect.facebook.net/en_US/sdk.js';
	var SDK_GLOBAL = 'FB';
	var SDK_GLOBAL_READY = 'fbAsyncInit';
	var MATCH_URL = /facebook\.com\/([^/?].+\/)?video(s|\.php)[/?].*$/;
	var PLAYER_ID_PREFIX = 'facebook-player-';
	
	var Facebook = exports.Facebook = function (_Component) {
	  _inherits(Facebook, _Component);
	
	  function Facebook() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Facebook);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Facebook.__proto__ || Object.getPrototypeOf(Facebook)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Facebook, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      if (isReady) {
	        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	          return FB.XFBML.parse();
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
	        FB.init({
	          appId: _this2.props.config.facebook.appId,
	          xfbml: true,
	          version: 'v2.5'
	        });
	        FB.Event.subscribe('xfbml.render', function (msg) {
	          // Here we know the SDK has loaded, even if onReady/onPlay
	          // is not called due to a video that cannot be embedded
	          _this2.props.onLoaded();
	        });
	        FB.Event.subscribe('xfbml.ready', function (msg) {
	          if (msg.type === 'video' && msg.id === _this2.playerID) {
	            _this2.player = msg.instance;
	            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);
	            _this2.player.subscribe('paused', _this2.props.onPause);
	            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);
	            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);
	            _this2.player.subscribe('error', _this2.props.onError);
	            if (!_this2.props.muted) {
	              // Player is muted by default
	              _this2.callPlayer('unmute');
	            }
	            _this2.props.onReady();
	
	            // For some reason Facebook have added `visibility: hidden`
	            // to the iframe when autoplay fails, so here we set it back
	            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentPosition');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'black'
	      };
	      return _react2['default'].createElement('div', {
	        style: style,
	        id: this.playerID,
	        className: 'fb-video',
	        'data-href': this.props.url,
	        'data-autoplay': this.props.playing ? 'true' : 'false',
	        'data-allowfullscreen': 'true',
	        'data-controls': this.props.controls ? 'true' : 'false'
	      });
	    }
	  }]);
	
	  return Facebook;
	}(_react.Component);
	
	Facebook.displayName = 'Facebook';
	
	Facebook.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Facebook.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Facebook);

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FilePlayer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
	var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
	var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
	var HLS_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/hls.js/VERSION/hls.min.js';
	var HLS_GLOBAL = 'Hls';
	var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
	var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
	var DASH_GLOBAL = 'dashjs';
	var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
	
	function canPlay(url) {
	  if (url instanceof Array) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = url[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        if (typeof item === 'string' && canPlay(item)) {
	          return true;
	        }
	        if (canPlay(item.src)) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return false;
	  }
	  if ((0, _utils.isMediaStream)(url)) {
	    return true;
	  }
	  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
	}
	
	function canEnablePIP(url) {
	  return canPlay(url) && !!document.pictureInPictureEnabled && !AUDIO_EXTENSIONS.test(url);
	}
	
	var FilePlayer = exports.FilePlayer = function (_Component) {
	  _inherits(FilePlayer, _Component);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.onDisablePIP = function (e) {
	      var _this$props = _this.props,
	          onDisablePIP = _this$props.onDisablePIP,
	          playing = _this$props.playing;
	
	      onDisablePIP(e);
	      if (playing) {
	        _this.play();
	      }
	    }, _this.onSeek = function (e) {
	      _this.props.onSeek(e.target.currentTime);
	    }, _this.mute = function () {
	      _this.player.muted = true;
	    }, _this.unmute = function () {
	      _this.player.muted = false;
	    }, _this.renderSourceElement = function (source, index) {
	      if (typeof source === 'string') {
	        return _react2['default'].createElement('source', { key: index, src: source });
	      }
	      return _react2['default'].createElement('source', _extends({ key: index }, source));
	    }, _this.renderTrack = function (track, index) {
	      return _react2['default'].createElement('track', _extends({ key: index }, track));
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	      if (IOS) {
	        this.player.load();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(nextProps)) {
	        this.removeListeners();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
	        this.addListeners();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _props = this.props,
	          onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onEnded = _props.onEnded,
	          onError = _props.onError,
	          playsinline = _props.playsinline,
	          onEnablePIP = _props.onEnablePIP;
	
	      this.player.addEventListener('canplay', onReady);
	      this.player.addEventListener('play', onPlay);
	      this.player.addEventListener('pause', onPause);
	      this.player.addEventListener('seeked', this.onSeek);
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      this.player.addEventListener('enterpictureinpicture', onEnablePIP);
	      this.player.addEventListener('leavepictureinpicture', this.onDisablePIP);
	      if (playsinline) {
	        this.player.setAttribute('playsinline', '');
	        this.player.setAttribute('webkit-playsinline', '');
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      var _props2 = this.props,
	          onReady = _props2.onReady,
	          onPlay = _props2.onPlay,
	          onPause = _props2.onPause,
	          onEnded = _props2.onEnded,
	          onError = _props2.onError,
	          onEnablePIP = _props2.onEnablePIP;
	
	      this.player.removeEventListener('canplay', onReady);
	      this.player.removeEventListener('play', onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('seeked', this.onSeek);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      this.player.removeEventListener('enterpictureinpicture', onEnablePIP);
	      this.player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
	    }
	  }, {
	    key: 'shouldUseAudio',
	    value: function shouldUseAudio(props) {
	      if (props.config.file.forceVideo) {
	        return false;
	      }
	      if (props.config.file.attributes.poster) {
	        return false; // Use <video> so that poster is shown
	      }
	      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
	    }
	  }, {
	    key: 'shouldUseHLS',
	    value: function shouldUseHLS(url) {
	      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
	    }
	  }, {
	    key: 'shouldUseDASH',
	    value: function shouldUseDASH(url) {
	      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props$config$file = this.props.config.file,
	          hlsVersion = _props$config$file.hlsVersion,
	          dashVersion = _props$config$file.dashVersion;
	
	      if (this.shouldUseHLS(url)) {
	        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
	          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);
	          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
	            _this2.props.onError(e, data, _this2.hls, Hls);
	          });
	          _this2.hls.loadSource(url);
	          _this2.hls.attachMedia(_this2.player);
	        });
	      }
	      if (this.shouldUseDASH(url)) {
	        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
	          _this2.dash = dashjs.MediaPlayer().create();
	          _this2.dash.initialize(_this2.player, url, _this2.props.playing);
	          _this2.dash.getDebug().setLogToBrowserConsole(false);
	        });
	      }
	
	      if (url instanceof Array) {
	        // When setting new urls (<source>) on an already loaded video,
	        // HTMLMediaElement.load() is needed to reset the media element
	        // and restart the media resource. Just replacing children source
	        // dom nodes is not enough
	        this.player.load();
	      } else if ((0, _utils.isMediaStream)(url)) {
	        try {
	          this.player.srcObject = url;
	        } catch (e) {
	          this.player.src = window.URL.createObjectURL(url);
	        }
	      }
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      var promise = this.player.play();
	      if (promise) {
	        promise['catch'](this.props.onError);
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	      if (this.hls) {
	        this.hls.destroy();
	      }
	      if (this.dash) {
	        this.dash.reset();
	      }
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.player.currentTime = seconds;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'enablePIP',
	    value: function enablePIP() {
	      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
	        this.player.requestPictureInPicture();
	      }
	    }
	  }, {
	    key: 'disablePIP',
	    value: function disablePIP() {
	      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
	        document.exitPictureInPicture();
	      }
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.player.playbackRate = rate;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.player) return null;
	      var _player = this.player,
	          duration = _player.duration,
	          seekable = _player.seekable;
	      // on iOS, live streams return Infinity for the duration
	      // so instead we use the end of the seekable timerange
	
	      if (duration === Infinity && seekable.length > 0) {
	        return seekable.end(seekable.length - 1);
	      }
	      return duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      if (!this.player) return null;
	      return this.player.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      if (!this.player) return null;
	      var buffered = this.player.buffered;
	
	      if (buffered.length === 0) {
	        return 0;
	      }
	      var end = buffered.end(buffered.length - 1);
	      var duration = this.getDuration();
	      if (end > duration) {
	        return duration;
	      }
	      return end;
	    }
	  }, {
	    key: 'getSource',
	    value: function getSource(url) {
	      var useHLS = this.shouldUseHLS(url);
	      var useDASH = this.shouldUseDASH(url);
	      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
	        return undefined;
	      }
	      if (MATCH_DROPBOX_URL.test(url)) {
	        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
	      }
	      return url;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          url = _props3.url,
	          playing = _props3.playing,
	          loop = _props3.loop,
	          controls = _props3.controls,
	          muted = _props3.muted,
	          config = _props3.config,
	          width = _props3.width,
	          height = _props3.height;
	
	      var useAudio = this.shouldUseAudio(this.props);
	      var Element = useAudio ? 'audio' : 'video';
	      var style = {
	        width: width === 'auto' ? width : '100%',
	        height: height === 'auto' ? height : '100%'
	      };
	      return _react2['default'].createElement(
	        Element,
	        _extends({
	          ref: this.ref,
	          src: this.getSource(url),
	          style: style,
	          preload: 'auto',
	          autoPlay: playing || undefined,
	          controls: controls,
	          muted: muted,
	          loop: loop
	        }, config.file.attributes),
	        url instanceof Array && url.map(this.renderSourceElement),
	        config.file.tracks.map(this.renderTrack)
	      );
	    }
	  }]);
	
	  return FilePlayer;
	}(_react.Component);
	
	FilePlayer.displayName = 'FilePlayer';
	FilePlayer.canPlay = canPlay;
	FilePlayer.canEnablePIP = canEnablePIP;
	exports['default'] = (0, _singlePlayer2['default'])(FilePlayer);

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Mixcloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//widget.mixcloud.com/media/js/widgetApi.js';
	var SDK_GLOBAL = 'Mixcloud';
	var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
	
	var Mixcloud = exports.Mixcloud = function (_Component) {
	  _inherits(Mixcloud, _Component);
	
	  function Mixcloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Mixcloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Mixcloud.__proto__ || Object.getPrototypeOf(Mixcloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      // No volume support
	    }, _this.unmute = function () {
	      // No volume support
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Mixcloud, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
	        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);
	        _this2.player.ready.then(function () {
	          _this2.player.events.play.on(_this2.props.onPlay);
	          _this2.player.events.pause.on(_this2.props.onPause);
	          _this2.player.events.ended.on(_this2.props.onEnded);
	          _this2.player.events.error.on(_this2.props.error);
	          _this2.player.events.progress.on(function (seconds, duration) {
	            _this2.currentTime = seconds;
	            _this2.duration = duration;
	          });
	          _this2.props.onReady();
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      // No volume support
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          url = _props.url,
	          config = _props.config;
	
	      var id = url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      var query = (0, _utils.queryString)(_extends({}, config.mixcloud.options, {
	        feed: '/' + id + '/'
	      }));
	      // We have to give the iframe a key here to prevent a
	      // weird dialog appearing when loading a new track
	      return _react2['default'].createElement('iframe', {
	        key: id,
	        ref: this.ref,
	        style: style,
	        src: 'https://www.mixcloud.com/widget/iframe/?' + query,
	        frameBorder: '0'
	      });
	    }
	  }]);
	
	  return Mixcloud;
	}(_react.Component);
	
	Mixcloud.displayName = 'Mixcloud';
	
	Mixcloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Mixcloud);

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SoundCloud = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://w.soundcloud.com/player/api.js';
	var SDK_GLOBAL = 'SC';
	var MATCH_URL = /(soundcloud\.com|snd\.sc)\/.+$/;
	
	var SoundCloud = exports.SoundCloud = function (_Component) {
	  _inherits(SoundCloud, _Component);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.fractionLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
	        if (!_this2.iframe) return;
	        var _SC$Widget$Events = SC.Widget.Events,
	            PLAY = _SC$Widget$Events.PLAY,
	            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
	            PAUSE = _SC$Widget$Events.PAUSE,
	            FINISH = _SC$Widget$Events.FINISH,
	            ERROR = _SC$Widget$Events.ERROR;
	
	        if (!isReady) {
	          _this2.player = SC.Widget(_this2.iframe);
	          _this2.player.bind(PLAY, _this2.props.onPlay);
	          _this2.player.bind(PAUSE, _this2.props.onPause);
	          _this2.player.bind(PLAY_PROGRESS, function (e) {
	            _this2.currentTime = e.currentPosition / 1000;
	            _this2.fractionLoaded = e.loadedProgress;
	          });
	          _this2.player.bind(FINISH, function () {
	            return _this2.props.onEnded();
	          });
	          _this2.player.bind(ERROR, function (e) {
	            return _this2.props.onError(e);
	          });
	        }
	        _this2.player.load(url, _extends({}, _this2.props.config.soundcloud.options, {
	          callback: function callback() {
	            _this2.player.getDuration(function (duration) {
	              _this2.duration = duration / 1000;
	              _this2.props.onReady();
	            });
	          }
	        }));
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seekTo', seconds * 1000);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.fractionLoaded * this.duration;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(this.props.url),
	        style: style,
	        frameBorder: 0
	      });
	    }
	  }]);
	
	  return SoundCloud;
	}(_react.Component);
	
	SoundCloud.displayName = 'SoundCloud';
	
	SoundCloud.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	SoundCloud.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(SoundCloud);

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Streamable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//cdn.embed.ly/player-0.1.0.min.js';
	var SDK_GLOBAL = 'playerjs';
	var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
	
	var Streamable = exports.Streamable = function (_Component) {
	  _inherits(Streamable, _Component);
	
	  function Streamable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Streamable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Streamable.__proto__ || Object.getPrototypeOf(Streamable)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Streamable, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
	        if (!_this2.iframe) return;
	        _this2.player = new playerjs.Player(_this2.iframe);
	        _this2.player.setLoop(_this2.props.loop);
	        _this2.player.on('ready', _this2.props.onReady);
	        _this2.player.on('play', _this2.props.onPlay);
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', _this2.props.onSeek);
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var duration = _ref2.duration,
	              seconds = _ref2.seconds;
	
	          _this2.duration = duration;
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('buffered', function (_ref3) {
	          var percent = _ref3.percent;
	
	          if (_this2.duration) {
	            _this2.secondsLoaded = _this2.duration * percent;
	          }
	        });
	        if (_this2.props.muted) {
	          _this2.player.mute();
	        }
	      }, this.props.onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      // Nothing to do
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.props.url.match(MATCH_URL)[1];
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        src: 'https://streamable.com/o/' + id,
	        frameBorder: '0',
	        scrolling: 'no',
	        style: style,
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return Streamable;
	}(_react.Component);
	
	Streamable.displayName = 'Streamable';
	
	Streamable.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Streamable);

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
	var SDK_GLOBAL = 'Twitch';
	var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
	var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
	var PLAYER_ID_PREFIX = 'twitch-player-';
	
	var Twitch = exports.Twitch = function (_Component) {
	  _inherits(Twitch, _Component);
	
	  function Twitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Twitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Twitch.__proto__ || Object.getPrototypeOf(Twitch)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.playerID = PLAYER_ID_PREFIX + (0, _utils.randomString)(), _this.mute = function () {
	      _this.callPlayer('setMuted', true);
	    }, _this.unmute = function () {
	      _this.callPlayer('setMuted', false);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Twitch, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playsinline = _props.playsinline,
	          onError = _props.onError,
	          config = _props.config;
	
	      var isChannel = MATCH_CHANNEL_URL.test(url);
	      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];
	      if (isReady) {
	        if (isChannel) {
	          this.player.setChannel(id);
	        } else {
	          this.player.setVideo('v' + id);
	        }
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
	        _this2.player = new Twitch.Player(_this2.playerID, _extends({
	          video: isChannel ? '' : id,
	          channel: isChannel ? id : '',
	          height: '100%',
	          width: '100%',
	          playsinline: playsinline,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted
	        }, config.twitch.options));
	        var _Twitch$Player = Twitch.Player,
	            READY = _Twitch$Player.READY,
	            PLAYING = _Twitch$Player.PLAYING,
	            PAUSE = _Twitch$Player.PAUSE,
	            ENDED = _Twitch$Player.ENDED;
	
	        _this2.player.addEventListener(READY, _this2.props.onReady);
	        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);
	        _this2.player.addEventListener(PAUSE, _this2.props.onPause);
	        _this2.player.addEventListener(ENDED, _this2.props.onEnded);
	      }, onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('seek', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { style: style, id: this.playerID });
	    }
	  }]);
	
	  return Twitch;
	}(_react.Component);
	
	Twitch.displayName = 'Twitch';
	
	Twitch.canPlay = function (url) {
	  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
	};
	
	Twitch.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Twitch);

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vimeo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://player.vimeo.com/api/player.js';
	var SDK_GLOBAL = 'Vimeo';
	var MATCH_URL = /vimeo\.com\/.+/;
	var MATCH_FILE_URL = /vimeo\.com\/external\/.+\.mp4/;
	
	var Vimeo = exports.Vimeo = function (_Component) {
	  _inherits(Vimeo, _Component);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.duration = null, _this.currentTime = null, _this.secondsLoaded = null, _this.mute = function () {
	      _this.setVolume(0);
	    }, _this.unmute = function () {
	      if (_this.props.volume !== null) {
	        _this.setVolume(_this.props.volume);
	      }
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      this.duration = null;
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
	        if (!_this2.container) return;
	        _this2.player = new Vimeo.Player(_this2.container, _extends({}, _this2.props.config.vimeo.playerOptions, {
	          url: url,
	          autoplay: _this2.props.playing,
	          muted: _this2.props.muted,
	          loop: _this2.props.loop
	        }));
	        _this2.player.ready().then(function () {
	          var iframe = _this2.container.querySelector('iframe');
	          iframe.style.width = '100%';
	          iframe.style.height = '100%';
	        })['catch'](_this2.props.onError);
	        _this2.player.on('loaded', function () {
	          _this2.props.onReady();
	          _this2.refreshDuration();
	        });
	        _this2.player.on('play', function () {
	          _this2.props.onPlay();
	          _this2.refreshDuration();
	        });
	        _this2.player.on('pause', _this2.props.onPause);
	        _this2.player.on('seeked', function (e) {
	          return _this2.props.onSeek(e.seconds);
	        });
	        _this2.player.on('ended', _this2.props.onEnded);
	        _this2.player.on('error', _this2.props.onError);
	        _this2.player.on('timeupdate', function (_ref2) {
	          var seconds = _ref2.seconds;
	
	          _this2.currentTime = seconds;
	        });
	        _this2.player.on('progress', function (_ref3) {
	          var seconds = _ref3.seconds;
	
	          _this2.secondsLoaded = seconds;
	        });
	      }, this.props.onError);
	    }
	  }, {
	    key: 'refreshDuration',
	    value: function refreshDuration() {
	      var _this3 = this;
	
	      this.player.getDuration().then(function (duration) {
	        _this3.duration = duration;
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('unload');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('setCurrentTime', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.currentTime;
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.secondsLoaded;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%',
	        overflow: 'hidden',
	        backgroundColor: 'black'
	      }, this.props.style);
	      return _react2['default'].createElement('div', {
	        key: this.props.url,
	        ref: this.ref,
	        style: style
	      });
	    }
	  }]);
	
	  return Vimeo;
	}(_react.Component);
	
	Vimeo.displayName = 'Vimeo';
	
	Vimeo.canPlay = function (url) {
	  if (MATCH_FILE_URL.test(url)) {
	    return false;
	  }
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(Vimeo);

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Wistia = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = '//fast.wistia.com/assets/external/E-v1.js';
	var SDK_GLOBAL = 'Wistia';
	var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
	
	var Wistia = exports.Wistia = function (_Component) {
	  _inherits(Wistia, _Component);
	
	  function Wistia() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Wistia);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Wistia.__proto__ || Object.getPrototypeOf(Wistia)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unmute');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Wistia, [{
	    key: 'getID',
	    value: function getID(url) {
	      return url && url.match(MATCH_URL)[1];
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          controls = _props.controls,
	          _onReady = _props.onReady,
	          onPlay = _props.onPlay,
	          onPause = _props.onPause,
	          onSeek = _props.onSeek,
	          onEnded = _props.onEnded,
	          config = _props.config;
	
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
	        window._wq = window._wq || [];
	        window._wq.push({
	          id: _this2.getID(url),
	          options: _extends({
	            autoPlay: playing,
	            silentAutoPlay: 'allow',
	            muted: muted,
	            controlsVisibleOnLoad: controls
	          }, config.wistia.options),
	          onReady: function onReady(player) {
	            _this2.player = player;
	            _this2.player.bind('play', onPlay);
	            _this2.player.bind('pause', onPause);
	            _this2.player.bind('seek', onSeek);
	            _this2.player.bind('end', onEnded);
	            _onReady();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.callPlayer('remove');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(seconds) {
	      this.callPlayer('time', seconds);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('volume', fraction);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('playbackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('duration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('time');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.getID(this.props.url);
	      var className = 'wistia_embed wistia_async_' + id;
	      var style = {
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('div', { key: id, className: className, style: style });
	    }
	  }]);
	
	  return Wistia;
	}(_react.Component);
	
	Wistia.displayName = 'Wistia';
	
	Wistia.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	Wistia.loopOnEnded = true;
	exports['default'] = (0, _singlePlayer2['default'])(Wistia);

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YouTube = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(20);
	
	var _singlePlayer = __webpack_require__(25);
	
	var _singlePlayer2 = _interopRequireDefault(_singlePlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
	var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;
	
	function parsePlaylist(url) {
	  if (MATCH_PLAYLIST.test(url)) {
	    var _url$match = url.match(MATCH_PLAYLIST),
	        _url$match2 = _slicedToArray(_url$match, 2),
	        playlistId = _url$match2[1];
	
	    console.log(playlistId);
	    return {
	      listType: 'playlist',
	      list: playlistId
	    };
	  }
	  return {};
	}
	
	var YouTube = exports.YouTube = function (_Component) {
	  _inherits(YouTube, _Component);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.callPlayer = _utils.callPlayer, _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props,
	          onPlay = _this$props.onPlay,
	          onPause = _this$props.onPause,
	          onBuffer = _this$props.onBuffer,
	          onEnded = _this$props.onEnded,
	          onReady = _this$props.onReady,
	          loop = _this$props.loop;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
	          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
	          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
	          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
	          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
	          CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) {
	        var isPlaylist = !!_this.callPlayer('getPlaylist');
	        if (loop && !isPlaylist) {
	          _this.play(); // Only loop manually if not playing a playlist
	        }
	        onEnded();
	      }
	      if (data === CUED) onReady();
	    }, _this.mute = function () {
	      _this.callPlayer('mute');
	    }, _this.unmute = function () {
	      _this.callPlayer('unMute');
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'load',
	    value: function load(url, isReady) {
	      var _this2 = this;
	
	      var _props = this.props,
	          playing = _props.playing,
	          muted = _props.muted,
	          playsinline = _props.playsinline,
	          controls = _props.controls,
	          loop = _props.loop,
	          config = _props.config,
	          _onError = _props.onError;
	      var playerVars = config.youtube.playerVars;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
	          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
	        });
	        return;
	      }
	      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
	        return YT.loaded;
	      }).then(function (YT) {
	        if (!_this2.container) return;
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({
	            autoplay: playing ? 1 : 0,
	            mute: muted ? 1 : 0,
	            controls: controls ? 1 : 0,
	            start: (0, _utils.parseStartTime)(url),
	            end: (0, _utils.parseEndTime)(url),
	            origin: window.location.origin,
	            playsinline: playsinline
	          }, parsePlaylist(url), playerVars),
	          events: {
	            onReady: _this2.props.onReady,
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	        if (loop) {
	          _this2.player.setLoop(true); // Enable playlist looping
	        }
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.callPlayer('playVideo');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.callPlayer('pauseVideo');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!document.body.contains(this.callPlayer('getIframe'))) return;
	      this.callPlayer('stopVideo');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(amount) {
	      this.callPlayer('seekTo', amount);
	      if (!this.props.playing) {
	        this.pause();
	      }
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.callPlayer('setVolume', fraction * 100);
	    }
	  }, {
	    key: 'setPlaybackRate',
	    value: function setPlaybackRate(rate) {
	      this.callPlayer('setPlaybackRate', rate);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.callPlayer('getDuration');
	    }
	  }, {
	    key: 'getCurrentTime',
	    value: function getCurrentTime() {
	      return this.callPlayer('getCurrentTime');
	    }
	  }, {
	    key: 'getSecondsLoaded',
	    value: function getSecondsLoaded() {
	      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = _extends({
	        width: '100%',
	        height: '100%'
	      }, this.props.style);
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }]);
	
	  return YouTube;
	}(_react.Component);
	
	YouTube.displayName = 'YouTube';
	
	YouTube.canPlay = function (url) {
	  return MATCH_URL.test(url);
	};
	
	exports['default'] = (0, _singlePlayer2['default'])(YouTube);

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _YouTube = __webpack_require__(144);
	
	var _SoundCloud = __webpack_require__(142);
	
	var _Vimeo = __webpack_require__(143);
	
	var _Facebook = __webpack_require__(232);
	
	var _Streamable = __webpack_require__(235);
	
	var _Wistia = __webpack_require__(237);
	
	var _Twitch = __webpack_require__(236);
	
	var _DailyMotion = __webpack_require__(141);
	
	var _Mixcloud = __webpack_require__(234);
	
	var _FilePlayer = __webpack_require__(233);
	
	exports['default'] = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = renderPreloadPlayers;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Player = __webpack_require__(140);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _YouTube = __webpack_require__(144);
	
	var _SoundCloud = __webpack_require__(142);
	
	var _Vimeo = __webpack_require__(143);
	
	var _DailyMotion = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PRELOAD_PLAYERS = [{
	  Player: _YouTube.YouTube,
	  configKey: 'youtube',
	  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
	}, {
	  Player: _SoundCloud.SoundCloud,
	  configKey: 'soundcloud',
	  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
	}, {
	  Player: _Vimeo.Vimeo,
	  configKey: 'vimeo',
	  url: 'https://vimeo.com/300970506'
	}, {
	  Player: _DailyMotion.DailyMotion,
	  configKey: 'dailymotion',
	  url: 'http://www.dailymotion.com/video/xqdpyk'
	}];
	
	function renderPreloadPlayers(url, config) {
	  var players = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = PRELOAD_PLAYERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var player = _step.value;
	
	      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
	        players.push(_react2['default'].createElement(_Player2['default'], {
	          key: player.Player.displayName,
	          activePlayer: player.Player,
	          url: player.url,
	          playing: true,
	          muted: true,
	          style: { display: 'none' }
	        }));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return players;
	}

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = undefined;
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var string = _propTypes2['default'].string,
	    bool = _propTypes2['default'].bool,
	    number = _propTypes2['default'].number,
	    array = _propTypes2['default'].array,
	    oneOfType = _propTypes2['default'].oneOfType,
	    shape = _propTypes2['default'].shape,
	    object = _propTypes2['default'].object,
	    func = _propTypes2['default'].func;
	var propTypes = exports.propTypes = {
	  url: oneOfType([string, array, object]),
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  muted: bool,
	  playbackRate: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  style: object,
	  progressInterval: number,
	  playsinline: bool,
	  pip: bool,
	  light: oneOfType([bool, string]),
	  wrapper: oneOfType([string, func]),
	  config: shape({
	    soundcloud: shape({
	      options: object
	    }),
	    youtube: shape({
	      playerVars: object,
	      preload: bool
	    }),
	    facebook: shape({
	      appId: string
	    }),
	    dailymotion: shape({
	      params: object,
	      preload: bool
	    }),
	    vimeo: shape({
	      playerOptions: object,
	      preload: bool
	    }),
	    file: shape({
	      attributes: object,
	      tracks: array,
	      forceVideo: bool,
	      forceAudio: bool,
	      forceHLS: bool,
	      forceDASH: bool,
	      hlsOptions: object,
	      hlsVersion: string,
	      dashVersion: string
	    }),
	    wistia: shape({
	      options: object
	    }),
	    mixcloud: shape({
	      options: object
	    }),
	    twitch: shape({
	      options: object
	    })
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onSeek: func,
	  onProgress: func,
	  onEnablePIP: func,
	  onDisablePIP: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: null,
	  muted: false,
	  playbackRate: 1,
	  width: '640px',
	  height: '360px',
	  style: {},
	  progressInterval: 1000,
	  playsinline: false,
	  pip: false,
	  light: false,
	  wrapper: 'div',
	  config: {
	    soundcloud: {
	      options: {
	        visual: true, // Undocumented, but makes player fill container and look better
	        buying: false,
	        liking: false,
	        download: false,
	        sharing: false,
	        show_comments: false,
	        show_playcount: false
	      }
	    },
	    youtube: {
	      playerVars: {
	        playsinline: 1,
	        showinfo: 0,
	        rel: 0,
	        iv_load_policy: 3,
	        modestbranding: 1
	      },
	      preload: false
	    },
	    facebook: {
	      appId: '1309697205772819'
	    },
	    dailymotion: {
	      params: {
	        api: 1,
	        'endscreen-enable': false
	      },
	      preload: false
	    },
	    vimeo: {
	      playerOptions: {
	        autopause: false,
	        byline: false,
	        portrait: false,
	        title: false
	      },
	      preload: false
	    },
	    file: {
	      attributes: {},
	      tracks: [],
	      forceVideo: false,
	      forceAudio: false,
	      forceHLS: false,
	      forceDASH: false,
	      hlsOptions: {},
	      hlsVersion: '0.10.1',
	      dashVersion: '2.9.2'
	    },
	    wistia: {
	      options: {}
	    },
	    mixcloud: {
	      options: {
	        hide_cover: 1
	      }
	    },
	    twitch: {
	      options: {}
	    }
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onSeek: function onSeek() {},
	  onProgress: function onProgress() {},
	  onEnablePIP: function onEnablePIP() {},
	  onDisablePIP: function onDisablePIP() {}
	};
	
	var DEPRECATED_CONFIG_PROPS = exports.DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = createSinglePlayer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props2 = __webpack_require__(91);
	
	var _utils = __webpack_require__(20);
	
	var _Player = __webpack_require__(140);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SUPPORTED_PROPS = Object.keys(_props2.propTypes);
	
	function createSinglePlayer(activePlayer) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(SinglePlayer, _Component);
	
	    function SinglePlayer() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SinglePlayer);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SinglePlayer.__proto__ || Object.getPrototypeOf(SinglePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.config = (0, _utils.getConfig)(_this.props, _props2.defaultProps, true), _this.getDuration = function () {
	        if (!_this.player) return null;
	        return _this.player.getDuration();
	      }, _this.getCurrentTime = function () {
	        if (!_this.player) return null;
	        return _this.player.getCurrentTime();
	      }, _this.getSecondsLoaded = function () {
	        if (!_this.player) return null;
	        return _this.player.getSecondsLoaded();
	      }, _this.getInternalPlayer = function () {
	        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
	
	        if (!_this.player) return null;
	        return _this.player.getInternalPlayer(key);
	      }, _this.seekTo = function (fraction) {
	        if (!_this.player) return null;
	        _this.player.seekTo(fraction);
	      }, _this.ref = function (player) {
	        _this.player = player;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SinglePlayer, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return !(0, _utils.isEqual)(this.props, nextProps);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        this.config = (0, _utils.getConfig)(nextProps, _props2.defaultProps);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _config$file = this.config.file,
	            forceVideo = _config$file.forceVideo,
	            forceAudio = _config$file.forceAudio,
	            forceHLS = _config$file.forceHLS,
	            forceDASH = _config$file.forceDASH;
	
	        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
	        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
	          return null;
	        }
	        var _props = this.props,
	            style = _props.style,
	            width = _props.width,
	            height = _props.height,
	            Wrapper = _props.wrapper;
	
	        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props2.DEPRECATED_CONFIG_PROPS);
	        return _react2['default'].createElement(
	          Wrapper,
	          _extends({ style: _extends({}, style, { width: width, height: height }) }, otherProps),
	          _react2['default'].createElement(_Player2['default'], _extends({}, this.props, {
	            ref: this.ref,
	            activePlayer: activePlayer,
	            config: this.config
	          }))
	        );
	      }
	    }]);
	
	    return SinglePlayer;
	  }(_react.Component), _class.displayName = activePlayer.displayName + 'Player', _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _class.canPlay = activePlayer.canPlay, _temp2;
	}

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	exports.parseEndTime = parseEndTime;
	exports.randomString = randomString;
	exports.queryString = queryString;
	exports.getSDK = getSDK;
	exports.getConfig = getConfig;
	exports.omit = omit;
	exports.callPlayer = callPlayer;
	exports.isObject = isObject;
	exports.isEqual = isEqual;
	exports.isMediaStream = isMediaStream;
	
	var _loadScript = __webpack_require__(483);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _deepmerge = __webpack_require__(390);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _props = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseTimeParam(url, pattern) {
	  var match = url.match(pattern);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseTimeString(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp);
	    }
	  }
	  return undefined;
	}
	
	function parseTimeString(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array,
	        _array2 = _slicedToArray(_array, 3),
	        count = _array2[1],
	        period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}
	
	function parseStartTime(url) {
	  return parseTimeParam(url, MATCH_START_QUERY);
	}
	
	function parseEndTime(url) {
	  return parseTimeParam(url, MATCH_END_QUERY);
	}
	
	// http://stackoverflow.com/a/38622545
	function randomString() {
	  return Math.random().toString(36).substr(2, 5);
	}
	
	function queryString(object) {
	  return Object.keys(object).map(function (key) {
	    return key + '=' + object[key];
	  }).join('&');
	}
	
	// Util function to load an external SDK
	// or return the SDK if it is already loaded
	var resolves = {};
	function getSDK(url, sdkGlobal) {
	  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return true;
	  };
	  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript2['default'];
	
	  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
	    return Promise.resolve(window[sdkGlobal]);
	  }
	  return new Promise(function (resolve, reject) {
	    // If we are already loading the SDK, add the resolve
	    // function to the existing array of resolve functions
	    if (resolves[url]) {
	      resolves[url].push(resolve);
	      return;
	    }
	    resolves[url] = [resolve];
	    var onLoaded = function onLoaded(sdk) {
	      // When loaded, resolve all pending promises
	      resolves[url].forEach(function (resolve) {
	        return resolve(sdk);
	      });
	    };
	    if (sdkReady) {
	      var previousOnReady = window[sdkReady];
	      window[sdkReady] = function () {
	        if (previousOnReady) previousOnReady();
	        onLoaded(window[sdkGlobal]);
	      };
	    }
	    fetchScript(url, function (err) {
	      if (err) reject(err);
	      if (!sdkReady) {
	        onLoaded(window[sdkGlobal]);
	      }
	    });
	  });
	}
	
	function getConfig(props, defaultProps, showWarning) {
	  var config = (0, _deepmerge2['default'])(defaultProps.config, props.config);
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = _props.DEPRECATED_CONFIG_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var p = _step.value;
	
	      if (props[p]) {
	        var key = p.replace(/Config$/, '');
	        config = (0, _deepmerge2['default'])(config, _defineProperty({}, key, props[p]));
	        if (showWarning) {
	          var link = 'https://github.com/CookPete/react-player#config-prop';
	          var message = 'ReactPlayer: %c' + p + ' %cis deprecated, please use the config prop instead \u2013 ' + link;
	          console.warn(message, 'font-weight: bold', '');
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return config;
	}
	
	function omit(object) {
	  var _ref;
	
	  for (var _len = arguments.length, arrays = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    arrays[_key - 1] = arguments[_key];
	  }
	
	  var omitKeys = (_ref = []).concat.apply(_ref, arrays);
	  var output = {};
	  var keys = Object.keys(object);
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var key = _step2.value;
	
	      if (omitKeys.indexOf(key) === -1) {
	        output[key] = object[key];
	      }
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	        _iterator2['return']();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  return output;
	}
	
	function callPlayer(method) {
	  var _player;
	
	  // Util method for calling a method on this.player
	  // but guard against errors and console.warn instead
	  if (!this.player || !this.player[method]) {
	    var message = 'ReactPlayer: ' + this.constructor.displayName + ' player could not call %c' + method + '%c \u2013 ';
	    if (!this.player) {
	      message += 'The player was not available';
	    } else if (!this.player[method]) {
	      message += 'The method was not available';
	    }
	    console.warn(message, 'font-weight: bold', '');
	    return null;
	  }
	
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return (_player = this.player)[method].apply(_player, args);
	}
	
	function isObject(val) {
	  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
	}
	
	// Deep comparison of two objects but ignoring
	// functions, for use in shouldComponentUpdate
	function isEqual(a, b) {
	  if (typeof a === 'function' && typeof b === 'function') {
	    return true;
	  }
	  if (a instanceof Array && b instanceof Array) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    for (var i = 0; i !== a.length; i++) {
	      if (!isEqual(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	  if (isObject(a) && isObject(b)) {
	    if (Object.keys(a).length !== Object.keys(b).length) {
	      return false;
	    }
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = Object.keys(a)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var key = _step3.value;
	
	        if (!isEqual(a[key], b[key])) {
	          return false;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	          _iterator3['return']();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    return true;
	  }
	  return a === b;
	}
	
	function isMediaStream(url) {
	  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
	}

/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	module.exports = {"speakers":[{"firstName":"Chelsea ","lastName":"Klukas","job":"Product Design Manager at Facebook","bio":"Chelsea is a product design manager at Facebook and an interdisciplinary technology-focused artist. In addition to building great products, she is passionate about building design culture in data-driven environments and driving processes to innovate at scale. Klukas is also the co-founder of MakeFashion, a wearable technology startup that brings high tech and high fashion to the runway. MakeFashion has created over 100 wearable tech garments and has produced runway shows across the world including New York, Shenzhen, and Rome. Her “Lumen Couture” projector hat, a hat that includes real-time projection mapping and visual inputs to display video on a dress, has gained international attention as the first of its kind. Prior to Facebook, Klukas was a UX design manager at Amazon focused on social consumer products including Amazon Spark and Echo Look. Before Amazon she was the creative director of BeauCoo, a social shopping startup that helped women find clothes that fit, and design lead at Poynt, a cross-platform location-based app with 20M users that pioneered augmented reality features in the early days of iOS. Presented by FITC.","fields":["Product Design","Fashion Technology"],"Industry":"Product Design + Fashion Technology","links":"http://www.chelscore.com","presentationTitles":["\"The Future of Design Careers\""],"headshot":"chelsea_klukas","presentationTitleDesc":[{}]},{"firstName":"Krys","lastName":"Blackwood","job":"Senior Lead User Experience Designer at NASA's Jet Propulsion Laboratory","bio":"Krys has been designing interfaces for 23 years. Most of her career was spent in the Silicon Valley, designing e-commerce experiences for companies ranging from startups to Fortune 500 corporations. She is both a researcher and a designer and specializes in helping companies adopt a user centered approach. She’s now designing the future of mission operations with the Human Centered Design team for NASA’s Jet Propulsion Laboratory in Pasadena, CA. Krys fights for the user. Presented by FITC.","fields":[""],"Industry":"","links":"http://jpl.nasa.gov","presentationTitles":["\"Dreaming of Mars: How User Experience Factors Into NASA Missions\""],"headshot":"krys_blackwood","presentationTitleDesc":[{"title":"Dreaming of Mars: How User Experience Factors Into NASA Missions","desc":"NASA’s rovers on Mars brought us the first proof of water on our neighboring planet. Voyager, Juno and Cassini spacecraft have captured stunning images and with them, the hearts and imaginations of the world.  Learn the soup to nuts of how missions like these become a reality, and how NASA’s Jet Propulsion Laboratory is using design thinking to improve its mission design practices.  You’ll hear firsthand stories of how user experience design fits into an 80 year old process, and how it’s changing the ways that NASA approaches unmanned exploration of the solar system and beyond."}]},{"firstName":"Nicholas","lastName":"Baker","job":"Industrial Design Consultant","bio":"Nicholas Baker is a designer and maker currently residing in Brooklyn, New York. Born and raised in North Carolina, Nicholas started making at a young age in his grandfather's woodshop. After discovering his passion for art and engineering, Nicholas went on to study industrial design at the Savannah College of Art and Design. He interned with a wide range of companies including Boy Scouts of America, Enventys, and HunterGatherer while in school. After graduating in 2015 with a BFA in industrial design, Nicholas moved to Fort Worth, Texas to design full-time for Petmate Pet Products. Nicholas designed 80+ products for Petmate ranging from rubber toys to soft goods to litter boxes. He left Petmate in 2017 to pursue new opportunities in New York City. Nicholas launched a design brand, almost object, in 2017. After freelancing part-time for many years, Nicholas started a full-time industrial design studio in Greenpoint, Brooklyn. In his free time, he enjoys experimenting in virtual reality, instagramming, and podcasting.","fields":["Industrial Design","Education"],"Industry":"ID","links":"http://nicholas-baker.com","presentationTitles":["\"Product Timecapsule Archive Study Collection\""],"headshot":"nick_baker","presentationTitleDesc":[{"title":"Product Timecapsule Archive Study Collection","desc":"This session will introduce attendees to the artifacts of process associated with this special collection that is being developed at RIT. Participants will hear from Professor and Chair of Industrial Design at RIT, Josh Owen, ID Grad Student David Villarreal and ID Junior Kaitlyn Gilmor about how this collection is used by students, faculty, researchers in the field."}]},{"firstName":"Liz","lastName":"Wells","job":"User Experience Designer at Stink Studios","bio":"Liz Wells is a user experience designer based in Brooklyn, New York. Her work combines a background in graphic design with technology and user-centered design thinking. Liz currently works at Stink Studios, where she is responsible for all phases of the UX process, from concepting and information architecture to wireframing and prototyping. Liz advises visual designers and developers throughout the lifecycle of a project to help them meet Stink’s high standards for usability and design. While at Stink Studios, Liz has created products and experiences for a wide range of brands in music, automotive, technology, fashion, media, and nonprofit. Her work has been recognized by The One Show, The Webbys, Awwwards, FWA, Communication Arts, Cannes Lions and D&AD, and featured in The Next Web, The Verge, The New York Times, Quartz, BuzzFeed, Adweek, and Artsy to name a few. Her work on for the Equal Justice Initiative was showcased in an exhibit at the Brooklyn Museum during the summer of 2017 entitled The Legacy of Lynching: Confronting Racial Terror in America, and is currently on display at The Legacy Museum in Montgomery, Alabama. Liz received her BFA in Graphic Design from the Rochester Institute of Technology in 2015. Her foundation in design thinking informs her work as a UX designer. She has guest lectured at SVA and taught a workshop at RIT. In 2017, Liz was a finalist for Young Guns 15 by the The One Club for Creativity/ADC. She has a passion for raising the voices of women and non-binary people, which is why she co-founded Desk Lunch, a newsletter for people in the minority to share personal stories of what it's like to work in the creative industry. She publishes a new issue of Desk Lunch weekly.","fields":[""],"Industry":"Digital Design","links":"http://www.lizvwells.com/","presentationTitles":["Wireframe Sketching Workshop","Getting Uncomfortable"],"headshot":"liz_wells","presentationTitleDesc":[{"title":"Wireframe Sketching Workshop","desc":"This workshop will teach students from all backgrounds and experience levels, how to take a step back from the screen and sketch digital experiences. I’ll teach students the process I go through from user flows, experience maps and wireframes. Students will be able to use the tools I use on a daily basis and help them grow their user experience thinking and skill set!   "}]},{"firstName":"Jonathan ","lastName":"Kim","job":"Creative Director at Rare Volume","bio":"Jonathan Kim is a multi-disciplined Designer and Creative Director passionate about design and its application in various forms. Drawn to the arts at a young age, Jonathan started his career designing visual identities and performance graphics for dance companies in Los Angeles. He studied Digital Media—with an emphasis in Motion Design—at Otis College of Art and Design under the tutelage of instructors such as Chris Do and Jennifer Egger.\n\nThroughout his professional career, Jonathan has held leadership positions across a range of design industries—from boutique design studios to production houses to digital agencies. Doing so has allowed him to create award-winning work for some of the industry’s top brands and products such as, Nike, Samsung, Pepsi, Google, Twitter, Disney, and Hyundai.\n\nIn 2016, he co-founded Rare Volume, a design and technology company in NYC. With a focus in visual design and creative code, Rare Volume’s work reaches beyond traditional advertising, into territories such as interactive exhibit design, retail installations, and large-scale data visualization for brands and corporations.","fields":["Motion Graphic Design","Creative Direction"],"Industry":"Digital + Motion Graphics","links":"http://jonathankim.work","presentationTitles":["\"Digital Design for the Physical Space\""],"headshot":"jonathan_kim","presentationTitleDesc":[{"title":"Digital Design for the Physical Space","desc":"Design as a discipline has been on an amazing journey, beginning with objects, growing to include graphics and print, and more recently moving into motion and interaction. However as the industry has matured and the tools have become more homogeneous, designers are growing restless, looking for what's next. Thankfully, there's a growing appetite for designers' skills in industries previously unable to benefit from their abilities. Tools like Cinder and Processing are paving the way for partnerships between designers and technologists that will fundamentally change not just the content of our screens but also physical environments like museums and retail."}]},{"firstName":"Elvira (Elle)","lastName":"Barriga","job":"Creative Director at Local Project","bio":"Elvira Barriga is a Creative Director at Local Projects, the exhibition and media design studio behind the 9/11 Memorial Museum, the Immersion Room at Cooper Hewitt, the London Mithraeum and many more. She spearheads projects at the intersection of design, architecture, storytelling and technology and leads the Department for Visual Experience Design. Elle is most passionate about shaping creative processes and mentoring talent while looking for powerful concepts that enrich our environments with meaning, beauty and surprise. Her recent projects include ARoS Public for the ARoS Art Museum in Denmark, the Fashion for Good Center in Amsterdam, The Legacy Museum: From Enslavement to Mass Incarceration, and the forthcoming Hyde Park Barracks Museum in Sydney. She has worked internationally for major museums, leading educational institutions and global brands. Before coming to Local Projects, Elle was a Creative Director for Imprint Projects NYC and Bruce Mau Design in Toronto, an Art Director for Meiré und Meiré and a partner at blotto Design, both in Berlin. Presented by FITC.","fields":[""],"Industry":"Exhibition Design, Interactive Media Installations,","links":"http://localprojects.com","presentationTitles":["\"The Creative Leadership Inquiry\""],"headshot":"elvira_barriga","presentationTitleDesc":[{}]},{"firstName":"John","lastName":"Frye","job":"Industrial Designer at Honda R&D; Concept Design Academy","bio":"Raised in Bend, Oregon, John had an early affinity for mobile machinery. Army vehicles, tanks, scenes of car races were early drawing themes. Movies like Battle of Britain, The Great Waldo Pepper, and Star Wars formed lasting influences, the latter forging a link to a future career in industrial design. With a Bachelor of Science degree (with honors) from Art Center, vehicle design work for a variety of clients such as Boeing, Hasbro, John Deere and Activision led to a career at Honda R&D where John is Principal Designer, digital modeling group leader. In his spare creative time, he is obsessively putting ink to paper and churning out concepts, collecting vinyl records, and enjoying the best ramen, Sichuan food, and craft beer that he can track down.","fields":[""],"Industry":"Industrial design- automotive, product, toy, concept design. Vehicle specialist.","links":"www.fryewerk.com","presentationTitles":["\"Heavy duty vehicle design for any realities.\""],"headshot":"john_frye","presentationTitleDesc":[{"title":"Heavy duty vehicle design for any realities.","desc":"Industrial design is art with a purpose and one or many customers. Creating an engaging, memorable design is a mad feat of juggling multiple customer needs, aesthetic considerations, and injecting newness. Sitting down with a blank piece of paper can be paralyzing without a good process. With more than 20 years of design experience, John A. Frye reveals some of the simple methods and tools he uses regularly to tackle new design projects with ease. "}]},{"firstName":"Jessie","lastName":"Smith","job":"Product Designer at Adobe","bio":"Jessie Smith is a UX designer, lettering artist and illustrator working in New York City. After graduating with a degree in New Media Design from RIT in 2016, Jessie moved to Brooklyn and started working as a designer on Creative Cloud apps and web flows at Adobe. In the fall of 2016, Jessie started Tangible Design Shop with her husband, Doug, in an effort to keep creating outside of her UX work at Adobe. Her work is focused on branding, as well as her own personal lettering projects, which she sells on Etsy. Last year, Jessie started teaching lettering workshops in the New York City area. Outside of work, she leads a community group with her church, loves to walk around her neighborhood and occasionally escapes the hustle of New York City to go hiking on the weekends.\n","fields":["Product Design","UX"],"Industry":"Product Design","links":"https://jessieschnall.myportfolio.com/projects","presentationTitles":["\"Recharge your Creative Battery\""],"headshot":"jessie_smith","presentationTitleDesc":[{"title":"Recharge your Creative Battery","desc":"Jessie will share about her experience working at Adobe, and how she balances her full-time job with her passion projects. She'll also dive into her design process, and share some tips for hand lettering."}]},{"firstName":"Lauren","lastName":"O'Neill","job":"Art Director/Designer for Fashion, Editorial, and Lifestyle Brands","bio":"Lauren O’Neill is an art director + multidisciplinary designer based in Brooklyn, New York. Her work often explores the intersection of content and experience through design. She wholeheartedly believe good design starts with strong relationships.\n\nFrom art direction and experiential design to brand strategy and product development, Lauren has worked with small businesses as well as large companies including Kate Spade, Madewell, Martha Stewart Weddings, Color Factory, Domino, Roman & Williams GUILD, Bloomingdale’s, and other lifestyle, retail, restaurant, and product brands. She’s also worked alongside amazing Studiomates, co-created projects such as Nearly Impossible and Studio/Practice, dreamt up more side projects than she cares to admit, and taught graphic design to undergrads at VCUarts.\n\nIn her downtime, she enjoys scouting lovely shops and restaurants, working on a handful of [real] side projects, entertaining with family and friends, and advocating for a number of causes close to her heart.","fields":["Art Direction","Branding"],"Industry":"Design + Art Direction","links":"https://laurenoneilldesign.com/","presentationTitles":["\"Making Your Dream Job a Reality\""],"headshot":"lauren_o_neil","presentationTitleDesc":[{"title":"Making Your Dream Job a Reality","desc":"Through her personal and professional experiences, Lauren will explain how to make your dream job a reality—looking beyond a title, what does your dream job actually entail, what is your definition of success, and does it align with your bigger ambitions? The talk will provide insights and strategies used for connecting with top brands and creatives, plus principles to help position yourself for future growth and job happiness."}]},{"firstName":"Arnaud","lastName":"Tanielian","job":"Technical Director at Stink Studios","bio":"Arnaud Tanielian is an award-winning Technical Director from Marseille, France, currently based in Brooklyn, New York. With a strong commitment to standards and accessibility, Arnaud strives to achieve excellent craft, with a specific attention to details and motion. He currently works at Stink Studios, where has created products and experiences for a wide range of brands in music, automotive, technology, food & beverage, media, and nonprofit, including Google, Spotify, Subaru, Chevrolet, Chobani, the Washington Post and more recently the Center, heart and home of NYC's LGBTQ community.","fields":[""],"Industry":"Digital Advertising in studios","links":"http://cargocollective.com/danetag","presentationTitles":["\"You’re a designer. I’m a developer. Don’t be afraid.\""],"headshot":"arnaud_tanielian","presentationTitleDesc":[{}]},{"firstName":"Emily","lastName":"Herrick","job":"Service Designer for NYC Mayor's Office for Economic Opportunity","bio":"Emily is a design strategist with a practice grounded in curiosity and context. She has designed policy solutions for criminal justice reform, supported international open government initiatives through co-design, and collaborated with municipalities to design human-centered approaches to open data. Prior to joining the team at the Civic Service Design Studio, she worked as a service designer for the research and design consulting firm, Reboot, where she dabbled between the lines of communications design and service delivery. A Midwestern transplant, Emily graduated from Illinois State University with dual BAs in Graphic Design and Arts Technology and holds an MFA in Design for Social Innovation from the School of Visual Arts. Outside the office, you can find her wandering around Prospect Park or scouring the city for NYC’s best slice.","fields":[""],"Industry":"Service Design, Ux Design, Civic Design","links":"http://civicservicedesign.com","presentationTitles":["\"People + Processes: Designing Intangible Thing\""],"headshot":"emily_herrick","presentationTitleDesc":[{"title":"People + Processes: Designing Intangible Thing","desc":"Design school is a great place to learn about how to design tangible things: logos, posters, digital products, app interfaces, videos, and service concepts. But what about designing the intangible? Grasping the intangible often requires embracing an attitude that enables you to navigate through the fog of messy systems and politics so that you can design clear and meaningful solutions. In this talk, I will share my experience applying design to social problems and unpack how I have used the methods I learned in design school to create processes that drive collaboration, creative problem-solving, and organizational learning within large institutions. We’ll look at things like how design-informed approaches can help individuals experiencing homelessness access services, improve the quality of care within the child welfare system, and rethink how we support people in the criminal justice system."}]},{"firstName":"Meg","lastName":"Lewis","job":"Designer/Educator at Ghostly Ferns, Full Time You, Fool Proof","bio":"Meg empowers individuals to discover their unique selves through books, video series, workshops, and talks titled \"Full Time You.\" She also coaches, creates friendly experiences, and teaches workshops for happy companies. Meg founded Ghostly Ferns, an international collective of designers and commercial artists. In Minnesota, she co-founded Fool Proof, a shared workspace for creativity and collaboration.","fields":["Graphic Design","Branding"],"Industry":"Brand + Graphic Design","links":"http://darngood.co","presentationTitles":["\"On My Own\""],"headshot":"meg_lewis","presentationTitleDesc":[{"title":"On My Own","desc":"As students and adults we’re taught to rely on others for opportunities, promotions, and career success but what if there was a way to have everything we want all on our own? Join me, designer, educator, and entrepreneur Meg Lewis as I discuss how I created a totally self-sustainable, successful career by myself and how you can too!"}]},{"firstName":"Timmy","lastName":"Chau","job":"Experience Design Lead at New Deal Design","bio":"TLDR: Sub-par designer that’s worked on a lot of different things. RIT New Media Design 14' Alum. Eats a lot and enjoys drawing, 3D, and motion design.\n\nTimmy Chau is a multidisciplinary designer and creative based in San Francisco. He’s had experiences working with a variety of technologies like wearables, IOT, robotics, medicine, wellness, consumer toys, web, app, e-commerce, editorial media, and much more.\n\nHis work has been featured in Fast Company, Wall Street Journal, USA Today, Gizmodo and received awards from Adobe, Webbys, IDSA, and CES.\n\nHe graduated from RIT’s New Media Design program in 2014 and was previously an experience designer at a Fantasy.\n\nTimmy currently helps lead the Experience Design team at New Deal Design where they create human-centric experiences for physical and digital products. He’s worked with the team to create products like Play Impossible, a reinvention of the ball, and Dragonfly, an intelligent home system that replaces your lights.\n\nWhen he’s not working or eating, he enjoys illustration and experimenting in 3D and animation.","fields":[""],"Industry":"","links":"http://www.monkeychau.com","presentationTitles":["\"\""],"headshot":"timmy_chau","presentationTitleDesc":[{}]},{"firstName":"Ben","lastName":"Sorensen","job":"Product Designer at DoorDash","bio":"Graduated from RIT New Media Design in ‘14. Was previously at Odopod for 3 years as an interaction designer specializing in motion, prototyping and concept design. Now at DoorDash as a product designer working on consumer products.","fields":["\"Product Design\""],"Industry":"","links":"https://www.bendesign.in/","presentationTitles":["\"\""],"headshot":"ben_sorensen","presentationTitleDesc":[{"title":"Ben Here, Done That.","desc":"What should you know about working in the real world? What's the difference between product design at an agency and product design at a startup?How do you get an apartment in San Francisco? What's work life balance? Join me to hear about my journey from new media design to agency life, and now to product design. I'll break some of the misconceptions and personal lessons learned to hopefully reduce the anxiety of transitioning to the real world."}]},{"firstName":"Guillermo ","lastName":"Fok","job":"Project Designer at Tait","bio":"Guillermo worked in the manufacturing industry as an industrial engineer before making a shift into industrial design, a field he had always had a great interest interested in. After attending grad school at RIT as a Fulbright scholar, Guillermo moved to LA to work as an Imagineer at the Walt Disney Company, creating practical special effects and illusions for theme park attractions. Always being interested in product and environmental design, Guillermo continued his professional path as a Project Designer at TAIT, where he collaborates, develops and designs custom stages, set pieces and automation elements for clients like P!nk, Taylor Swift, Lady Gaga, and Cirque Du Soleil.","fields":[""],"Industry":"","links":"http://www.guillermofok.com","presentationTitles":["\"Industrial Design in Entertainment\""],"headshot":"guillermo_fok","presentationTitleDesc":[{}]},{"firstName":"Jen","lastName":"Byyny","job":"Senior Director of Product Experience Design at Welltok, Inc.","bio":"Jen Byyny is an end-to-end Product/UX/Visual Design Director with over fourteen years of experience. Her background includes degrees in Business Marketing and Media Design, roles in design management, art direction in advertising and interactive experiences for web and mobile. Jen is a system thinker and loves to ask, \"What if we tried...?\" She gets excited about leading teams, brainstorming new ideas to create strategically aligned business experiences with designers, researchers, engineers and product partners.","fields":[""],"Industry":"product design + UX","links":"http://jenbyyny.com/","presentationTitles":["\"The Post Grad Talk - Where to go after college\""],"headshot":"jen_byyny","presentationTitleDesc":[{"title":"The Post Grad Talk - Where to go after college","desc":"As you finish your final projects and your time in your studies draws to a close, what will you do next? Start-up? Agency/Consultancy? Work for yourself? Join a product company, and if so what size? 150, 400, 12,000 people? Work on-site? Or work from home?"}]},{"firstName":"Sean","lastName":"Wolcott","job":"Creative Director & Founder for Rationale","bio":"Sean Wolcott is a Seattle-based graphic designer. Having created design experiences for millions, Sean runs his own design studio, Rationale, where he designs identities, packaging, signage, publications, websites, and user interfaces for a wide range of clients.","fields":[""],"Industry":"Graphics, apps, websites, books, posters, etc.","links":"http://rationale-design.com","presentationTitles":[""],"headshot":"sean_wolcott","presentationTitleDesc":[{"title":"Basics for better design","desc":"This talk will focus on the process and benefits of how to use constraints to be more creative, clever, and clear as designers in practical ways you can apply daily."}]},{"firstName":"Meghan","lastName":"Preiss","job":"Design Research and Strategist at RKS Design","bio":"As a Design Researcher and Synthesizer at the global design consultancy RKS, Meghan Preiss works with clients to uncover user needs and identify ways to empower stakeholders. She is mesmerized by design processes and loves to develop strategies that create solutions for our world’s problems. Before RKS, Meghan attended SCAD and completed degrees focused in both industrial and service design. During that time, she led team projects with clients like BMW and Hewlett-Packard. While a student, she was very active in nurturing her community by serving as President, Vice-President, and Chair of the Service Design Club, the SCAD IDSA Chapter, and National Student Section at IDSA. Since moving to the west coast, Meghan became Chair of the Los Angeles IDSA Chapter and is actively growing the organization’s regional influence. Over the years, Meghan’s secret for personal growth has been attending numerous SHiFT events. She admits that the immersive SHiFT Camps are where she discovered her voice and began to craft her leadership style and confidence. Recently, she began to volunteer as staff for SHiFT and travel the world to support and assist the organization in training the next generation of creative leaders. Meghan has chosen to be connected and active in meaningful organizations around the world, because she believes that Design is community and it’s the best way to create change.","fields":["Industrial Design","Research"],"Industry":"Service Design and Research design","links":"https://www.rksdesign.com/","presentationTitles":["\"Design for the Senses\""],"headshot":"meghan_preiss","presentationTitleDesc":[{}]},{"firstName":"Jeff ","lastName":"Smith","job":"Education Manager at Autodesk","bio":"Jeff Smith is a passionate industrial designer with nearly 20 years in the industry and a true TAW veteran, returning for the 4th time. He is currently the Education Program Manager at Autodesk. A diverse range of clients gives him the opportunity to work on a cross section of consumer products and markets. A strong supporter of design education, Smith was also an adjunct faculty member at the Art Institute of Ft. Lauderdale for eight years. Currently, he hosts workshops and events at ID programs around the US, such as Virginia Tech, RIT and Georgia Tech. He continues to be an inspiration and friend to the young design world.","fields":[""],"Industry":"Product Design and Computer Aided Design","links":"","presentationTitles":["\"\""],"headshot":"jeff_smith","presentationTitleDesc":[{}]},{"firstName":"Miguel A","lastName":"Cardona Jr.","job":"Designer, Illustrator and Assistant Professor of New Media Design","bio":"Miguel is a designer, illustrator, and creative coder. After studying both new media design and industrial design at RIT, he now specializes in designing and developing interactive projects for companies like Kodak, Nick.com, Xerox and McNeil Nutritionals. He currently teaches in the New Media Design program at RIT. In the past, he's helped to build imgix.com as the Lead Designer and co-founded Dumbwaiter design, a Rochester based interactive agency.\n","fields":["UI/UX","Marketing","Illustration"],"Industry":"","links":"http://miggi.me/","presentationTitles":["\"Once you start mimicking, you stop looking\""],"headshot":"miguel_cardona","presentationTitleDesc":[{"title":"Once you start mimicking, you stop looking","desc":"Massimo Vignelli learned early in his career that a designer should be able to design everything, coining the term ‘Design is One.’ This presentation will focus on the bridges that exist between graphic, industrial, web, and user experience design with a focus on producing artifacts and communication when developing and disseminating work across different platforms and media."}]},{"firstName":"Amelia","lastName":"Fontanel","job":"Associate Curator of the Cary Collection","bio":"Amelia Hugill-Fontanel is associate curator at the Cary Graphic Arts Collection at Rochester Institute of Technology — a renowned library on printing history. She is an art historian and editor who contributes numerous publications about Cary Collection holdings, including those about graphic design, calligraphy, wood type, and typefounding. As manager of the Cary technology collection, she is responsible for teaching and maintaining some 20 different presses and several hundred fonts of metal and wood type. She has lectured for the American Printing History Association, College Art Association, the Hamilton Wood Type & Printing Museum, TypeCon, The Typophiles, the U.S. Government Publishing Office, and Yale University.","fields":[""],"Industry":"Typography, graphic design, printing history","links":"http://cary.rit.edu","presentationTitles":["\"Your Typographic Librarian\""],"headshot":"amelia_fontanel","presentationTitleDesc":[{"title":"Your Typographic Librarian","desc":"Archives and libraries contain infinite resources for twenty-first century typographic inspiration. Obscure matrices, colonial papers, scrawling personal letters, and rare films from the RIT Cary Graphic Arts Collection have all recently stimulated creative endeavors by our most enthusiastic patrons—type designers, educators, and designers like you! Join me, “your typographic librarian,” as I describe some great projects where history, technology, and design intersect—perhaps encouraging you to get to know your campus rare book library scientist."}]},{"firstName":"Emily ","lastName":"Dominguez","job":"User Experience Designer ","bio":"Emily Dominguez graduated from RIT’s Saunders College of Business with a degree in New Media Marketing and MIS. After graduating, she joined M&T Bank and went through their Management Development Program. Currently, she is a User Experience Designer on the Experience and Design team working on the redesign of the bank’s ATM UI. Outside of work, she loves trying new restaurants with her husband, Dan, and Mini Dachsund, Braxton, refurbishing furniture, and of course binge watching shows on Netflix.","fields":["\"UX\""],"Industry":"User Experience Design","links":"","presentationTitles":["\"designing for humans: leveraging the lean ux canvas to build successful products\"\n"],"headshot":"emily_dominguez","presentationTitleDesc":["{ title : \"designing for humans: leveraging the lean ux canvas to build successful products\"","desc : \"Knowing what problem to solve next is a complicated task. It is even more difficult when designing products or services for humans. It is imperative for designers to understand how to practice effective discovery methods in order to solve real problems for customers as well as simultaneously feeding delivery efforts. The Lean UX Canvas is a tool that we use that helps us effectively frame our work, establish outcomes, know who we are designing for, and test our assumptions. This helps us create a collaborative, customer-centric environment that brings together product design, user experience, engineering, and product management, that focuses on building the right product and building the product right.\""]},{"firstName":"John","lastName":"McCartney","job":"User Experience Designer ","bio":"John McCartney is a User Experience designer in M&T Bank’s Experience and Design group. Currently based in Buffalo, New York, John focuses on strategy, user-centered design, Design-Thinking, and usability. With a background in Human-Computer Interaction and Cognitive Science, he is passionate about creating business cultures that are highly focused on keeping humans and their needs at the center of every conversation. Prior to M&T Bank, John was a User Experience Designer at a higher education software company and a materials science start-up.","fields":["\"UX\""],"Industry":"User Experience Design","links":"","presentationTitles":["\"designing for humans: leveraging the lean ux canvas to build successful products\"\n"],"headshot":"john_mccartney","presentationTitleDesc":["{ title : \"designing for humans: leveraging the lean ux canvas to build successful products\"","desc : \"Knowing what problem to solve next is a complicated task. It is even more difficult when designing products or services for humans. It is imperative for designers to understand how to practice effective discovery methods in order to solve real problems for customers as well as simultaneously feeding delivery efforts. The Lean UX Canvas is a tool that we use that helps us effectively frame our work, establish outcomes, know who we are designing for, and test our assumptions. This helps us create a collaborative, customer-centric environment that brings together product design, user experience, engineering, and product management, that focuses on building the right product and building the product right.\""]}]}

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HomeAboutAnimation = __webpack_require__(260);
	
	var _HomeAboutAnimation2 = _interopRequireDefault(_HomeAboutAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeAbout = function (_Component) {
	  (0, _inherits3.default)(HomeAbout, _Component);
	
	  function HomeAbout(props) {
	    (0, _classCallCheck3.default)(this, HomeAbout);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  HomeAbout.prototype.render = function render() {
	    var aboutMaxWidthStyle = {
	      maxWidth: '570px'
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('gridish-container--complete container gridish-grid content-Block--margin-top') },
	      _react2.default.createElement(
	        'h3',
	        { className: (0, _classnames2.default)('gridish-grid__col--medium--5 gridish-grid__col--small--4 gridish-grid__col--xsmall--3 gridish-grid__height--xsmall--10 text-transform--unset') },
	        'A design conference made for students by students.'
	      ),
	      _react2.default.createElement(_HomeAboutAnimation2.default, null),
	      _react2.default.createElement(
	        'h3',
	        { className: (0, _classnames2.default)('gridish-grid__col--medium--5 gridish-grid__col--small--5 gridish-grid__col--xsmall-4 text-transform--unset'), style: aboutMaxWidthStyle },
	        'We provide a variety of talks, design workshops, after parties and more. Held at RIT in Rochester, NY.'
	      )
	    );
	  };
	
	  return HomeAbout;
	}(_react.Component);
	
	exports.default = HomeAbout;
	module.exports = exports['default'];

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

	module.exports = {"v":"5.1.10","fr":29.9700012207031,"ip":50.0000020365418,"op":250.000010182709,"w":450,"h":150,"nm":"home_graphic 2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":3,"nm":"blue_cone_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[5],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[2],"e":[9]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[9],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[3],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[5],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"blue_cone Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":22.335,"ix":3},"y":{"a":0,"k":82.938,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('blue_cone_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,22.099,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-8.506,0],[-0.379,4.536],[0,0]],"o":[[0.379,4.536],[8.506,0],[0,0],[0,0]],"v":[[-16.107,10.549],[0.001,18.849],[16.107,10.549],[0.001,-17.349]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.723,0],[0,6.547],[-0.132,0.228],[0,0],[-0.536,0],[-0.268,-0.464],[0,0],[0,-0.264]],"o":[[-10.723,0],[0,-0.264],[0,0],[0.268,-0.464],[0.536,0],[0,0],[0.132,0.228],[0,6.547]],"v":[[0.001,21.849],[-19.122,10.174],[-18.921,9.424],[-1.299,-21.099],[0.001,-21.849],[1.299,-21.099],[18.921,9.424],[19.122,10.174]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,5.619],[0,0],[0,0],[9.732,0]],"o":[[0,0],[0,0],[0,5.619],[-9.733,0]],"v":[[-17.622,10.174],[0.001,-20.349],[17.622,10.174],[0.001,20.349]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125,0.442999985639,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"blue_cone_shadow Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":30.012,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('blue_cone_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":98.613,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('blue_cone_controller').transform.yPosition);"}},"a":{"a":0,"k":[20.617,11.549,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.293,0.507],[0,0],[0.294,0.128],[9.712,-3.741],[-0.026,-0.073],[-0.526,-0.096],[0,0],[-0.09,0],[-0.284,0.404]],"o":[[0,0],[-0.161,-0.278],[-0.424,-0.184],[-10.706,4.123],[0.181,0.503],[0,0],[0.09,0.016],[0.483,0],[0.337,-0.478]],"v":[[20.074,9.048],[11.253,-6.215],[10.551,-6.84],[-9.661,-7.557],[-17.891,3.854],[-16.749,4.822],[18.505,11.275],[18.774,11.299],[20.001,10.663]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803660154343,0.782468318939,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20.616,11.549],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"red_ball_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":25,"s":[5],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":75,"s":[3],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":125,"s":[7],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":175,"s":[3],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":225,"s":[5],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":275,"s":[3],"e":[0]},{"t":325.000013237521}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"red_ball Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":113.552,"ix":3},"y":{"a":0,"k":103.271,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('red_ball_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,19.372,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.891,0],[0,-8.891],[-8.89,0],[0,8.89]],"o":[[-8.89,0],[0,8.89],[8.891,0],[0,-8.891]],"v":[[-0.001,-16.122],[-16.123,0.001],[-0.001,16.122],[16.123,0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.545,0],[0,10.544],[-10.544,0],[0,-10.545]],"o":[[-10.544,0],[0,-10.545],[10.545,0],[0,10.544]],"v":[[-0.001,19.122],[-19.123,0.001],[-0.001,-19.122],[19.123,0.001]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,19.372],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-9.732],[9.733,0],[0,9.733],[-9.732,0]],"o":[[0,9.733],[-9.732,0],[0,-9.732],[9.733,0]],"v":[[17.622,0],[-0.001,17.623],[-17.622,0],[-0.001,-17.623]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.195999998205,0.313999998803,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,19.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"red_ball_shadow Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":119.448,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('red_ball_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":116.177,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('red_ball_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,11.924,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.723,0],[0,-6.547],[-10.723,0],[0,6.546]],"o":[[-10.723,0],[0,6.546],[10.723,0],[0,-6.547]],"v":[[0.001,-11.674],[-19.122,0.001],[0.001,11.674],[19.122,0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.925],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":3,"nm":"yellow_cube_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[7],"e":[4]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[4],"e":[6]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[6],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[3],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[7],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"yellow_cube Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":205.331,"ix":3},"y":{"a":0,"k":66.79,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('yellow_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,22.133,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-14.622,0.034],[0.001,8.476],[14.622,0.034],[0.001,-8.408]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.232,0.134],[0,0],[0,0.536],[-0.464,0.268],[0,0],[-0.465,-0.269],[0,0],[0,-0.536],[0.464,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,-0.536],[0,0],[0.465,-0.269],[0,0],[0.464,0.268],[0,0.536],[0,0],[-0.232,0.134]],"v":[[0.001,11.708],[-0.749,11.507],[-18.372,1.333],[-19.122,0.034],[-18.372,-1.265],[-0.749,-11.439],[0.751,-11.439],[18.372,-1.265],[19.122,0.034],[18.372,1.333],[0.751,11.507]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.958],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0,-10.174],[17.623,-0.001],[0,10.174],[-17.623,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.976000019148,0.957000014361,0.847000002394,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.992],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0.465,0.268],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-0.465,0.268],[0,0],[0,0]],"v":[[-16.122,4.255],[0.001,13.564],[16.122,4.255],[16.122,-12.63],[0.751,-3.755],[-0.749,-3.755],[-16.122,-12.63]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.232,0.134],[0,0],[0,0.536],[0,0],[-0.464,0.267],[-0.465,-0.269],[0,0],[0,0],[-0.465,-0.269],[0,-0.537],[0,0],[0.464,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,0],[0,-0.537],[0.465,-0.269],[0,0],[0,0],[0.465,-0.269],[0.464,0.267],[0,0],[0,0.536],[0,0],[-0.232,0.134]],"v":[[0.001,16.796],[-0.749,16.594],[-18.372,6.419],[-19.122,5.12],[-19.122,-15.227],[-18.372,-16.526],[-16.872,-16.526],[0.001,-6.785],[16.872,-16.526],[18.372,-16.526],[19.122,-15.227],[19.122,5.12],[18.372,6.419],[0.751,16.594]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,27.22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":4,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,-5.088],[-17.623,-15.262],[-17.623,5.087],[0,15.262],[17.623,5.087],[17.623,-15.262]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.948999980852,0.760999971278,0.152999997606,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,27.254],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"yellow_cube_shadow Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":214.669,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('yellow_cube_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":82.317,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('yellow_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,11.959,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.464,0.268],[0,0],[0.465,-0.268],[0,0],[0,-0.535],[-0.464,-0.268],[0,0],[-0.259,0],[-0.232,0.134],[0,0],[0,0.536]],"o":[[0,0],[-0.465,-0.268],[0,0],[-0.464,0.268],[0,0.536],[0,0],[0.232,0.134],[0.259,0],[0,0],[0.464,-0.268],[0,-0.535]],"v":[[18.372,-1.266],[0.751,-11.441],[-0.749,-11.441],[-18.372,-1.266],[-19.122,0.034],[-18.372,1.333],[-0.749,11.507],[0.001,11.708],[0.751,11.507],[18.372,1.333],[19.122,0.034]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.959],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":3,"nm":"red_cone_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[5],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[2],"e":[6]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[6],"e":[1]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[1],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[5],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"red_cone Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":296.085,"ix":3},"y":{"a":0,"k":102.938,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('red_cone_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,22.099,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-8.506,0],[-0.379,4.536],[0,0]],"o":[[0.379,4.536],[8.506,0],[0,0],[0,0]],"v":[[-16.107,10.549],[0.001,18.849],[16.107,10.549],[0.001,-17.349]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.723,0],[0,6.547],[-0.132,0.228],[0,0],[-0.536,0],[-0.268,-0.464],[0,0],[0,-0.264]],"o":[[-10.723,0],[0,-0.264],[0,0],[0.268,-0.464],[0.536,0],[0,0],[0.132,0.228],[0,6.547]],"v":[[0.001,21.849],[-19.122,10.174],[-18.921,9.424],[-1.299,-21.099],[0.001,-21.849],[1.299,-21.099],[18.921,9.424],[19.122,10.174]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,5.619],[0,0],[0,0],[9.732,0]],"o":[[0,0],[0,0],[0,5.619],[-9.733,0]],"v":[[-17.622,10.174],[0.001,-20.349],[17.622,10.174],[0.001,20.349]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.196078434587,0.313725501299,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"red_cone_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":303.262,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('red_cone_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":118.113,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('red_cone_controller').transform.yPosition);"}},"a":{"a":0,"k":[20.617,11.549,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.293,0.507],[0,0],[0.294,0.128],[9.712,-3.741],[-0.026,-0.073],[-0.526,-0.096],[0,0],[-0.09,0],[-0.284,0.404]],"o":[[0,0],[-0.161,-0.278],[-0.424,-0.184],[-10.706,4.123],[0.181,0.503],[0,0],[0.09,0.016],[0.483,0],[0.337,-0.478]],"v":[[20.074,9.048],[11.253,-6.215],[10.551,-6.84],[-9.661,-7.557],[-17.891,3.854],[-16.749,4.822],[18.505,11.275],[18.774,11.299],[20.001,10.663]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20.616,11.549],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":3,"nm":"yellow_cylinder_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":25,"s":[7],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":75,"s":[5],"e":[8]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":125,"s":[8],"e":[6]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":175,"s":[6],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":225,"s":[7],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":275,"s":[5],"e":[0]},{"t":325.000013237521}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"yellow_cylinder Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":405.814,"ix":3},"y":{"a":0,"k":105.07,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('yellow_cylinder_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,22.099,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.739,0],[0,-4.702],[-8.739,0],[0,4.702]],"o":[[-8.739,0],[0,4.702],[8.739,0],[0,-4.702]],"v":[[0.001,-8.674],[-16.122,-0.001],[0.001,8.674],[16.122,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.723,0],[0,6.547],[-10.724,0],[0,-6.546]],"o":[[-10.724,0],[0,-6.546],[10.723,0],[0,6.547]],"v":[[0.001,11.674],[-19.122,-0.001],[0.001,-11.674],[19.122,-0.001]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.925],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-5.619],[9.733,0],[0,5.619],[-9.732,0]],"o":[[0,5.619],[-9.732,0],[0,-5.619],[9.733,0]],"v":[[17.622,0],[-0.001,10.174],[-17.622,0],[-0.001,-10.174]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.976000019148,0.957000014361,0.847000002394,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.924],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.828,0],[0,0.828],[0,0],[0,0],[0,0],[0.828,0],[0,0.828],[0,0],[-0.828,0],[0,0],[0,-0.829],[0,0]],"o":[[-0.828,0],[0,0],[0,0],[0,0],[0,0.828],[-0.828,0],[0,0],[0,-0.829],[0,0],[0.828,0],[0,0],[0,0.828]],"v":[[17.622,11.674],[16.122,10.174],[16.122,-8.674],[-16.122,-8.674],[-16.122,10.174],[-17.622,11.674],[-19.122,10.174],[-19.122,-10.174],[-17.622,-11.674],[17.622,-11.674],[19.122,-10.174],[19.122,10.174]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[17.622,10.174],[17.622,-10.174],[-17.622,-10.174],[-17.622,10.174]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.948999980852,0.760999971278,0.152999997606,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,22.099],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.739,0],[0,-4.702],[-8.739,0],[0,4.702]],"o":[[-8.739,0],[0,4.702],[8.739,0],[0,-4.702]],"v":[[0.001,-8.675],[-16.122,0],[0.001,8.675],[16.122,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.723,0],[0,6.546],[-10.724,0],[0,-6.547]],"o":[[-10.724,0],[0,-6.547],[10.723,0],[0,6.546]],"v":[[0.001,11.675],[-19.122,0],[0.001,-11.675],[19.122,0]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,32.274],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":4,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-5.619],[9.733,0],[0,5.619],[-9.732,0]],"o":[[0,5.619],[-9.732,0],[0,-5.619],[9.733,0]],"v":[[17.622,0.001],[-0.001,10.174],[-17.622,0.001],[-0.001,-10.174]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.948999980852,0.760999971278,0.152999997606,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,32.273],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"yellow_cylinder_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":413.186,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('yellow_cylinder_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":120.105,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('yellow_cylinder_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,11.924,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.724,0],[0,-6.547],[-10.723,0],[0,6.546]],"o":[[-10.723,0],[0,6.546],[10.724,0],[0,-6.547]],"v":[[-0.001,-11.674],[-19.122,-0.001],[-0.001,11.674],[19.122,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.924],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":3,"nm":"blue_ball_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":25,"s":[5],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":75,"s":[2],"e":[4]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":125,"s":[4],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":175,"s":[2],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":225,"s":[5],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":275,"s":[2],"e":[0]},{"t":325.000013237521}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"blue_ball Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":421.427,"ix":3},"y":{"a":0,"k":71.271,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('blue_ball_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,19.372,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.891,0],[0,-8.891],[-8.89,0],[0,8.89]],"o":[[-8.89,0],[0,8.89],[8.891,0],[0,-8.891]],"v":[[-0.001,-16.122],[-16.123,0.001],[-0.001,16.122],[16.123,0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.545,0],[0,10.544],[-10.544,0],[0,-10.545]],"o":[[-10.544,0],[0,-10.545],[10.545,0],[0,10.544]],"v":[[-0.001,19.122],[-19.123,0.001],[-0.001,-19.122],[19.123,0.001]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,19.372],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-9.732],[9.733,0],[0,9.733],[-9.732,0]],"o":[[0,9.733],[-9.732,0],[0,-9.732],[9.733,0]],"v":[[17.622,0],[-0.001,17.623],[-17.622,0],[-0.001,-17.623]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.1254902035,0.443137258291,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,19.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"blue_ball_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":427.323,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('blue_ball_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":84.177,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('blue_ball_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,11.924,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.723,0],[0,-6.547],[-10.723,0],[0,6.546]],"o":[[-10.723,0],[0,6.546],[10.723,0],[0,-6.547]],"v":[[0.001,-11.674],[-19.122,0.001],[0.001,11.674],[19.122,0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.925],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":19,"ty":3,"nm":"red_cube_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[5],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[7],"e":[4]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[4],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[7],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[5],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"red_cube Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":369.206,"ix":3},"y":{"a":0,"k":46.79,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('red_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,22.133,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-14.622,0.034],[0.001,8.476],[14.622,0.034],[0.001,-8.408]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.232,0.134],[0,0],[0,0.536],[-0.464,0.268],[0,0],[-0.465,-0.269],[0,0],[0,-0.536],[0.464,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,-0.536],[0,0],[0.465,-0.269],[0,0],[0.464,0.268],[0,0.536],[0,0],[-0.232,0.134]],"v":[[0.001,11.708],[-0.749,11.507],[-18.372,1.333],[-19.122,0.034],[-18.372,-1.265],[-0.749,-11.439],[0.751,-11.439],[18.372,-1.265],[19.122,0.034],[18.372,1.333],[0.751,11.507]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.958],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0,-10.174],[17.623,-0.001],[0,10.174],[-17.623,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.600000023842,0.600000023842,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.992],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0.465,0.268],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-0.465,0.268],[0,0],[0,0]],"v":[[-16.122,4.255],[0.001,13.564],[16.122,4.255],[16.122,-12.63],[0.751,-3.755],[-0.749,-3.755],[-16.122,-12.63]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.232,0.134],[0,0],[0,0.536],[0,0],[-0.464,0.267],[-0.465,-0.269],[0,0],[0,0],[-0.465,-0.269],[0,-0.537],[0,0],[0.464,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,0],[0,-0.537],[0.465,-0.269],[0,0],[0,0],[0.465,-0.269],[0.464,0.267],[0,0],[0,0.536],[0,0],[-0.232,0.134]],"v":[[0.001,16.796],[-0.749,16.594],[-18.372,6.419],[-19.122,5.12],[-19.122,-15.227],[-18.372,-16.526],[-16.872,-16.526],[0.001,-6.785],[16.872,-16.526],[18.372,-16.526],[19.122,-15.227],[19.122,5.12],[18.372,6.419],[0.751,16.594]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,27.22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":4,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,-5.088],[-17.623,-15.262],[-17.623,5.087],[0,15.262],[17.623,5.087],[17.623,-15.262]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.196078434587,0.313725501299,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,27.254],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"red_cube_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":378.544,"ix":3},"y":{"a":0,"k":62.317,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('red_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,11.959,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.464,0.268],[0,0],[0.465,-0.268],[0,0],[0,-0.535],[-0.464,-0.268],[0,0],[-0.259,0],[-0.232,0.134],[0,0],[0,0.536]],"o":[[0,0],[-0.465,-0.268],[0,0],[-0.464,0.268],[0,0.536],[0,0],[0.232,0.134],[0.259,0],[0,0],[0.464,-0.268],[0,-0.535]],"v":[[18.372,-1.266],[0.751,-11.441],[-0.749,-11.441],[-18.372,-1.266],[-19.122,0.034],[-18.372,1.333],[-0.749,11.507],[0.001,11.708],[0.751,11.507],[18.372,1.333],[19.122,0.034]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156862750649,0.117647059262,0.207843139768,1],"ix":4},"o":{"a":0,"k":20,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.959],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":22,"ty":3,"nm":"big_cube_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[5],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[7],"e":[4]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[4],"e":[7]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[7],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[5],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"big_cube Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":361.163,"ix":3},"y":{"a":0,"k":83.114,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('big_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[36.995,42.482,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-32.245,0.033],[-0.001,18.65],[32.245,0.033],[-0.001,-18.583]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.233,0.134],[0,0],[0,0.536],[-0.464,0.268],[0,0],[-0.465,-0.269],[0,0],[0,-0.536],[0.463,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,-0.536],[0,0],[0.465,-0.269],[0,0],[0.463,0.268],[0,0.536],[0,0],[-0.232,0.134]],"v":[[-0.001,21.883],[-0.751,21.682],[-35.995,1.333],[-36.745,0.033],[-35.995,-1.266],[-0.751,-21.613],[0.75,-21.613],[35.995,-1.266],[36.745,0.033],[35.995,1.333],[0.75,21.682]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[36.995,22.133],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0,-20.349],[35.245,0],[0,20.349],[-35.245,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.6,0.8,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[36.995,22.166],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0.465,0.268],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[-0.465,0.268],[0,0],[0,0]],"v":[[-33.745,9.341],[-0.001,28.824],[33.745,9.341],[33.745,-27.892],[0.749,-8.842],[-0.751,-8.842],[-33.745,-27.892]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0.259,0],[0.233,0.133],[0,0],[0,0.536],[0,0],[-0.464,0.268],[-0.465,-0.268],[0,0],[0,0],[-0.465,-0.268],[0,-0.536],[0,0],[0.463,-0.268],[0,0]],"o":[[-0.259,0],[0,0],[-0.464,-0.268],[0,0],[0,-0.536],[0.465,-0.268],[0,0],[0,0],[0.465,-0.268],[0.463,0.268],[0,0],[0,0.536],[0,0],[-0.232,0.133]],"v":[[-0.001,32.057],[-0.751,31.856],[-35.995,11.506],[-36.745,10.207],[-36.745,-30.49],[-35.995,-31.789],[-34.495,-31.789],[-0.001,-11.873],[34.495,-31.789],[35.995,-31.789],[36.745,-30.49],[36.745,10.207],[35.995,11.506],[0.749,31.856]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[36.996,52.656],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":4,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,-10.174],[-35.245,-30.523],[-35.245,10.174],[0,30.523],[35.245,10.174],[35.245,-30.523]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125,0.442999985639,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[36.995,52.689],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"big_cube_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":379.837,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('big_cube_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":114.167,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('big_cube_controller').transform.yPosition);"}},"a":{"a":0,"k":[36.995,22.132,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.465,0.268],[0,0],[0.465,-0.268],[0,0],[0,-0.536],[-0.464,-0.268],[0,0],[-0.26,0],[-0.233,0.135],[0,0],[0,0.535]],"o":[[0,0],[-0.465,-0.268],[0,0],[-0.464,0.268],[0,0.535],[0,0],[0.232,0.135],[0.258,0],[0,0],[0.465,-0.268],[0,-0.536]],"v":[[35.995,-1.265],[0.751,-21.614],[-0.749,-21.614],[-35.995,-1.265],[-36.745,0.034],[-35.995,1.333],[-0.749,21.681],[0.001,21.882],[0.751,21.681],[35.995,1.333],[36.745,0.034]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[36.995,22.132],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":25,"ty":3,"nm":"tall_cylinder_controller","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":225,"ix":3},"y":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":50,"s":[5],"e":[3]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":100,"s":[3],"e":[4]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":150,"s":[4],"e":[2]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":200,"s":[2],"e":[5]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":250,"s":[5],"e":[0]},{"t":300.00001221925}],"ix":4}},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"tall_cylinder Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":334.315,"ix":3},"y":{"a":0,"k":54.07,"ix":4,"x":"var $bm_rt;\n$bm_rt = sub(transform.yPosition, thisComp.layer('tall_cylinder_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.373,39.391,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.74,0],[0,-4.702],[-8.739,0],[0,4.702]],"o":[[-8.739,0],[0,4.702],[8.74,0],[0,-4.702]],"v":[[-0.001,-8.674],[-16.123,-0.001],[-0.001,8.674],[16.123,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.724,0],[0,6.547],[-10.723,0],[0,-6.546]],"o":[[-10.723,0],[0,-6.546],[10.724,0],[0,6.547]],"v":[[-0.001,11.674],[-19.123,-0.001],[-0.001,-11.674],[19.123,-0.001]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.374,11.925],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-5.619],[9.732,0],[0,5.619],[-9.733,0]],"o":[[0,5.619],[-9.733,0],[0,-5.619],[9.732,0]],"v":[[17.622,0],[0.001,10.174],[-17.622,0],[0.001,-10.174]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.976000019148,0.957000014361,0.847000002394,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,11.924],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.828,0],[0,0.829],[0,0],[0,0],[0,0],[0.829,0],[0,0.829],[0,0],[-0.828,0],[0,0],[0,-0.828],[0,0]],"o":[[-0.828,0],[0,0],[0,0],[0,0],[0,0.829],[-0.828,0],[0,0],[0,-0.828],[0,0],[0.828,0],[0,0],[0,0.829]],"v":[[17.623,28.152],[16.123,26.652],[16.123,-25.152],[-16.123,-25.152],[-16.123,26.652],[-17.623,28.152],[-19.123,26.652],[-19.123,-26.652],[-17.623,-28.152],[17.623,-28.152],[19.123,-26.652],[19.123,26.652]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,40.206],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[17.622,26.652],[17.622,-26.652],[-17.622,-26.652],[-17.622,26.652]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.948999980852,0.760999971278,0.152999997606,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,40.206],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.74,0],[0,-4.702],[-8.739,0],[0,4.702]],"o":[[-8.739,0],[0,4.702],[8.74,0],[0,-4.702]],"v":[[-0.001,-8.674],[-16.123,-0.001],[-0.001,8.674],[16.123,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[10.724,0],[0,6.547],[-10.723,0],[0,-6.546]],"o":[[-10.723,0],[0,-6.546],[10.724,0],[0,6.547]],"v":[[-0.001,11.674],[-19.123,-0.001],[-0.001,-11.674],[19.123,-0.001]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.156999999402,0.118000000598,0.20800000359,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.374,66.858],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":4,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-5.619],[9.732,0],[0,5.619],[-9.733,0]],"o":[[0,5.619],[-9.733,0],[0,-5.619],[9.732,0]],"v":[[17.622,0],[0.001,10.175],[-17.622,0],[0.001,-10.175]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.948999980852,0.760999971278,0.152999997606,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.373,66.857],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"tall_cylinder_shadow Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"s":true,"x":{"a":0,"k":341.685,"ix":3,"x":"var $bm_rt;\n$bm_rt = sum(transform.xPosition, div(thisComp.layer('tall_cylinder_controller').transform.yPosition, Math.pow(3, 1 / 2)));"},"y":{"a":0,"k":86.397,"ix":4,"x":"var $bm_rt;\n$bm_rt = sum(transform.yPosition, thisComp.layer('tall_cylinder_controller').transform.yPosition);"}},"a":{"a":0,"k":[19.372,11.924,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[10.723,0],[0,-6.546],[-10.723,0],[0,6.547]],"o":[[-10.723,0],[0,6.547],[10.723,0],[0,-6.546]],"v":[[0.001,-11.674],[-19.122,-0.001],[0.001,11.674],[19.122,-0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.803921580315,0.784313738346,0.831372559071,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[19.372,11.924],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":301.000012259981,"st":0,"bm":0}],"markers":[]}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLottie = __webpack_require__(90);
	
	var _reactLottie2 = _interopRequireDefault(_reactLottie);
	
	var _HomeAbout = __webpack_require__(479);
	
	var animationData = _interopRequireWildcard(_HomeAbout);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _homeAboutModule = __webpack_require__(401);
	
	var _homeAboutModule2 = _interopRequireDefault(_homeAboutModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeAboutAnimation = function (_React$Component) {
	  (0, _inherits3.default)(HomeAboutAnimation, _React$Component);
	
	  function HomeAboutAnimation(props) {
	    (0, _classCallCheck3.default)(this, HomeAboutAnimation);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.onClick = function (clickEvent) {
	      clickEvent.stopPropagation();
	    };
	
	    _this.state = { isStopped: false, isPaused: false, isClickToPauseDisabled: true };
	    return _this;
	  }
	
	  HomeAboutAnimation.prototype.render = function render() {
	    var defaultOptions = {
	      loop: true,
	      autoplay: true,
	      animationData: animationData,
	      rendererSettings: {
	        scaleMode: 'noScale',
	        isClickToPauseDisabled: true,
	        clearCanvas: false,
	        progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
	        hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
	        className: 'some-css-class-name'
	      }
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_homeAboutModule2.default.image, 'gridish-container--complete gridish-grid') },
	      _react2.default.createElement(_reactLottie2.default, { options: defaultOptions,
	        isClickToPauseDisabled: true
	      })
	    );
	  };
	
	  return HomeAboutAnimation;
	}(_react2.default.Component);
	
	exports.default = HomeAboutAnimation;
	module.exports = exports['default'];

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SpeakerCarousel = __webpack_require__(280);
	
	var _SpeakerCarousel2 = _interopRequireDefault(_SpeakerCarousel);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSpeakers = function (_Component) {
	  (0, _inherits3.default)(HomeSpeakers, _Component);
	
	  function HomeSpeakers(props) {
	    (0, _classCallCheck3.default)(this, HomeSpeakers);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  HomeSpeakers.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('content-Block--margin-top flex flex-column container gridish-container gridish-container--complete') },
	        _react2.default.createElement(
	          'h1',
	          { className: (0, _classnames2.default)('gridish-grid__height--medium--12 gridish-grid__height--small--10 gridish-grid__height--xsmall--8') },
	          'our lineup'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: (0, _classnames2.default)('gridish-grid__height--small--8 gridish-grid__height--xsmall--7'),
	            to: '/Speakers'
	          },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'View All Speakers'
	          )
	        )
	      ),
	      _react2.default.createElement(_SpeakerCarousel2.default, null)
	    );
	  };
	
	  return HomeSpeakers;
	}(_react.Component);
	
	exports.default = HomeSpeakers;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SplashAnimation = __webpack_require__(264);
	
	var _SplashAnimation2 = _interopRequireDefault(_SplashAnimation);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSplash = function (_Component) {
	  (0, _inherits3.default)(HomeSplash, _Component);
	
	  function HomeSplash(props) {
	    (0, _classCallCheck3.default)(this, HomeSplash);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  HomeSplash.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)() },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('container flex flex-column gridish-container--complete gridish-padding--bottom') },
	        _react2.default.createElement(
	          'h1',
	          { className: 'flex gridish-padding--bottom' },
	          'thought at work'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'flex gridish-grid__height--xsmall--10 text-transform--unset' },
	          _react2.default.createElement(
	            'strike',
	            null,
	            'October 19 - 21, 2018'
	          )
	        )
	      ),
	      _react2.default.createElement(_SplashAnimation2.default, null)
	    );
	  };
	
	  return HomeSplash;
	}(_react.Component);
	
	exports.default = HomeSplash;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(641);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _homeVideoModule = __webpack_require__(403);
	
	var _homeVideoModule2 = _interopRequireDefault(_homeVideoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeVideo = function (_Component) {
	  (0, _inherits3.default)(HomeVideo, _Component);
	
	  function HomeVideo() {
	    (0, _classCallCheck3.default)(this, HomeVideo);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  HomeVideo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: (0, _classnames2.default)('content-Block--margin-top container flex gridish-container gridish-container--complete gridish-grid__height--medium--13 gridish-grid__height--small--14 gridish-grid__height--xsmall--12') },
	        '2017 recap'
	      ),
	      _react2.default.createElement(_reactPlayer2.default, {
	        className: (0, _classnames2.default)(_homeVideoModule2.default.home_video, 'container gridish-container--complete gridish-container gridish-grid__col--xsmall--4'),
	        url: 'https://player.vimeo.com/video/263565186',
	        controls: true,
	        width: '100%',
	        height: '50vw',
	        vimeoConfig: { playerOptions: { title: true } }
	      })
	    );
	  };
	
	  return HomeVideo;
	}(_react.Component);
	
	exports.default = HomeVideo;
	module.exports = exports['default'];

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports = {"v":"5.2.1","fr":29.9700012207031,"ip":51.0000020772726,"op":305.000012422905,"w":1319,"h":637,"nm":"For spalsh 4 real","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":2,"ty":5,"nm":"JEN BYNNY","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":603.356,"s":[0],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":629.181,"s":[100],"e":[0]},{"t":671.060027332834}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":588,"s":[791.383,323,0],"e":[559.383,323,0],"to":[-38.6666679382324,-1.89478068516246e-14,0],"ti":[38.6666679382324,1.89478068516246e-14,0]},{"t":692.000028185738}],"ix":2},"a":{"a":0,"k":[-1,-18.898,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":54,"f":"FSElliot-Bold","t":"JEN BYNNY","j":2,"tr":0,"lh":64.8,"ls":0,"fc":[0,0,0]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[]},"ip":597.000024316308,"op":694.0000282672,"st":99.0000040323527,"bm":0},{"ddd":0,"ind":3,"ty":5,"nm":"ARNAUD TANIELIAN","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":448.209,"s":[0],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":473.785,"s":[100],"e":[0]},{"t":515.262520987072}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":433,"s":[791.383,402,0],"e":[559.383,402,0],"to":[-38.6666679382324,0,0],"ti":[38.6666679382324,0,0]},{"t":536.000021831728}],"ix":2},"a":{"a":0,"k":[-1,-18.898,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":60,"f":"FSElliot-Bold","t":"ARNAUD TANIELIAN","j":2,"tr":0,"lh":72,"ls":0,"fc":[1,0.19,0.19]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[]},"ip":446.000018165952,"op":543.000022116843,"st":-52.0000021180034,"bm":0},{"ddd":0,"ind":4,"ty":5,"nm":"MEGHAN PREISS","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":390,"s":[0],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":422,"s":[100],"e":[0]},{"t":464.753768929808}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":371,"s":[633,154,0],"e":[436,154,0],"to":[-32.8333320617676,0,0],"ti":[32.8333320617676,0,0]},{"t":486.000019795186}],"ix":2},"a":{"a":0,"k":[-1,-18.898,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":50,"f":"FSElliot-Bold","t":"MEGHAN PREISS","j":2,"tr":0,"lh":60,"ls":0,"fc":[0.29,0.19,1]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[]},"ip":390.000015885026,"op":487.000019835917,"st":-108.00000439893,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[985.738,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[],"ip":0,"op":1798.00007323404,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Shape Layer 1","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[945,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[363.117,137.133],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[0.293431330662,0.18959868188,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-45.441,282.539],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1798.00007323404,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":5,"nm":"JESSIE SMITH","tt":2,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":532,"s":[100],"e":[1]},{"t":559.000022768537}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":0.982},"o":{"x":0.333,"y":0},"n":"0_0p982_0p333_0","t":512,"s":[904.245,836.917,0],"e":[1298.245,836.917,0],"to":[65.6666641235352,-0.00000156250007,0],"ti":[-65.6666641235352,0.00000156250007,0]},{"t":530.000021587343}],"ix":2},"a":{"a":0,"k":[-1.755,-20.412,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"t":{"d":{"k":[{"s":{"s":54,"f":"FSElliot-Bold","t":"JESSIE SMITH","j":2,"tr":0,"lh":64.8,"ls":0,"fc":[0.29,0.19,1]},"t":0}]},"p":{},"m":{"g":1,"a":{"a":0,"k":[0,0],"ix":2}},"a":[]},"ip":494.000020121032,"op":591.000024071923,"st":-4.00000016292334,"bm":0},{"ddd":0,"ind":9,"ty":3,"nm":"Null 4","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":0.574},"o":{"x":0.333,"y":0},"n":"0p667_0p574_0p333_0","t":808,"s":[807.43,895.319,0],"e":[807.43,695.629,0],"to":[0,-31.5993595123291,0],"ti":[0,74.5147857666016,0]},{"t":830.000033806593,"s":[807.43,695.629,0],"h":1}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":806.000032829053,"op":830.000033806593,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Ball 13","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"n":"0p833_0p833_0p333_0","t":818,"s":[0,0,0],"e":[306.688,195.477,0],"to":[108.614585876465,-69.6666717529297,0],"ti":[-0.61458331346512,-197.33332824707,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p667_1_0p167_0p167","t":830,"s":[306.688,195.477,0],"e":[462.688,195.477,0],"to":[0.61458331346512,1.33333170413971,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"n":"0p667_0p667_0p167_0p167","t":836,"s":[462.688,195.477,0],"e":[462.688,195.477,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"n":"0p667_1_0p167_0","t":844,"s":[462.688,195.477,0],"e":[154.688,195.477,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.587,"y":0.587},"o":{"x":0.167,"y":0.167},"n":"0p587_0p587_0p167_0p167","t":853,"s":[154.688,195.477,0],"e":[154.688,195.477,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.297,"y":0},"n":"0p833_0p833_0p297_0","t":874,"s":[154.688,195.477,0],"e":[246.688,195.477,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.627,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p627_1_0p167_0p167","t":888,"s":[246.688,195.477,0],"e":[436.102,10.305,0],"to":[0,0,0],"ti":[-137.532089233398,-81.9341430664062,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"n":"0p667_1_0p167_0","t":898,"s":[436.102,10.305,0],"e":[459.102,10.305,0],"to":[0.68220150470734,-0.25628045201302,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":904,"s":[459.102,10.305,0],"e":[459.102,10.305,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.298,"y":1},"o":{"x":0.52,"y":0},"n":"0p298_1_0p52_0","t":955.346,"s":[459.102,10.305,0],"e":[273.654,-409.695,0],"to":[0,0,0],"ti":[-2.56883239746094,12.0658569335938,0]},{"i":{"x":0.272,"y":1},"o":{"x":0.392,"y":0},"n":"0p272_1_0p392_0","t":966.036,"s":[273.654,-409.695,0],"e":[1334.654,-431.871,0],"to":[2.56883239746094,-12.0658569335938,0],"ti":[0,0,0]},{"t":988.032540243389}],"ix":2},"a":{"a":0,"k":[-749.57,138.986,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":0,"k":[-749.51,139.1],"ix":2},"a":{"a":0,"k":[0.079,89.577],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":813,"s":[77,77],"e":[77,46]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":818,"s":[77,46],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":823,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":827,"s":[77,77],"e":[85,36]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":830,"s":[85,36],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":839,"s":[77,77],"e":[77,46]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":844,"s":[77,46],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":850,"s":[77,77],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":881,"s":[77,77],"e":[77,46]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":888,"s":[77,46],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":893,"s":[77,77],"e":[77,63]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":898,"s":[77,63],"e":[77,77]},{"i":{"x":[0.612,0.569],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p612_1_0p167_0","0p569_1_0p167_0"],"t":904,"s":[77,77],"e":[77,77]},{"i":{"x":[0.593,0.547],"y":[1,1]},"o":{"x":[0.776,0.499],"y":[0,0]},"n":["0p593_1_0p776_0","0p547_1_0p499_0"],"t":933,"s":[77,77],"e":[77,40]},{"i":{"x":[0.612,0.569],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p612_1_0p167_0","0p569_1_0p167_0"],"t":950,"s":[77,40],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":961.761,"s":[77,77],"e":[35,77]},{"i":{"x":[0.612,0.569],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p612_1_0p167_0","0p569_1_0p167_0"],"t":966.036,"s":[35,77],"e":[77,77]},{"t":974.590039695864}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":806.000032829053,"op":1130.00004602584,"st":20.0000008146167,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Ball 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":782,"s":[1195.43,895.319,0],"e":[807.43,895.319,0],"to":[-64.6666641235352,0,0],"ti":[64.6666641235352,3.41666674613953,0]},{"t":796.000032421745,"s":[807.43,895.319,0],"h":1}],"ix":2},"a":{"a":0,"k":[-749.57,138.986,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":782,"s":[-749.51,139.1],"e":[-749.51,139.1],"to":[0,0],"ti":[0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":808,"s":[-749.51,139.1],"e":[-749.51,-149.9],"to":[0,-48.1666679382324],"ti":[0,48.1666679382324]},{"t":843.000034336094}],"ix":2},"a":{"a":0,"k":[0.079,89.577],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p833_1_0p333_0","0p833_1_0p333_0"],"t":782,"s":[77,77],"e":[97,48]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":785,"s":[97,48],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":791,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":806,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.736,0.167],"y":[0,0]},"n":["0p833_1_0p736_0","0p833_1_0p167_0"],"t":811,"s":[77,77],"e":[84,51]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":818,"s":[84,51],"e":[84,51]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":827,"s":[84,51],"e":[77,77]},{"t":838.00003413244}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":782.000031851513,"op":806.000032829053,"st":20.0000008146167,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Ball 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"t":746,"s":[1195.43,895.319,0],"h":1},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":757.104,"s":[1195.43,895.319,0],"e":[1411.968,589.553,0],"to":[6.09505224227905,-182.460952758789,0],"ti":[-150.09504699707,26.4609508514404,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"n":"0p667_1_0p167_0","t":768,"s":[1411.968,589.553,0],"e":[1195.43,895.319,0],"to":[64.3441696166992,-11.3435316085815,0],"ti":[-18.1813259124756,-352.700012207031,0]},{"t":776.896281643633}],"ix":2},"a":{"a":0,"k":[-749.57,138.986,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":697,"s":[-749.51,139.1],"e":[-749.51,139.1],"to":[0,0],"ti":[0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":701.138,"s":[-749.51,139.1],"e":[-749.51,139.1],"to":[0,0],"ti":[0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":707,"s":[-749.51,139.1],"e":[-749.51,8.1],"to":[0,-21.8333339691162],"ti":[0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":712.4,"s":[-749.51,8.1],"e":[-749.51,139.1],"to":[0,0],"ti":[0,-21.8333339691162]},{"t":718.762529275797}],"ix":2},"a":{"a":0,"k":[0.079,89.577],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":697,"s":[77,77],"e":[77,49]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":701.138,"s":[77,49],"e":[77,49]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":707,"s":[77,49],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":713.394,"s":[77,77],"e":[77,68]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":722.331,"s":[77,68],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":725.9,"s":[77,77],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":739,"s":[77,77],"e":[77,49]},{"t":746,"s":[77,49],"h":1},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":757.104,"s":[77,49],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":763,"s":[77,77],"e":[36,86]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":768,"s":[36,86],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":772,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":776,"s":[77,77],"e":[77,68]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":780,"s":[77,68],"e":[77,77]},{"t":783.068781895044}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":683.00002781916,"op":784.000031932975,"st":29.0000011811942,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Ball 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1383.43,895.319,0],"ix":2},"a":{"a":0,"k":[-561.57,138.986,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":657.455,"s":[-500.088,69.713],"e":[-680.088,69.713],"to":[-30,0],"ti":[30,0]},{"t":672.000027371121}],"ix":2},"a":{"a":0,"k":[90.237,-0.535],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":656,"s":[77,77],"e":[36,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":657.455,"s":[36,77],"e":[97,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":667.636,"s":[97,77],"e":[77,77]},{"t":672.000027371121}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":651.000026515774,"op":683.00002781916,"st":15.0000006109625,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Ball 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":550,"s":[822.43,893.514,0],"e":[1037.43,794.316,0],"to":[1.5703125,-80.5143585205078,0],"ti":[-122.4296875,-67.8157348632812,0]},{"t":564,"s":[1037.43,794.316,0],"h":1},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p667_1_0p167_0p167","t":571,"s":[1037.43,794.316,0],"e":[1199.43,890.399,0],"to":[126.4296875,-70.1842651367188,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0},"n":"0p833_0p833_0p167_0","t":582,"s":[1199.43,890.399,0],"e":[1199.43,880.399,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p667_1_0p167_0p167","t":583.733,"s":[1199.43,880.399,0],"e":[1199.43,890.399,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"n":"0p667_0p667_0p167_0p167","t":587.2,"s":[1199.43,890.399,0],"e":[1199.43,890.399,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"n":"0p667_1_0p167_0","t":625,"s":[1199.43,890.399,0],"e":[1383.43,895.319,0],"to":[0,0,0],"ti":[-95.4296875,-375.319274902344,0]},{"t":645.000026271389}],"ix":2},"a":{"a":0,"k":[-561.57,138.986,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":0,"k":[-570.27,141.73],"ix":2},"a":{"a":0,"k":[-0.908,92.994],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":547,"s":[77,77],"e":[77,39]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":551,"s":[77,39],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":555,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p833_1_0p333_0","0p833_1_0p333_0"],"t":562,"s":[77,77],"e":[84,51]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":563.5,"s":[84,51],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":567,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":612,"s":[77,77],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":620,"s":[77,77],"e":[77,55]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":623,"s":[77,55],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":634,"s":[77,77],"e":[77,55]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":645,"s":[77,55],"e":[77,77]},{"t":651.000026515774}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":537.000021872458,"op":651.000026515774,"st":15.0000006109625,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Ball 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[909.43,890.942,0],"ix":2},"a":{"a":0,"k":[-466.57,136.413,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":514.819,"s":[-398.949,71.418],"e":[-493.949,71.418],"to":[-15.8333330154419,0],"ti":[15.8333330154419,0]},{"t":525.000021383688}],"ix":2},"a":{"a":0,"k":[87.82,1.679],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.895,0.333],"y":[0,0]},"n":["0p667_1_0p895_0","0p667_1_0p333_0"],"t":511,"s":[77,77],"e":[57,77]},{"i":{"x":[0.506,0.833],"y":[1,1]},"o":{"x":[0.565,0.333],"y":[0,0]},"n":["0p506_1_0p565_0","0p833_1_0p333_0"],"t":514.819,"s":[57,77],"e":[98,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.774,0.167],"y":[0,0]},"n":["0p833_1_0p774_0","0p833_1_0p167_0"],"t":521.181,"s":[98,77],"e":[77,77]},{"t":525.000021383688}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":493.000020080302,"op":537.000021872458,"st":0,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"3 Obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":651,"s":[1658.047,894.514,0],"e":[1490.485,894.514,0],"to":[-15.1693897247314,0,0],"ti":[91.4427719116211,0,0]},{"t":657,"s":[1490.485,894.514,0],"h":1},{"t":1054.0000429303,"s":[-240.953,892.514,0],"h":1}],"ix":2},"a":{"a":0,"k":[344.047,350.764,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[344.047,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[1,0.833]},"o":{"x":[0.828,0.459],"y":[0,0]},"n":["0p833_1_0p828_0","0p833_0p833_0p459_0"],"t":651,"s":[51,-1],"e":[51,136]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":657,"s":[51,136],"e":[51,136]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":758,"s":[51,136],"e":[51,136]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":760,"s":[51,136],"e":[51,267]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":766,"s":[51,267],"e":[51,136]},{"i":{"x":[0.008,0],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p008_1_0p167_0","0_1_0p167_0"],"t":780,"s":[51,136],"e":[51,136]},{"i":{"x":[0.479,0.131],"y":[1,1]},"o":{"x":[0.348,0.167],"y":[0,0]},"n":["0p479_1_0p348_0","0p131_1_0p167_0"],"t":890,"s":[51,136],"e":[51,175]},{"i":{"x":[0.479,0.131],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p479_1_0p167_0","0p131_1_0p167_0"],"t":897,"s":[51,175],"e":[51,175]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":959,"s":[51,175],"e":[51,343]},{"t":975.000039712564}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.293431330662,0.18959868188,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":651.000026515774,"op":1133.00004614804,"st":233.000009490285,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"2 Obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":621,"s":[1658.047,894.514,0],"e":[652.703,894.514,0],"to":[-47.0197372436523,0,0],"ti":[471.458374023438,0,0]},{"t":657,"s":[652.703,894.514,0],"h":1},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":1133,"s":[652.703,892.514,0],"e":[-240.953,892.514,0],"to":[-406.992950439453,0,0],"ti":[91.1520690917969,0,0]},{"t":1166.00004749215}],"ix":2},"a":{"a":0,"k":[344.047,350.764,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[344.047,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":621,"s":[51,-1],"e":[51,51]},{"t":629.000025619695}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.191636029412,0.191636029412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":621.000025293849,"op":1264.00005148378,"st":203.000008268359,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":1,"y":1},"o":{"x":0.333,"y":0},"n":"1_1_0p333_0","t":850,"s":[463.485,781.479,0],"e":[463.485,669.146,0],"to":[0,-0.21175415813923,0],"ti":[0,0.50613993406296,0]},{"i":{"x":0.667,"y":1},"o":{"x":1,"y":0},"n":"0p667_1_1_0","t":854.334,"s":[463.485,669.146,0],"e":[463.485,779.479,0],"to":[0,-0.2906014919281,0],"ti":[0,0.12157917022705,0]},{"t":863.000035150711}],"ix":2},"a":{"a":0,"k":[-357.985,-100,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-464,-216],[-464,16],[-251.97,16]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tr","p":{"a":0,"k":[-462.484,14.324],"ix":2},"a":{"a":0,"k":[-462.484,13.712],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0_1_0p333_0","0_1_0p333_0"],"t":850,"s":[100,0],"e":[100,100]},{"t":858.000034947056}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.192156877705,0.192156877705,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":826.00003364367,"op":1786.00007274527,"st":-12.00000048877,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"8 obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[654.03,763.598,0],"ix":2},"a":{"a":0,"k":[-454,177,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-40.869,0],[0,40.869]],"o":[[0,40.869],[40.869,0],[0,0]],"v":[[-528,140],[-454,214],[-380,140]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":826,"s":[-454.078,258.363],"e":[-454.078,106.363],"to":[0,-25.3333339691162],"ti":[0,14.1666669845581]},{"i":{"x":0.919,"y":1},"o":{"x":1,"y":0},"n":"0p919_1_1_0","t":837,"s":[-454.078,106.363],"e":[-454.078,173.363],"to":[0,-14.1666669845581],"ti":[0,-11.1666669845581]},{"t":844.000034376825}],"ix":2},"a":{"a":0,"k":[-454.078,175.363],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":832.75,"s":[45,45],"e":[100,100]},{"t":838.00003413244}],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":828,"s":[180],"e":[360]},{"t":838.00003413244}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":10,"ml2":{"a":0,"k":10,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.294117647059,0.188235309077,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":793.000032299552,"op":1798.00007323404,"st":0,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"7 Obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1270.032,699.434,0],"ix":2},"a":{"a":0,"k":[-572.406,155.684,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-572.406,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.128,0.116],"y":[1,1]},"o":{"x":[0.96,0.816],"y":[0,0]},"n":["0p128_1_0p96_0","0p116_1_0p816_0"],"t":848,"s":[100,0],"e":[69,101]},{"t":860.000035028518}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.192156877705,0.192156877705,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":690.000028104276,"op":1172.00004773654,"st":272.000011078787,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"6 Obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[316.97,631.152,0],"ix":2},"a":{"a":0,"k":[-73.469,87.402,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":824,"s":[-73.469,352.227],"e":[-73.469,352.727],"to":[0,0.08333333581686],"ti":[0,-0.08333333581686]},{"t":837.000034091709}],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.642,0],"y":[1.662,1]},"o":{"x":[0.53,0.916],"y":[0,0]},"n":["0p642_1p662_0p53_0","0_1_0p916_0"],"t":824,"s":[100,0],"e":[69,287]},{"t":837.000034091709}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.294117647059,0.188235309077,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":666.000027126736,"op":1148.000046759,"st":248.000010101247,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"4 Obstacle ","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[812.97,770.485,0],"ix":2},"a":{"a":0,"k":[-33.469,226.735,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-73.469,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":809,"s":[100,0],"e":[100,157]},{"t":844.000034376825}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.932740873449,0.161764675963,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":651.000026515774,"op":1133.00004614804,"st":233.000009490285,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"6 Obstacle 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[988.97,631.152,0],"ix":2},"a":{"a":0,"k":[-73.469,87.402,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":940,"s":[-73.469,352.227],"e":[-73.469,352.727],"to":[0,0.08333333581686],"ti":[0,-0.08333333581686]},{"t":953.000038816486}],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.642,0],"y":[1.662,1]},"o":{"x":[0.53,0.916],"y":[0,0]},"n":["0p642_1p662_0p53_0","0_1_0p916_0"],"t":940,"s":[100,0],"e":[69,378]},{"t":953.000038816486}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.294117647059,0.188235309077,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":733.000029855702,"op":1215.00004948796,"st":315.000012830213,"bm":0},{"ddd":0,"ind":25,"ty":4,"nm":"1 Obstacle","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":493,"s":[1485.047,892.514,0],"e":[1030.835,892.514,0],"to":[-87.6101760864258,0,0],"ti":[198.945739746094,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":513,"s":[1030.835,892.514,0],"e":[1031.124,892.514,0],"to":[-7.52627372741699,0,0],"ti":[7.61319494247437,0,0]},{"t":514,"s":[1031.124,892.514,0],"h":1},{"t":566,"s":[1031.124,892.514,0],"h":1},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":587,"s":[1031.124,892.514,0],"e":[-240.953,892.514,0],"to":[-451.922943115234,0,0],"ti":[196.742126464844,0,0]},{"t":625.000025456772}],"ix":2},"a":{"a":0,"k":[344.047,350.764,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[344.047,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":493,"s":[51,-1],"e":[51,51]},{"t":508.000020691264}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.191636029412,0.191636029412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":493.000020080302,"op":1801.00007335623,"st":75.0000030548126,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"Ball 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.745,"y":0.692},"o":{"x":0,"y":0},"n":"0p745_0p692_0_0","t":98,"s":[830.43,831.413,0],"e":[910.586,828.595,0],"to":[14.9796304702759,0,0],"ti":[-34.6508102416992,1.26323235034943,0]},{"i":{"x":0.59,"y":1},"o":{"x":0.31,"y":0.354},"n":"0p59_1_0p31_0p354","t":125.621,"s":[910.586,828.595,0],"e":[1057.43,831.413,0],"to":[52.8650817871094,-1.92725300788879,0],"ti":[-31.5119342803955,-5.99315786361694,0]},{"i":{"x":0.67,"y":1},"o":{"x":1,"y":0.144},"n":"0p67_1_1_0p144","t":173.79,"s":[1057.43,831.413,0],"e":[1143.43,890.942,0],"to":[52.1666679382324,9.92141819000244,0],"ti":[-2.39423298835754,-14.501914024353,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0},"n":"0p833_0p833_0p167_0","t":184,"s":[1143.43,890.942,0],"e":[1143.43,877.942,0],"to":[0.08333333581686,0.5047515630722,0],"ti":[0,0,0]},{"i":{"x":0.67,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p67_1_0p167_0p167","t":186,"s":[1143.43,877.942,0],"e":[1143.43,890.942,0],"to":[0,0,0],"ti":[-0.14423300325871,-14.251914024353,0]},{"i":{"x":0.67,"y":1},"o":{"x":0.167,"y":0},"n":"0p67_1_0p167_0","t":190,"s":[1143.43,890.942,0],"e":[1143.43,890.942,0],"to":[0.00517709925771,0.51155817508698,0],"ti":[0,0,0]},{"i":{"x":0.385,"y":1},"o":{"x":0.268,"y":0},"n":"0p385_1_0p268_0","t":201,"s":[1143.43,890.942,0],"e":[1033.43,890.942,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.385,"y":0.385},"o":{"x":0.826,"y":0.826},"n":"0p385_0p385_0p826_0p826","t":222,"s":[1033.43,890.942,0],"e":[1033.43,890.942,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.463,"y":0.926},"o":{"x":0.714,"y":0},"n":"0p463_0p926_0p714_0","t":236.736,"s":[1033.43,890.942,0],"e":[1202.43,890.942,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.766,"y":0.766},"o":{"x":0.167,"y":0.167},"n":"0p766_0p766_0p167_0p167","t":252,"s":[1202.43,890.942,0],"e":[1202.43,890.942,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.766,"y":1},"o":{"x":0.809,"y":0},"n":"0p766_1_0p809_0","t":272.351,"s":[1202.43,890.942,0],"e":[909.43,890.942,0],"to":[0,0,0],"ti":[0,0,0]},{"t":292.000011893404}],"ix":2},"a":{"a":0,"k":[-466.57,136.413,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Echo","np":7,"mn":"ADBE Echo","ix":1,"en":1,"ef":[{"ty":0,"nm":"Echo Time (seconds)","mn":"ADBE Echo-0001","ix":1,"v":{"a":0,"k":-0.001,"ix":1}},{"ty":0,"nm":"Number Of Echoes","mn":"ADBE Echo-0002","ix":2,"v":{"a":0,"k":24,"ix":2}},{"ty":0,"nm":"Starting Intensity","mn":"ADBE Echo-0003","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":0,"nm":"Decay","mn":"ADBE Echo-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":7,"nm":"Echo Operator","mn":"ADBE Echo-0005","ix":5,"v":{"a":0,"k":2,"ix":5}}]}],"shapes":[{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 2","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":324,"s":[-466.57,140.727],"e":[-466.57,-31.273],"to":[0,-28.6666660308838],"ti":[0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":332.174,"s":[-466.57,-31.273],"e":[-466.57,140.727],"to":[0,0],"ti":[0,-28.6666660308838]},{"t":339.178763815034}],"ix":2},"a":{"a":0,"k":[0,91.69],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":315.828,"s":[77,77],"e":[85,61]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":324,"s":[85,61],"e":[77,77]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":331.006,"s":[77,77],"e":[94,53]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":339.179,"s":[94,53],"e":[77,77]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":347.828,"s":[77,77],"e":[77,77]},{"t":363.000014785293}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":177.000007209358,"op":493.000020080302,"st":0,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"Mask","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1203.865,524.774,0],"ix":2},"a":{"a":0,"k":[224.77,-2.547,0],"ix":1},"s":{"a":0,"k":[111.165,152.31,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Wave Warp","np":10,"mn":"ADBE Wave Warp","ix":1,"en":1,"ef":[{"ty":7,"nm":"Wave Type","mn":"ADBE Wave Warp-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":0,"nm":"Wave Height","mn":"ADBE Wave Warp-0002","ix":2,"v":{"a":0,"k":-2,"ix":2}},{"ty":0,"nm":"Wave Width","mn":"ADBE Wave Warp-0003","ix":3,"v":{"a":0,"k":37.7,"ix":3}},{"ty":0,"nm":"Direction","mn":"ADBE Wave Warp-0004","ix":4,"v":{"a":0,"k":180,"ix":4}},{"ty":7,"nm":"Wave Speed","mn":"ADBE Wave Warp-0005","ix":5,"v":{"a":0,"k":1,"ix":5}},{"ty":7,"nm":"Pinning","mn":"ADBE Wave Warp-0006","ix":6,"v":{"a":0,"k":1,"ix":6}},{"ty":0,"nm":"Phase","mn":"ADBE Wave Warp-0007","ix":7,"v":{"a":0,"k":0,"ix":7}},{"ty":7,"nm":"Antialiasing (Best Quality)","mn":"ADBE Wave Warp-0008","ix":8,"v":{"a":0,"k":1,"ix":8}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[374.461,405.594],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[224.77,-2.547],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 2","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[374.461,405.594],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[224.77,-2.547],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":28,"ty":4,"nm":"Ball1","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.745,"y":0.692},"o":{"x":0,"y":0},"n":"0p745_0p692_0_0","t":98,"s":[825.93,834.913,0],"e":[906.086,832.095,0],"to":[14.9796304702759,0,0],"ti":[-34.6508102416992,1.26323235034943,0]},{"i":{"x":0.59,"y":1},"o":{"x":0.31,"y":0.354},"n":"0p59_1_0p31_0p354","t":125.621,"s":[906.086,832.095,0],"e":[1052.93,834.913,0],"to":[52.8650817871094,-1.92725300788879,0],"ti":[-31.5119342803955,-5.99315786361694,0]},{"i":{"x":0.67,"y":1},"o":{"x":1,"y":0.144},"n":"0p67_1_1_0p144","t":173.79,"s":[1052.93,834.913,0],"e":[1138.93,894.442,0],"to":[52.1666679382324,9.92141819000244,0],"ti":[-2.39423298835754,-14.501914024353,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0},"n":"0p833_0p833_0p167_0","t":184,"s":[1138.93,894.442,0],"e":[1138.93,881.442,0],"to":[0.08333333581686,0.5047515630722,0],"ti":[-0.75,0.58333331346512,0]},{"i":{"x":0.67,"y":1},"o":{"x":0.167,"y":0.167},"n":"0p67_1_0p167_0p167","t":186,"s":[1138.93,881.442,0],"e":[1143.43,890.942,0],"to":[0.75,-0.58333331346512,0],"ti":[-0.14423300325871,-14.251914024353,0]},{"i":{"x":0.67,"y":1},"o":{"x":0.167,"y":0},"n":"0p67_1_0p167_0","t":190,"s":[1143.43,890.942,0],"e":[1143.43,890.942,0],"to":[0.00517709925771,0.51155817508698,0],"ti":[0,0,0]},{"t":201.000008186898}],"ix":2},"a":{"a":0,"k":[-466.57,136.413,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":0,"k":[-466.57,70.125],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[77,77],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":201.000008186898,"st":0,"bm":0},{"ddd":0,"ind":29,"ty":4,"nm":"Floor line 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.634,"y":0},"n":"0p833_1_0p634_0","t":338,"s":[2624,895,0],"e":[980,895,0],"to":[-274,0,0],"ti":[274,-0.16666667163372,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"n":"0p833_1_0p167_0","t":466,"s":[980,895,0],"e":[980,896,0],"to":[-274,0.16666667163372,0],"ti":[0,-0.16666667163372,0]},{"t":788.000032095898}],"ix":2},"a":{"a":0,"k":[60,312,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-516,312],[636,312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.258055892645,0.13581496594,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":90,"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.664],"y":[0.505]},"o":{"x":[0.334],"y":[0]},"n":["0p664_0p505_0p334_0"],"t":338,"s":[76],"e":[-1763.873]},{"t":513,"s":[-1763.873],"h":1},{"i":{"x":[0.664],"y":[0.672]},"o":{"x":[0.331],"y":[0.293]},"n":["0p664_0p672_0p331_0p293"],"t":585,"s":[-1763.873],"e":[-2768.706]},{"t":657,"s":[-2768.706],"h":1},{"t":747,"s":[-3499.731],"h":1},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"n":["0p667_1_0p167_0p167"],"t":1094,"s":[-2797.833],"e":[-3644]},{"t":1145.00004663681}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":338.000013767022,"op":1238.00005042477,"st":338.000013767022,"bm":0},{"ddd":0,"ind":30,"ty":4,"nm":"Floor line 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[980,883.5,0],"ix":2},"a":{"a":0,"k":[60,312,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-670.25,321.5],[-510,321.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125490196078,0.443137254902,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":176.000007168627,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":31,"ty":4,"nm":"Floor line","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[980,893,0],"ix":2},"a":{"a":0,"k":[60,312,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-516,312],[636,312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.258055892645,0.13581496594,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p667_1_1_0"],"t":22,"s":[79],"e":[0]},{"t":34.0000013848484}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[1],"y":[0]},"n":["0p667_1_1_0"],"t":22,"s":[79],"e":[90]},{"t":34.0000013848484}],"ix":2},"o":{"a":0,"k":76,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":22.0000008960784,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":34,"ty":4,"nm":"Mask for ball","parent":27,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[224.77,-2.547,0],"ix":2},"a":{"a":0,"k":[224.77,-2.547,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[374.461,405.594],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"rc","d":1,"s":{"a":0,"k":[373.461,432.594],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 2","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-232.918,-2.547],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":-1.00000004073083,"bm":0},{"ddd":0,"ind":35,"ty":4,"nm":"Ball 2","parent":28,"tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-466.57,136.413,0],"ix":2},"a":{"a":0,"k":[-466.57,136.413,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[178.859,178.859],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":0,"k":[-466.57,70.125],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[77,77],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":201.000008186898,"st":0,"bm":0},{"ddd":0,"ind":36,"ty":4,"nm":"mask for gate","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.634,"y":0},"n":"0p667_1_0p634_0","t":338,"s":[920,522,0],"e":[-796,522,0],"to":[-286,0,0],"ti":[286,0,0]},{"t":428.000017432797}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,115,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[585.688,640.359],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[0.258055892645,0.13581496594,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[40.844,0.18],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":37,"ty":0,"nm":"Gate","tt":1,"refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.177,"y":1},"o":{"x":0,"y":0},"n":"0p177_1_0_0","t":27,"s":[960,1520,0],"e":[960,579,0],"to":[0,-156.83332824707,0],"ti":[0,156.83332824707,0]},{"i":{"x":0.177,"y":0.177},"o":{"x":0.167,"y":0.167},"n":"0p177_0p177_0p167_0p167","t":76,"s":[960,579,0],"e":[960,579,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.597,"y":1},"o":{"x":0.173,"y":0},"n":"0p597_1_0p173_0","t":91,"s":[960,579,0],"e":[964,587,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.697,"y":1},"o":{"x":0.352,"y":0},"n":"0p697_1_0p352_0","t":263,"s":[964,587,0],"e":[960,579,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.634,"y":0},"n":"0p667_1_0p634_0","t":338,"s":[960,579,0],"e":[-756,579,0],"to":[-286,0,0],"ti":[286,0,0]},{"t":428.000017432797}],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[95.833,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"n":["0p667_1_0p167_0p167"],"t":0,"s":[0],"e":[0.801]},{"i":{"x":[0.139],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p139_1_0p333_0"],"t":27,"s":[0.801],"e":[2.006]},{"t":76.0000030955435}],"ix":2},"w":1920,"h":1080,"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":38,"ty":3,"nm":"Null 5","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,537,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":1204.00004903993,"st":0,"bm":0},{"ddd":0,"ind":39,"ty":4,"nm":"Shape Layer 5","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.333,"y":0},"n":"0_1_0p333_0","t":189,"s":[-536.515,241.479,0],"e":[-536.515,129.146,0],"to":[0,-0.21175415813923,0],"ti":[0,0.50613993406296,0]},{"i":{"x":0.667,"y":1},"o":{"x":1,"y":0},"n":"0p667_1_1_0","t":195.001,"s":[-536.515,129.146,0],"e":[-536.515,239.479,0],"to":[0,-0.2906014919281,0],"ti":[0,0.12157917022705,0]},{"t":207.000008431283}],"ix":2},"a":{"a":0,"k":[-357.985,-100,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[972.53,-240.479]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988235353956,0.211764720842,0.329411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-359.25,-101.375],[-464,16],[-251.97,16]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tr","p":{"a":0,"k":[-462.484,14.324],"ix":2},"a":{"a":0,"k":[-462.484,13.712],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0_1_0p333_0","0_1_0p333_0"],"t":189,"s":[79,0],"e":[100,100]},{"t":200.076258149273}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":1,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.1254902035,0.443137288094,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 2","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-464,-216],[-464,16],[-251.97,16]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tr","p":{"a":0,"k":[-462.484,14.324],"ix":2},"a":{"a":0,"k":[-462.484,13.712],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0_1_0p333_0","0_1_0p333_0"],"t":189,"s":[79,0],"e":[100,100]},{"t":200.076258149273}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":1,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.996078491211,0.819607902976,0.262745098039,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":165.000006720588,"op":1125.00004582219,"st":-673.000027411852,"bm":0},{"ddd":0,"ind":40,"ty":4,"nm":"6 Obstacle 3","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-643.03,91.152,0],"ix":2},"a":{"a":0,"k":[-73.469,87.402,0],"ix":1},"s":{"a":0,"k":[-100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":190,"s":[-73.469,352.227],"e":[-73.469,352.727],"to":[0,0.08333333581686],"ti":[0,-0.08333333581686]},{"t":203.000008268359}],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.642,0],"y":[1.662,1]},"o":{"x":[0.53,0.916],"y":[0,0]},"n":["0p642_1p662_0p53_0","0_1_0p916_0"],"t":190,"s":[100,0],"e":[69,287]},{"t":203.000008268359}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":24,"s":[0],"e":[100]},{"t":34.0000013848484}],"ix":1},"e":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125490196078,0.443137254902,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":2.00000008146167,"op":514.000020935649,"st":-386.000015722102,"bm":0},{"ddd":0,"ind":41,"ty":4,"nm":"2 Obstacle 3","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-264.297,354.514,0],"ix":2},"a":{"a":0,"k":[344.047,350.764,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[344.047,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0_1_0p333_0","0_1_0p333_0"],"t":201,"s":[51,0],"e":[51,51]},{"t":208.000008472014}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988235353956,0.211764720842,0.329411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":184.000007494474,"op":650.000026475043,"st":-411.000016740373,"bm":0},{"ddd":0,"ind":42,"ty":4,"nm":"8 obstacle 2","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-266.97,223.598,0],"ix":2},"a":{"a":0,"k":[-454,177,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-40.869,0],[0,40.869]],"o":[[0,40.869],[40.869,0],[0,0]],"v":[[-528,140],[-454,214],[-380,140]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":208,"s":[-454.078,258.363],"e":[-454.078,106.363],"to":[0,-25.3333339691162],"ti":[0,14.1666669845581]},{"i":{"x":0.919,"y":1},"o":{"x":1,"y":0},"n":"0p919_1_1_0","t":219,"s":[-454.078,106.363],"e":[-454.078,173.363],"to":[0,-14.1666669845581],"ti":[0,-11.1666669845581]},{"t":226.000009205169}],"ix":2},"a":{"a":0,"k":[-454.078,175.363],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":214.75,"s":[45,45],"e":[100,100]},{"t":220.000008960784}],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":210,"s":[180],"e":[360]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":220,"s":[360],"e":[370]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":228,"s":[370],"e":[348]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":232,"s":[348],"e":[374]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"n":["0p833_1_0p167_0"],"t":242,"s":[374],"e":[360]},{"t":251.00001022344}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125490196078,0.443137254902,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":202.000008227629,"op":1180.00004806239,"st":-618.000025171656,"bm":0},{"ddd":0,"ind":43,"ty":4,"nm":"4 Obstacle 2","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-147.03,230.485,0],"ix":2},"a":{"a":0,"k":[-33.469,226.735,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-73.469,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0,0.101],"y":[0,0]},"n":["0_1_0_0","0_1_0p101_0"],"t":218,"s":[100,0],"e":[100,157]},{"t":237.000009653208}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.996078491211,0.819607902976,0.262745098039,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-73.469,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0,0.101],"y":[0,0]},"n":["0_1_0_0","0_1_0p101_0"],"t":212,"s":[100,0],"e":[100,157]},{"t":231.000009408823}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 3","np":1,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 3","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988235354424,0.211764723063,0.329411774874,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 3","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-73.469,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0,0.101],"y":[0,0]},"n":["0_1_0_0","0_1_0p101_0"],"t":205,"s":[100,0],"e":[100,157]},{"t":224.000009123707}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 2","np":1,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.1254902035,0.443137288094,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 2","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":70.0000028511585,"op":515.00002097638,"st":-385.000015681371,"bm":0},{"ddd":0,"ind":44,"ty":4,"nm":"7 Obstacle 2","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[310.032,159.434,0],"ix":2},"a":{"a":0,"k":[-572.406,155.684,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[-572.406,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.128,0.116],"y":[1,1]},"o":{"x":[0.96,0.816],"y":[0,0]},"n":["0p128_1_0p96_0","0p116_1_0p816_0"],"t":184,"s":[100,0],"e":[69,101]},{"t":196.000007983244}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988235353956,0.211764720842,0.329411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":72.0000029326201,"op":554.000022564883,"st":-346.000014092869,"bm":0},{"ddd":0,"ind":45,"ty":4,"nm":"3 Obstacle 2","parent":38,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":191.464,"s":[530.485,354.514,0],"e":[530.485,204.285,0],"to":[-0.68113368749619,-2,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":196.928,"s":[530.485,204.285,0],"e":[530.485,354.514,0],"to":[0,0,0],"ti":[0,0,0]},{"t":203.000008268359}],"ix":2},"a":{"a":0,"k":[344.047,350.764,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[184.094,184.094],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"tr","p":{"a":0,"k":[344.047,352.227],"ix":2},"a":{"a":0,"k":[0,92.273],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0.682],"y":[-0.563,0.995]},"o":{"x":[0.322,0.35],"y":[0,0]},"n":["0_-0p563_0p322_0","0p682_0p995_0p35_0"],"t":191.464,"s":[51,0],"e":[51,99.89]},{"i":{"x":[0,0.682],"y":[1,-0.445]},"o":{"x":[0.175,0.148],"y":[0,0.673]},"n":["0_1_0p175_0","0p682_-0p445_0p148_0p673"],"t":193.464,"s":[51,99.89],"e":[51,99.89]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.175,0.148],"y":[0,-0.006]},"n":["0p833_1_0p175_0","0p833_1_0p148_-0p006"],"t":199.464,"s":[51,99.89],"e":[51,23.89]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[1,1],"y":[0,0]},"n":["0p833_1_1_0","0p833_1_1_0"],"t":203.606,"s":[51,23.89],"e":[51,66.89]},{"t":208.463758490903}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.125490196078,0.443137254902,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":111.000004521123,"op":515.00002097638,"st":-385.000015681371,"bm":0},{"ddd":0,"ind":46,"ty":4,"nm":"Shape Layer 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.098,"y":1},"o":{"x":0.333,"y":0},"n":"0p098_1_0p333_0","t":208,"s":[574.621,742.344,0],"e":[510.621,742.344,0],"to":[-10.6666669845581,0,0],"ti":[0,0,0]},{"i":{"x":0.449,"y":1},"o":{"x":0.411,"y":0},"n":"0p449_1_0p411_0","t":217,"s":[510.621,742.344,0],"e":[574.621,742.344,0],"to":[0,0,0],"ti":[-10.6666669845581,0,0]},{"t":238.000009693939}],"ix":2},"a":{"a":0,"k":[-400.379,196.344,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[137.242,137.242],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":true},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":183.511,"s":[-400.379,345.992],"e":[-400.379,158.992],"to":[0,-31.1666660308838],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":1,"y":0},"n":"0_1_1_0","t":200.745,"s":[-400.379,158.992],"e":[-400.379,345.992],"to":[0,0],"ti":[0,-31.1666660308838]},{"t":210.511258574299}],"ix":2},"a":{"a":0,"k":[0,187.061],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":195,"s":[0,0],"e":[80,80]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":205.341,"s":[80,80],"e":[99,53]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":210.511,"s":[99,53],"e":[80,80]},{"t":217.511258859415}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 2","np":1,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":true},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 2","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.1254902035,0.443137288094,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[375.242,375.242],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":183.511,"s":[-400.379,345.992],"e":[-400.379,158.992],"to":[0,-31.1666660308838],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":1,"y":0},"n":"0_1_1_0","t":200.745,"s":[-400.379,158.992],"e":[-400.379,345.992],"to":[0,0],"ti":[0,-31.1666660308838]},{"t":210.511258574299}],"ix":2},"a":{"a":0,"k":[0,187.061],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0"],"t":195,"s":[0,0],"e":[80,80]},{"i":{"x":[0.833,0.833],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p833_1_0p167_0","0p833_1_0p167_0"],"t":205.341,"s":[80,80],"e":[99,53]},{"i":{"x":[0.667,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0,0]},"n":["0p667_1_0p167_0","0p667_1_0p167_0"],"t":210.511,"s":[99,53],"e":[80,80]},{"t":217.511258859415}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":1,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.988235353956,0.211764720842,0.329411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 2","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":1204.00004903993,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Null 2","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[926,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Gate Front","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,313,0],"ix":2},"a":{"a":0,"k":[0,313,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[626,626],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"rc","d":1,"s":{"a":0,"k":[464,518],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":20,"ix":4},"nm":"Rectangle Path 2","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"mm","mm":3,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.704},"o":{"x":1,"y":0},"n":"0p833_0p704_1_0","t":30,"s":[0,0],"e":[100,0],"to":[16.6666660308838,0],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.098},"n":"0_1_0p167_0p098","t":70.134,"s":[100,0],"e":[0,0],"to":[0,0],"ti":[16.6666660308838,0]},{"t":116.000004724777}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,1]},"o":{"x":[1,0.255],"y":[0,0]},"n":["0p833_0p833_1_0","0p833_1_0p255_0"],"t":30,"s":[70,100],"e":[0,100]},{"i":{"x":[0,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0.167,0]},"n":["0_1_0p167_0p167","0p667_1_0p167_0"],"t":70.134,"s":[0,100],"e":[61,100]},{"t":116.000004724777}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.607843137255,0.803921568627,0.992156862745,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":69,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":1,"y":0},"n":"0p667_1_1_0","t":30,"s":[923.402,531.098,0],"e":[1023.402,531.098,0],"to":[16.6666603088379,0,0],"ti":[-16.6666603088379,0,0]},{"t":69.0000028104276}],"ix":2},"a":{"a":0,"k":[-36.598,-8.902,0],"ix":1},"s":{"a":0,"k":[100,102,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Wave Warp","np":10,"mn":"ADBE Wave Warp","ix":1,"en":1,"ef":[{"ty":7,"nm":"Wave Type","mn":"ADBE Wave Warp-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":0,"nm":"Wave Height","mn":"ADBE Wave Warp-0002","ix":2,"v":{"a":0,"k":10,"ix":2}},{"ty":0,"nm":"Wave Width","mn":"ADBE Wave Warp-0003","ix":3,"v":{"a":0,"k":157.3,"ix":3}},{"ty":0,"nm":"Direction","mn":"ADBE Wave Warp-0004","ix":4,"v":{"a":0,"k":6,"ix":4}},{"ty":7,"nm":"Wave Speed","mn":"ADBE Wave Warp-0005","ix":5,"v":{"a":0,"k":1,"ix":5}},{"ty":7,"nm":"Pinning","mn":"ADBE Wave Warp-0006","ix":6,"v":{"a":0,"k":1,"ix":6}},{"ty":0,"nm":"Phase","mn":"ADBE Wave Warp-0007","ix":7,"v":{"a":0,"k":0,"ix":7}},{"ty":7,"nm":"Antialiasing (Best Quality)","mn":"ADBE Wave Warp-0008","ix":8,"v":{"a":0,"k":1,"ix":8}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[78.43,560.805],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-36.598,-8.902],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[60.655,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Gate Back","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[50,313,0],"ix":2},"a":{"a":0,"k":[0,313,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[626,626],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"rc","d":1,"s":{"a":0,"k":[464,518],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":20,"ix":4},"nm":"Rectangle Path 2","mn":"ADBE Vector Shape - Rect","hd":true},{"ty":"mm","mm":3,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.704},"o":{"x":1,"y":0},"n":"0p833_0p704_1_0","t":30,"s":[0,0],"e":[-100,0],"to":[-16.6666660308838,0],"ti":[0,0]},{"i":{"x":0,"y":1},"o":{"x":0.167,"y":0.098},"n":"0_1_0p167_0p098","t":70.134,"s":[-100,0],"e":[0,0],"to":[0,0],"ti":[-16.6666660308838,0]},{"t":116.000004724777}],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,1]},"o":{"x":[1,0.255],"y":[0,0]},"n":["0p833_0p833_1_0","0p833_1_0p255_0"],"t":30,"s":[70,100],"e":[0,100]},{"i":{"x":[0,0.667],"y":[1,1]},"o":{"x":[0.167,0.167],"y":[0.167,0]},"n":["0_1_0p167_0p167","0p667_1_0p167_0"],"t":70.134,"s":[0,100],"e":[61,100]},{"t":116.000004724777}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.152941176471,0.458823559331,0.984313785329,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Back of Gate","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":0,"s":[960,540,0],"e":[961.958,540,0],"to":[2.26508545875549,0,0],"ti":[-4.74111557006836,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":46,"s":[961.958,540,0],"e":[977,540,0],"to":[1.18941605091095,0,0],"ti":[-0.80223232507706,0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"n":"0p833_0p833_0p167_0p167","t":56,"s":[977,540,0],"e":[984,540,0],"to":[4,0,0],"ti":[-1.16666662693024,0,0]},{"t":61.0000024845809}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":0,"s":[104,100,100],"e":[112.429,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":32,"s":[112.429,100,100],"e":[89,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":56,"s":[89,100,100],"e":[60,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":59,"s":[60,100,100],"e":[58,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":60,"s":[58,100,100],"e":[51.5,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":61,"s":[51.5,100,100],"e":[46,100,100]},{"i":{"x":[0.833,0.833,0.833],"y":[0.833,0.833,0.833]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":62,"s":[46,100,100],"e":[30,100,100]},{"t":63.0000025660426}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[338,533.688],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[0.152941176471,0.458823559331,0.984313785329,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[17.422,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Right Wall","parent":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[190.285,0,0],"ix":2},"a":{"a":0,"k":[-297.715,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[200,634],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"ml2":{"a":0,"k":4,"ix":8},"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":true},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.823,"y":0.839},"o":{"x":0.502,"y":0},"n":"0p823_0p839_0p502_0","t":30,"s":[-217.875,0],"e":[-253.762,0],"to":[7.3230619430542,0],"ti":[-3.64869332313538,0]},{"i":{"x":0.719,"y":0.689},"o":{"x":0.394,"y":0.043},"n":"0p719_0p689_0p394_0p043","t":58.666,"s":[-253.762,0],"e":[-281.848,0],"to":[0.30019381642342,0],"ti":[-10.7477760314941,0]},{"i":{"x":0.523,"y":1},"o":{"x":0.386,"y":0.224},"n":"0p523_1_0p386_0p224","t":61.534,"s":[-281.848,0],"e":[-100,0],"to":[38.9621734619141,0],"ti":[-7.4743218421936,0]},{"t":70.1337528566062}],"ix":2},"a":{"a":0,"k":[-102.875,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.742,0.576],"y":[0.396,1.156]},"o":{"x":[0.557,0],"y":[0,-0.011]},"n":["0p742_0p396_0p557_0","0p576_1p156_0_-0p011"],"t":30,"s":[0,100],"e":[-45.76,100]},{"i":{"x":[0.65,0.671],"y":[9.211,1]},"o":{"x":[0.319,0.337],"y":[-4.768,0]},"n":["0p65_9p211_0p319_-4p768","0p671_1_0p337_0"],"t":57,"s":[-45.76,100],"e":[-44.433,100]},{"i":{"x":[0.602,0.698],"y":[1,0.447]},"o":{"x":[0.282,0.357],"y":[0.299,0.141]},"n":["0p602_1_0p282_0p299","0p698_0p447_0p357_0p141"],"t":61.534,"s":[-44.433,100],"e":[-100,100]},{"t":70.1337528566062}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":900.000036657751,"st":0,"bm":0}]}],"fonts":{"list":[{"fName":"FSElliot-Bold","fFamily":"FS Elliot","fStyle":"Bold","ascent":70.3994750976562}]},"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"For Splash","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[711.5,276,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":46,"s":[0],"e":[4.438]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":150,"s":[4.438],"e":[6.139]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":184,"s":[6.139],"e":[40.174]},{"t":1204.00004903993}],"ix":2},"w":1920,"h":1080,"ip":0,"op":311.00001266729,"st":0,"bm":0}],"markers":[],"chars":[{"ch":"J","size":54,"style":"Bold","w":43.6,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[6.244,0],[3.323,0.806],[0,0],[-4.532,0],[0,12.085]],"o":[[0,0],[0,0],[0,6.445],[-2.921,0],[0,0],[5.035,1.309],[12.488,0],[0,0]],"v":[[37.061,-67.676],[23.666,-67.676],[23.666,-20.444],[12.891,-9.668],[3.424,-10.977],[1.712,-0.705],[15.912,1.208],[37.061,-19.135]],"c":true},"ix":2},"nm":"J","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"J","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"E","size":54,"style":"Bold","w":60.2,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[56.296,0],[56.296,-10.071],[21.854,-10.071],[21.854,-29.709],[51.462,-29.709],[51.462,-39.578],[21.854,-39.578],[21.854,-57.605],[54.684,-57.605],[54.684,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"E","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"S","size":54,"style":"Bold","w":58.8,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-11.481],[0,-14.905],[8.258,0],[7.855,3.021],[0,0],[-7.755,0],[0,11.783],[0,14.502],[-7.855,0],[-6.848,-2.719],[0,0],[7.352,0]],"o":[[0,25.378],[0,5.64],[-6.143,0],[0,0],[9.164,3.827],[15.106,0],[0,-25.983],[0,-5.338],[5.74,0],[0,0],[-8.157,-3.122],[-14.804,0]],"v":[[4.532,-49.548],[41.995,-18.53],[28.601,-9.366],[7.15,-14.301],[4.129,-4.33],[29.608,1.208],[55.087,-18.53],[17.725,-49.548],[30.615,-58.31],[49.649,-54.181],[52.67,-64.151],[29.608,-68.884]],"c":true},"ix":2},"nm":"S","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"S","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"I","size":54,"style":"Bold","w":30.2,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[21.854,0],[21.854,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"I","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":" ","size":54,"style":"Bold","w":24,"data":{},"fFamily":"FS Elliot"},{"ch":"M","size":54,"style":"Bold","w":86.5,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[20.847,0],[20.847,-49.347],[39.88,-23.264],[47.333,-23.264],[66.266,-49.347],[66.266,0],[78.653,0],[78.653,-67.676],[65.662,-67.676],[43.607,-37.262],[21.451,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"M","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"M","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"T","size":54,"style":"Bold","w":63.4,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[23.666,0],[37.061,0],[37.061,-57.404],[58.411,-57.404],[58.411,-67.676],[2.216,-67.676],[2.216,-57.404],[23.666,-57.404]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"T","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"H","size":54,"style":"Bold","w":77.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[21.854,0],[21.854,-29.507],[56.396,-29.507],[56.396,0],[69.791,0],[69.791,-67.676],[56.396,-67.676],[56.396,-39.78],[21.854,-39.78],[21.854,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"H","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"H","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"G","size":50,"style":"Bold","w":71.3,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[4.33,0],[0,14.703],[-14.2,0],[-6.647,-3.525],[0,0],[8.258,0],[0,-20.544],[-21.451,0],[-8.459,3.625]],"o":[[0,0],[0,0],[0,0],[0,0],[-3.726,1.611],[-14.301,0],[0,-14.502],[6.042,0],[0,0],[-8.359,-4.532],[-20.947,0],[0,20.544],[8.762,0],[0,0]],"v":[[65.863,-37.363],[38.269,-37.363],[38.269,-27.493],[53.476,-27.493],[53.476,-11.581],[41.29,-9.064],[17.02,-33.838],[40.988,-58.612],[59.619,-52.972],[64.554,-61.935],[39.478,-68.884],[3.928,-33.838],[40.283,1.208],[65.863,-4.532]],"c":true},"ix":2},"nm":"G","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"G","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"A","size":50,"style":"Bold","w":71.3,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0.403,0],[13.898,0],[20.142,-16.113],[48.441,-16.113],[54.684,0],[68.179,0],[40.485,-67.676],[28.098,-67.676]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[34.341,-52.972],[44.916,-25.882],[23.767,-25.882]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"A","np":5,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"N","size":50,"style":"Bold","w":77.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[20.847,0],[20.847,-49.347],[56.799,0],[69.791,0],[69.791,-67.676],[57.404,-67.676],[57.404,-18.329],[21.451,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"N","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"P","size":50,"style":"Bold","w":62.8,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,13.092],[14.099,0],[0,0]],"o":[[0,0],[0,0],[0,0],[14.099,0],[0,-12.991],[0,0],[0,0]],"v":[[8.459,0],[21.35,0],[21.35,-23.062],[36.154,-23.062],[60.223,-45.419],[36.154,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"P","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-6.949],[7.654,0],[0,0]],"o":[[0,0],[7.654,0],[0,7.05],[0,0],[0,0]],"v":[[21.35,-57.404],[34.14,-57.404],[47.031,-45.419],[34.14,-33.435],[21.35,-33.435]],"c":true},"ix":2},"nm":"P","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"P","np":5,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"R","size":50,"style":"Bold","w":66,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,10.071],[13.596,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[9.467,-2.014],[0,-12.488],[0,0],[0,0]],"v":[[8.459,0],[21.35,0],[21.35,-24.673],[31.824,-24.673],[48.239,0],[62.842,0],[44.312,-26.688],[59.921,-46.426],[36.658,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-6.546],[7.05,0],[0,0]],"o":[[0,0],[7.05,0],[0,6.747],[0,0],[0,0]],"v":[[21.35,-57.404],[34.644,-57.404],[46.729,-46.225],[34.644,-35.046],[21.35,-35.046]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"R","np":5,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"U","size":60,"style":"Bold","w":77.7,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[10.474,0],[0,10.373],[0,0],[0,0],[0,0],[-18.228,0],[0,16.415]],"o":[[0,0],[0,0],[0,10.373],[-10.574,0],[0,0],[0,0],[0,0],[0,16.415],[18.228,0],[0,0]],"v":[[70.596,-67.676],[57.202,-67.676],[57.202,-26.99],[39.175,-9.366],[21.048,-26.99],[21.048,-67.676],[7.654,-67.676],[7.654,-26.486],[39.175,1.208],[70.596,-26.486]],"c":true},"ix":2},"nm":"U","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"U","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"D","size":60,"style":"Bold","w":72.9,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,19.94],[20.746,0],[0,0]],"o":[[0,0],[20.746,0],[0,-20.142],[0,0],[0,0]],"v":[[8.459,0],[34.744,0],[69.589,-33.838],[34.744,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,-13.797],[13.394,0],[0,0],[0,0],[0,0]],"o":[[0,13.797],[0,0],[0,0],[0,0],[13.394,0]],"v":[[55.893,-33.838],[33.133,-10.272],[21.854,-10.272],[21.854,-57.404],[33.133,-57.404]],"c":true},"ix":2},"nm":"D","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"D","np":5,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"L","size":60,"style":"Bold","w":53.8,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.459,0],[51.965,0],[51.965,-10.272],[21.854,-10.272],[21.854,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"L","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"L","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"B","size":54,"style":"Bold","w":66,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,11.078],[7.251,2.518],[0,6.747],[12.589,0],[0,0]],"o":[[0,0],[12.891,0],[0,-7.755],[5.539,-2.518],[0,-10.574],[0,0],[0,0]],"v":[[8.459,0],[39.578,0],[61.835,-18.732],[50.052,-35.248],[59.418,-49.75],[37.967,-67.676],[8.459,-67.676]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-6.042],[6.647,0],[0,0]],"o":[[0,0],[6.647,0],[0,6.042],[0,0],[0,0]],"v":[[21.35,-30.212],[37.463,-30.212],[48.642,-20.041],[37.463,-9.769],[21.35,-9.769]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,-5.539],[6.042,0],[0,0]],"o":[[0,0],[6.042,0],[0,5.539],[0,0],[0,0]],"v":[[21.35,-57.907],[36.154,-57.907],[46.527,-48.441],[36.154,-39.075],[21.35,-39.075]],"c":true},"ix":2},"nm":"B","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"B","np":6,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"},{"ch":"Y","size":54,"style":"Bold","w":64.9,"data":{"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[24.371,0],[37.766,0],[37.766,-27.493],[62.439,-67.676],[47.937,-67.676],[31.018,-39.377],[14.2,-67.676],[-0.403,-67.676],[24.371,-27.493]],"c":true},"ix":2},"nm":"Y","mn":"ADBE Vector Shape - Group","hd":false}],"nm":"Y","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}]},"fFamily":"FS Elliot"}]}

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLottie = __webpack_require__(90);
	
	var _reactLottie2 = _interopRequireDefault(_reactLottie);
	
	var _Splash = __webpack_require__(480);
	
	var animationData = _interopRequireWildcard(_Splash);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _homeSplashModule = __webpack_require__(402);
	
	var _homeSplashModule2 = _interopRequireDefault(_homeSplashModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplashAnimation = function (_React$Component) {
	  (0, _inherits3.default)(SplashAnimation, _React$Component);
	
	  function SplashAnimation(props) {
	    (0, _classCallCheck3.default)(this, SplashAnimation);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.onClick = function (clickEvent) {
	      clickEvent.stopPropagation();
	    };
	
	    _this.state = { isStopped: false, isPaused: false, isClickToPauseDisabled: true };
	    return _this;
	  }
	
	  SplashAnimation.prototype.render = function render() {
	    var defaultOptions = {
	      loop: false,
	      autoplay: true,
	      animationData: animationData,
	      rendererSettings: {
	        scaleMode: 'noScale',
	        isClickToPauseDisabled: true,
	        clearCanvas: false,
	        progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
	        hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
	        className: 'some-css-class-name'
	      }
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_homeSplashModule2.default.splashSizing, _homeSplashModule2.default.splashSpacing, 'gridish-container--complete gridish-grid') },
	      _react2.default.createElement(_reactLottie2.default, { options: defaultOptions,
	        isClickToPauseDisabled: true
	      })
	    );
	  };
	
	  return SplashAnimation;
	}(_react2.default.Component);
	
	exports.default = SplashAnimation;
	module.exports = exports['default'];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HomeSpeakers = __webpack_require__(261);
	
	var _HomeSpeakers2 = _interopRequireDefault(_HomeSpeakers);
	
	var _HomeVideo = __webpack_require__(263);
	
	var _HomeVideo2 = _interopRequireDefault(_HomeVideo);
	
	var _HomeAbout = __webpack_require__(259);
	
	var _HomeAbout2 = _interopRequireDefault(_HomeAbout);
	
	var _HomeSplash = __webpack_require__(262);
	
	var _HomeSplash2 = _interopRequireDefault(_HomeSplash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var index = function (_Component) {
	  (0, _inherits3.default)(index, _Component);
	
	  function index() {
	    (0, _classCallCheck3.default)(this, index);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  index.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HomeSplash2.default, null),
	      _react2.default.createElement(_HomeAbout2.default, null),
	      _react2.default.createElement(_HomeSpeakers2.default, null),
	      _react2.default.createElement(_HomeVideo2.default, null)
	    );
	  };
	
	  return index;
	}(_react.Component);
	
	exports.default = index;
	module.exports = exports['default'];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SpeakerPhoto = __webpack_require__(283);
	
	var _SpeakerPhoto2 = _interopRequireDefault(_SpeakerPhoto);
	
	var _speakers = __webpack_require__(128);
	
	var _speakers2 = _interopRequireDefault(_speakers);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _speakerCarouselModule = __webpack_require__(411);
	
	var _speakerCarouselModule2 = _interopRequireDefault(_speakerCarouselModule);
	
	var _reactDragscroll = __webpack_require__(617);
	
	var _reactDragscroll2 = _interopRequireDefault(_reactDragscroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpeakerCarousel = function (_React$Component) {
	  (0, _inherits3.default)(SpeakerCarousel, _React$Component);
	
	  function SpeakerCarousel() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SpeakerCarousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createPerson = function (person) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_speakerCarouselModule2.default.speakerCard, _speakerCarouselModule2.default.speaker_lineup__padding),
	          key: person.headshot },
	        _react2.default.createElement(_SpeakerPhoto2.default, { firstName: person.firstName, lastName: person.lastName, job: person.job, headshot: person.headshot })
	      );
	    }, _this.createPeople = function (people) {
	      return people.map(_this.createPerson);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  SpeakerCarousel.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactDragscroll2.default,
	        { height: 'unset', width: 'unset', className: (0, _classnames2.default)(_speakerCarouselModule2.default.speaker_lineup__Carousel, 'flex gridish-container--complete') },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('flex') },
	          this.createPeople(_speakers2.default.speakers)
	        )
	      )
	    );
	  };
	
	  return SpeakerCarousel;
	}(_react2.default.Component);
	
	exports.default = SpeakerCarousel;
	module.exports = exports['default'];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(6);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _speakerPhotoModule = __webpack_require__(414);
	
	var _speakerPhotoModule2 = _interopRequireDefault(_speakerPhotoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpeakerPhoto = function statelessFunctionComponentClass(props) {
	  // let imageURL = './assets/speaker-headshots/' + 'arnaud_tanielian.jpg';
	  // let imageURLPrefix = './assets/speaker-headshots/';
	  var imageURLPrefix = 'https://thoughtatwork.cias.rit.edu/assets/graphics/2018-imagery/speaker-headshots/';
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('img', { className: (0, _classnames2.default)(_speakerPhotoModule2.default.headshotContainer),
	      src: imageURLPrefix + props.headshot + '.jpg'
	    }),
	    _react2.default.createElement(
	      'h2',
	      { className: (0, _classnames2.default)(_speakerPhotoModule2.default.speakerCard_text__spacing) },
	      props.firstName + ' ' + props.lastName
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      props.job
	    )
	  );
	};
	
	exports.default = SpeakerPhoto;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.home = undefined;
	
	var _classCallCheck2 = __webpack_require__(2);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(4);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(3);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(265);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var home = exports.home = function (_Component) {
	  (0, _inherits3.default)(home, _Component);
	
	  function home(props) {
	    (0, _classCallCheck3.default)(this, home);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  home.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_index2.default, null)
	    );
	  };
	
	  return home;
	}(_react.Component);
	
	exports.default = home;

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-styles-components-home----homeAbout-module---image---1BIeR"};

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gridish-container":"src-styles-components-home----homeSplash-module---gridish-container---24L9b","gridish-container--left":"src-styles-components-home----homeSplash-module---gridish-container--left---UNCNd","gridish-container--right":"src-styles-components-home----homeSplash-module---gridish-container--right---2lKil","gridish-grid":"src-styles-components-home----homeSplash-module---gridish-grid---1pjq-","gridish-grid__height--xsmall--0":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--0---3I0FL","gridish-grid__height--xsmall--1":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--1---18ojY","gridish-grid__height--xsmall--2":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--2---2Q9y5","gridish-grid__height--xsmall--3":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--3---2Hnmm","gridish-grid__height--xsmall--4":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--4---fTILv","gridish-grid__height--xsmall--5":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--5---3VfVb","gridish-grid__height--xsmall--6":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--6---3bkeA","gridish-grid__height--xsmall--7":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--7---1L5GK","gridish-grid__height--xsmall--8":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--8---1szX0","gridish-grid__height--xsmall--9":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--9---3Tl7t","gridish-grid__height--xsmall--10":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--10---2qXEF","gridish-grid__height--xsmall--11":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--11---2Qa7y","gridish-grid__height--xsmall--12":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--12---30DRp","gridish-grid__height--xsmall--13":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--13---2PaUU","gridish-grid__height--xsmall--14":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--14---2WbA8","gridish-grid__height--xsmall--15":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--15---18zET","gridish-grid__height--xsmall--16":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--16---3J4F8","gridish-grid__height--xsmall--17":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--17---1f6TF","gridish-grid__height--xsmall--18":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--18---3l-Wl","gridish-grid__height--xsmall--19":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--19---s-YGJ","gridish-grid__height--xsmall--20":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--20---38hnW","gridish-grid__height--xsmall--21":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--21---1GGHt","gridish-grid__height--xsmall--22":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--22---3d2aY","gridish-grid__height--xsmall--23":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--23---2Coke","gridish-grid__height--xsmall--24":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--24---qiaHo","gridish-grid__height--xsmall--25":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--25---3JOOd","gridish-grid__height--xsmall--26":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--26---1dUj_","gridish-grid__height--xsmall--27":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--27---IZnqA","gridish-grid__height--xsmall--28":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--28---1bld0","gridish-grid__height--xsmall--29":"src-styles-components-home----homeSplash-module---gridish-grid__height--xsmall--29---2AFPQ","gridish-grid__col--xsmall--0":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--0---1_Pn3","gridish-grid__col--xsmall--0--only":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--0--only---2iGaV","gridish-padding":"src-styles-components-home----homeSplash-module---gridish-padding---3rgWD","gridish-padding--bottom":"src-styles-components-home----homeSplash-module---gridish-padding--bottom---3vwC6","gridish-padding--left":"src-styles-components-home----homeSplash-module---gridish-padding--left---LQPDR","gridish-padding--right":"src-styles-components-home----homeSplash-module---gridish-padding--right---31ONG","gridish-padding--top":"src-styles-components-home----homeSplash-module---gridish-padding--top---3Nc1i","gridish-padding--horizontal":"src-styles-components-home----homeSplash-module---gridish-padding--horizontal---yvNBT","gridish-padding--vertical":"src-styles-components-home----homeSplash-module---gridish-padding--vertical---3Fj97","gridish-grid--fixed-columns":"src-styles-components-home----homeSplash-module---gridish-grid--fixed-columns---1-ip8","gridish-grid--fluid-rows":"src-styles-components-home----homeSplash-module---gridish-grid--fluid-rows---1LHn1","gridish-grid__col--xsmall--1":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--1---3cOMl","gridish-grid__col--xsmall--2":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--2---17SDh","gridish-grid__col--xsmall--3":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--3---1Urjk","gridish-grid__col--xsmall--4":"src-styles-components-home----homeSplash-module---gridish-grid__col--xsmall--4---1oUKZ","gridish-container--complete":"src-styles-components-home----homeSplash-module---gridish-container--complete---3iAqY","gridish-container__bleed--xsmall":"src-styles-components-home----homeSplash-module---gridish-container__bleed--xsmall---1noGt","gridish-container__bleed--xsmall--left":"src-styles-components-home----homeSplash-module---gridish-container__bleed--xsmall--left---2P1Pz","gridish-container__break--xsmall":"src-styles-components-home----homeSplash-module---gridish-container__break--xsmall---1D4oH","gridish-container__break--xsmall--left":"src-styles-components-home----homeSplash-module---gridish-container__break--xsmall--left---37KZJ","gridish-container__bleed--xsmall--right":"src-styles-components-home----homeSplash-module---gridish-container__bleed--xsmall--right---3WOU2","gridish-container__break--xsmall--right":"src-styles-components-home----homeSplash-module---gridish-container__break--xsmall--right---3y3I6","gridish-grid__height--small--0":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--0---2WIY2","gridish-grid__height--small--1":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--1---37RZN","gridish-grid__height--small--2":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--2---3gLoZ","gridish-grid__height--small--3":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--3---3kxme","gridish-grid__height--small--4":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--4---1Zndi","gridish-grid__height--small--5":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--5---2zOxD","gridish-grid__height--small--6":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--6---JX37A","gridish-grid__height--small--7":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--7---tP3s-","gridish-grid__height--small--8":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--8---29nRs","gridish-grid__height--small--9":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--9---2GBxf","gridish-grid__height--small--10":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--10---5sdQY","gridish-grid__height--small--11":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--11---2ee16","gridish-grid__height--small--12":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--12---2Leqv","gridish-grid__height--small--13":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--13---3ygsV","gridish-grid__height--small--14":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--14---3rv_J","gridish-grid__height--small--15":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--15---1MtJj","gridish-grid__height--small--16":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--16---2rZw7","gridish-grid__height--small--17":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--17---3UZJU","gridish-grid__height--small--18":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--18---7WAZt","gridish-grid__height--small--19":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--19---2cApb","gridish-grid__height--small--20":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--20---3mPba","gridish-grid__height--small--21":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--21---vAqzD","gridish-grid__height--small--22":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--22---3lMhn","gridish-grid__height--small--23":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--23---Jcl3y","gridish-grid__height--small--24":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--24---1YUC4","gridish-grid__height--small--25":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--25---26Mu-","gridish-grid__height--small--26":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--26---2ylYY","gridish-grid__height--small--27":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--27---39hA7","gridish-grid__height--small--28":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--28---3vOrh","gridish-grid__height--small--29":"src-styles-components-home----homeSplash-module---gridish-grid__height--small--29---3Ca84","gridish-grid__col--small--0":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--0---2iCjW","gridish-grid__col--small--0--only":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--0--only---1RUDH","gridish-grid__col--small--1":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--1---2tnC_","gridish-grid__col--small--2":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--2---3HqBj","gridish-grid__col--small--3":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--3---1p4Ch","gridish-grid__col--small--4":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--4---3sO19","gridish-grid__col--small--5":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--5---1kFiu","gridish-grid__col--small--6":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--6---2C2cF","gridish-grid__col--small--7":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--7---2DEmC","gridish-grid__col--small--8":"src-styles-components-home----homeSplash-module---gridish-grid__col--small--8---3HfhW","gridish-container__bleed--small":"src-styles-components-home----homeSplash-module---gridish-container__bleed--small---28K8i","gridish-container__bleed--small--left":"src-styles-components-home----homeSplash-module---gridish-container__bleed--small--left---atWs8","gridish-container__break--small":"src-styles-components-home----homeSplash-module---gridish-container__break--small---4bfNj","gridish-container__break--small--left":"src-styles-components-home----homeSplash-module---gridish-container__break--small--left---i-CTt","gridish-container__bleed--small--right":"src-styles-components-home----homeSplash-module---gridish-container__bleed--small--right---iSGJN","gridish-container__break--small--right":"src-styles-components-home----homeSplash-module---gridish-container__break--small--right---3raDG","gridish-grid__col--medium--0":"src-styles-components-home----homeSplash-module---gridish-grid__col--medium--0---3g1QP","gridish-grid__col--medium--0--only":"src-styles-components-home----homeSplash-module---gridish-grid__col--medium--0--only---2CcjG","splashSizing":"src-styles-components-home----homeSplash-module---splashSizing---3XStm","splashSpacing":"src-styles-components-home----homeSplash-module---splashSpacing---FJPbf"};

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"home_video":"src-styles-components-home----homeVideo-module---home_video---l68WC"};

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gridish-container":"src-styles-components-speakers----speakerCarousel-module---gridish-container---tHifd","gridish-container--left":"src-styles-components-speakers----speakerCarousel-module---gridish-container--left---3vmOh","gridish-container--right":"src-styles-components-speakers----speakerCarousel-module---gridish-container--right---34-Rs","gridish-grid":"src-styles-components-speakers----speakerCarousel-module---gridish-grid---2Lvxo","gridish-grid__height--xsmall--0":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--0---D_YXV","gridish-grid__height--xsmall--1":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--1---1IPlj","gridish-grid__height--xsmall--2":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--2---3KG85","gridish-grid__height--xsmall--3":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--3---2Q89q","gridish-grid__height--xsmall--4":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--4---1Q5mA","gridish-grid__height--xsmall--5":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--5---11q4a","gridish-grid__height--xsmall--6":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--6---Vv6rP","gridish-grid__height--xsmall--7":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--7---1vvl6","gridish-grid__height--xsmall--8":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--8---2_92F","gridish-grid__height--xsmall--9":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--9---25RTB","gridish-grid__height--xsmall--10":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--10---1kO1X","gridish-grid__height--xsmall--11":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--11---1SP5r","gridish-grid__height--xsmall--12":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--12---1vdGi","gridish-grid__height--xsmall--13":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--13---3vPg_","gridish-grid__height--xsmall--14":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--14---26Dy3","gridish-grid__height--xsmall--15":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--15---3_-1Z","gridish-grid__height--xsmall--16":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--16---3lGlr","gridish-grid__height--xsmall--17":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--17---2rRrV","gridish-grid__height--xsmall--18":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--18---QIM7r","gridish-grid__height--xsmall--19":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--19---3V0M1","gridish-grid__height--xsmall--20":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--20---369j_","gridish-grid__height--xsmall--21":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--21---33kYg","gridish-grid__height--xsmall--22":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--22---u4IOA","gridish-grid__height--xsmall--23":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--23---1aXmy","gridish-grid__height--xsmall--24":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--24---3Xz32","gridish-grid__height--xsmall--25":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--25---1MYM9","gridish-grid__height--xsmall--26":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--26---DCiWH","gridish-grid__height--xsmall--27":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--27---2QJT3","gridish-grid__height--xsmall--28":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--28---g5zhe","gridish-grid__height--xsmall--29":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--xsmall--29---UOWOM","gridish-grid__col--xsmall--0":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--0---1O2nD","gridish-grid__col--xsmall--0--only":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--0--only---2HNSX","gridish-padding":"src-styles-components-speakers----speakerCarousel-module---gridish-padding---3cyGq","gridish-padding--bottom":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--bottom---YyI1R","gridish-padding--left":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--left---2G81R","gridish-padding--right":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--right---3vYz0","gridish-padding--top":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--top---LhuW4","gridish-padding--horizontal":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--horizontal---3scy5","gridish-padding--vertical":"src-styles-components-speakers----speakerCarousel-module---gridish-padding--vertical---d3b_9","gridish-grid--fixed-columns":"src-styles-components-speakers----speakerCarousel-module---gridish-grid--fixed-columns---131MK","gridish-grid--fluid-rows":"src-styles-components-speakers----speakerCarousel-module---gridish-grid--fluid-rows---3EWC0","gridish-grid__col--xsmall--1":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--1---eajWK","gridish-grid__col--xsmall--2":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--2---3onmc","gridish-grid__col--xsmall--3":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--3---1-wH4","gridish-grid__col--xsmall--4":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--xsmall--4---3k062","gridish-container--complete":"src-styles-components-speakers----speakerCarousel-module---gridish-container--complete---1aAnY","gridish-container__bleed--xsmall":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--xsmall---2CIJE","gridish-container__bleed--xsmall--left":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--xsmall--left---Q90XB","gridish-container__break--xsmall":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--xsmall---10j3x","gridish-container__break--xsmall--left":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--xsmall--left---2ep62","gridish-container__bleed--xsmall--right":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--xsmall--right---35E1g","gridish-container__break--xsmall--right":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--xsmall--right---lYlXo","gridish-grid__height--small--0":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--0---1j7H5","gridish-grid__height--small--1":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--1---1jxvv","gridish-grid__height--small--2":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--2---51LwZ","gridish-grid__height--small--3":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--3---3usRd","gridish-grid__height--small--4":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--4---3sB_n","gridish-grid__height--small--5":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--5---c57J1","gridish-grid__height--small--6":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--6---1n89v","gridish-grid__height--small--7":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--7---2-dhn","gridish-grid__height--small--8":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--8---1LEUo","gridish-grid__height--small--9":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--9---6FtY1","gridish-grid__height--small--10":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--10---3lkSn","gridish-grid__height--small--11":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--11---1N5aM","gridish-grid__height--small--12":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--12---2RvMh","gridish-grid__height--small--13":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--13---2Wyhs","gridish-grid__height--small--14":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--14---3BRy2","gridish-grid__height--small--15":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--15---3Lo8j","gridish-grid__height--small--16":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--16---GXp4e","gridish-grid__height--small--17":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--17---3pzx_","gridish-grid__height--small--18":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--18---34W8f","gridish-grid__height--small--19":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--19---1m0tY","gridish-grid__height--small--20":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--20---2vkd7","gridish-grid__height--small--21":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--21---3g9k2","gridish-grid__height--small--22":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--22---PTBAq","gridish-grid__height--small--23":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--23---14-HF","gridish-grid__height--small--24":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--24---1AHBZ","gridish-grid__height--small--25":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--25---2DN8W","gridish-grid__height--small--26":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--26---3llQW","gridish-grid__height--small--27":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--27---2IZrb","gridish-grid__height--small--28":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--28---1oaoU","gridish-grid__height--small--29":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__height--small--29---3WRCi","gridish-grid__col--small--0":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--0---uSDBh","gridish-grid__col--small--0--only":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--0--only---3xq-y","gridish-grid__col--small--1":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--1---1wVhz","gridish-grid__col--small--2":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--2---17PSN","gridish-grid__col--small--3":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--3---2eXGO","gridish-grid__col--small--4":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--4---N2Fzu","gridish-grid__col--small--5":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--5---StHC_","gridish-grid__col--small--6":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--6---2hWdb","gridish-grid__col--small--7":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--7---1lXaR","gridish-grid__col--small--8":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--small--8---aBZSA","gridish-container__bleed--small":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--small---2GmRB","gridish-container__bleed--small--left":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--small--left---13nUJ","gridish-container__break--small":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--small---2XWnb","gridish-container__break--small--left":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--small--left---26JEH","gridish-container__bleed--small--right":"src-styles-components-speakers----speakerCarousel-module---gridish-container__bleed--small--right---1gK5K","gridish-container__break--small--right":"src-styles-components-speakers----speakerCarousel-module---gridish-container__break--small--right---1_oq2","gridish-grid__col--medium--0":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--medium--0---1GLm_","gridish-grid__col--medium--0--only":"src-styles-components-speakers----speakerCarousel-module---gridish-grid__col--medium--0--only---2QVoB","speaker_lineup__Carousel":"src-styles-components-speakers----speakerCarousel-module---speaker_lineup__Carousel---2NnBt","button_Spacing":"src-styles-components-speakers----speakerCarousel-module---button_Spacing---2RmlB","speakerCard":"src-styles-components-speakers----speakerCarousel-module---speakerCard---36nGn","speaker_lineup__padding":"src-styles-components-speakers----speakerCarousel-module---speaker_lineup__padding---wruuF"};

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"gridish-container":"src-styles-components-speakers----speakerPhoto-module---gridish-container---2dFsT","gridish-container--left":"src-styles-components-speakers----speakerPhoto-module---gridish-container--left---39cY2","gridish-container--right":"src-styles-components-speakers----speakerPhoto-module---gridish-container--right---1z9IA","gridish-grid":"src-styles-components-speakers----speakerPhoto-module---gridish-grid---3SLDy","gridish-grid__height--xsmall--0":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--0---1zH8G","gridish-grid__height--xsmall--1":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--1---3hSfc","gridish-grid__height--xsmall--2":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--2---2aV0c","gridish-grid__height--xsmall--3":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--3---3wZ2o","gridish-grid__height--xsmall--4":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--4---2Bqxq","gridish-grid__height--xsmall--5":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--5---3pPr1","gridish-grid__height--xsmall--6":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--6---1LqqQ","gridish-grid__height--xsmall--7":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--7---ewXCR","gridish-grid__height--xsmall--8":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--8---T94rS","gridish-grid__height--xsmall--9":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--9---3fb00","gridish-grid__height--xsmall--10":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--10---1wqY5","gridish-grid__height--xsmall--11":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--11---25_oh","gridish-grid__height--xsmall--12":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--12---3kZRo","gridish-grid__height--xsmall--13":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--13---2vJEA","gridish-grid__height--xsmall--14":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--14---31BK3","gridish-grid__height--xsmall--15":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--15---xvyvc","gridish-grid__height--xsmall--16":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--16---MbBPN","gridish-grid__height--xsmall--17":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--17---25VWW","gridish-grid__height--xsmall--18":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--18---1aX1Z","gridish-grid__height--xsmall--19":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--19---33KMh","gridish-grid__height--xsmall--20":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--20---3_6Jo","gridish-grid__height--xsmall--21":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--21---fCaYA","gridish-grid__height--xsmall--22":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--22---2QNgV","gridish-grid__height--xsmall--23":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--23---2LDeS","gridish-grid__height--xsmall--24":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--24---y7A9Z","gridish-grid__height--xsmall--25":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--25---3K3Sk","gridish-grid__height--xsmall--26":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--26---Hn6jF","gridish-grid__height--xsmall--27":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--27---37LtH","gridish-grid__height--xsmall--28":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--28---1dpEd","gridish-grid__height--xsmall--29":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--xsmall--29---vKpiv","gridish-grid__col--xsmall--0":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--0---22rJP","gridish-grid__col--xsmall--0--only":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--0--only---3K9SS","gridish-padding":"src-styles-components-speakers----speakerPhoto-module---gridish-padding---2Zzc-","gridish-padding--bottom":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--bottom---2_Xj0","gridish-padding--left":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--left---2PrnT","gridish-padding--right":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--right---3cNlp","gridish-padding--top":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--top---2f09c","gridish-padding--horizontal":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--horizontal---2o35Y","gridish-padding--vertical":"src-styles-components-speakers----speakerPhoto-module---gridish-padding--vertical---10XJZ","gridish-grid--fixed-columns":"src-styles-components-speakers----speakerPhoto-module---gridish-grid--fixed-columns---2lXRO","gridish-grid--fluid-rows":"src-styles-components-speakers----speakerPhoto-module---gridish-grid--fluid-rows---3s_ZQ","gridish-grid__col--xsmall--1":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--1----BWa9","gridish-grid__col--xsmall--2":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--2---3uu8k","gridish-grid__col--xsmall--3":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--3---3isTT","gridish-grid__col--xsmall--4":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--xsmall--4---3iBRx","gridish-container--complete":"src-styles-components-speakers----speakerPhoto-module---gridish-container--complete---3M2Jm","gridish-container__bleed--xsmall":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--xsmall---19fj1","gridish-container__bleed--xsmall--left":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--xsmall--left---1DPFL","gridish-container__break--xsmall":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--xsmall---1ySE1","gridish-container__break--xsmall--left":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--xsmall--left---srI5b","gridish-container__bleed--xsmall--right":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--xsmall--right---11Vc0","gridish-container__break--xsmall--right":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--xsmall--right---u6mHg","gridish-grid__height--small--0":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--0---1LRmG","gridish-grid__height--small--1":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--1---2hFUu","gridish-grid__height--small--2":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--2---1pBu8","gridish-grid__height--small--3":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--3---1dBoU","gridish-grid__height--small--4":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--4---2SYdX","gridish-grid__height--small--5":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--5---16cFr","gridish-grid__height--small--6":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--6---2Ule1","gridish-grid__height--small--7":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--7---N-OKO","gridish-grid__height--small--8":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--8---3Hmme","gridish-grid__height--small--9":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--9---3O8aO","gridish-grid__height--small--10":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--10---3_gAD","gridish-grid__height--small--11":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--11---10BIs","gridish-grid__height--small--12":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--12---hp41p","gridish-grid__height--small--13":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--13---3HOJ0","gridish-grid__height--small--14":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--14---1A-T8","gridish-grid__height--small--15":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--15---2GVRP","gridish-grid__height--small--16":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--16---2VZKz","gridish-grid__height--small--17":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--17---38yDU","gridish-grid__height--small--18":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--18---1B4Ld","gridish-grid__height--small--19":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--19---3CHxJ","gridish-grid__height--small--20":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--20---2DmZk","gridish-grid__height--small--21":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--21---10LdO","gridish-grid__height--small--22":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--22---37FW-","gridish-grid__height--small--23":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--23---2kOLZ","gridish-grid__height--small--24":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--24---vWTOJ","gridish-grid__height--small--25":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--25---35jOn","gridish-grid__height--small--26":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--26---14_BU","gridish-grid__height--small--27":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--27---3ZQF3","gridish-grid__height--small--28":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--28---2i4TD","gridish-grid__height--small--29":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__height--small--29---sbSzg","gridish-grid__col--small--0":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--0---2bOwU","gridish-grid__col--small--0--only":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--0--only---27Mej","gridish-grid__col--small--1":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--1---GXsb7","gridish-grid__col--small--2":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--2---AQrI2","gridish-grid__col--small--3":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--3---2oy4k","gridish-grid__col--small--4":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--4---3NcYS","gridish-grid__col--small--5":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--5---8JOHL","gridish-grid__col--small--6":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--6---2Rnzu","gridish-grid__col--small--7":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--7---3-p-3","gridish-grid__col--small--8":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--small--8---3zLXv","gridish-container__bleed--small":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--small---2Akyh","gridish-container__bleed--small--left":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--small--left---ZKL4q","gridish-container__break--small":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--small---DUBct","gridish-container__break--small--left":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--small--left---1ouIB","gridish-container__bleed--small--right":"src-styles-components-speakers----speakerPhoto-module---gridish-container__bleed--small--right---3Tu9N","gridish-container__break--small--right":"src-styles-components-speakers----speakerPhoto-module---gridish-container__break--small--right---182qF","gridish-grid__col--medium--0":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--medium--0---1CAmx","gridish-grid__col--medium--0--only":"src-styles-components-speakers----speakerPhoto-module---gridish-grid__col--medium--0--only---17P6i","headshotContainer":"src-styles-components-speakers----speakerPhoto-module---headshotContainer---zGLfW","speakerCard_text__spacing":"src-styles-components-speakers----speakerPhoto-module---speakerCard_text__spacing---3WvPH"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-home-js-08338528a6bace43dc02.js